import { jsx as P, jsxs as se, Fragment as sa } from "react/jsx-runtime";
import * as H from "react";
import q, { useCallback as le, createContext as rt, useMemo as Fe, createElement as E, useContext as Vt, useLayoutEffect as jn, useRef as j, useEffect as G, useState as Y, forwardRef as z, Children as ge, isValidElement as De, cloneElement as Ut, Fragment as wn, useReducer as Il } from "react";
import * as la from "react-dom";
import ua, { flushSync as Xr, createPortal as da } from "react-dom";
function fa(e) {
  var t, n, o = "";
  if (typeof e == "string" || typeof e == "number")
    o += e;
  else if (typeof e == "object")
    if (Array.isArray(e))
      for (t = 0; t < e.length; t++)
        e[t] && (n = fa(e[t])) && (o && (o += " "), o += n);
    else
      for (t in e)
        e[t] && (o && (o += " "), o += t);
  return o;
}
function oe() {
  for (var e, t, n = 0, o = ""; n < arguments.length; )
    (e = arguments[n++]) && (t = fa(e)) && (o && (o += " "), o += t);
  return o;
}
function dg({
  buttonType: e = "primary",
  children: t,
  disabled: n = !1,
  onClick: o,
  size: r = "md",
  ...i
}) {
  const c = oe({
    btn: !0,
    primary: e === "primary",
    secondary: e === "secondary",
    text: e === "text",
    destructive: e === "destructive",
    icon: e === "icon",
    sm: r === "sm",
    md: r === "md"
  });
  return /* @__PURE__ */ P(
    "button",
    {
      className: c,
      disabled: n,
      onClick: o,
      ...i,
      children: t
    }
  );
}
function F() {
  return F = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var o in n)
        Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
    }
    return e;
  }, F.apply(this, arguments);
}
function $e(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(r) {
    if (e == null || e(r), n === !1 || !r.defaultPrevented)
      return t == null ? void 0 : t(r);
  };
}
function Ll(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function va(...e) {
  return (t) => e.forEach(
    (n) => Ll(n, t)
  );
}
function we(...e) {
  return le(va(...e), e);
}
function zt(e, t = []) {
  let n = [];
  function o(i, c) {
    const a = /* @__PURE__ */ rt(c), s = n.length;
    n = [
      ...n,
      c
    ];
    function l(d) {
      const { scope: h, children: v, ...p } = d, f = (h == null ? void 0 : h[e][s]) || a, g = Fe(
        () => p,
        Object.values(p)
      );
      return /* @__PURE__ */ E(f.Provider, {
        value: g
      }, v);
    }
    function u(d, h) {
      const v = (h == null ? void 0 : h[e][s]) || a, p = Vt(v);
      if (p)
        return p;
      if (c !== void 0)
        return c;
      throw new Error(`\`${d}\` must be used within \`${i}\``);
    }
    return l.displayName = i + "Provider", [
      l,
      u
    ];
  }
  const r = () => {
    const i = n.map((c) => /* @__PURE__ */ rt(c));
    return function(a) {
      const s = (a == null ? void 0 : a[e]) || i;
      return Fe(
        () => ({
          [`__scope${e}`]: {
            ...a,
            [e]: s
          }
        }),
        [
          a,
          s
        ]
      );
    };
  };
  return r.scopeName = e, [
    o,
    Ml(r, ...t)
  ];
}
function Ml(...e) {
  const t = e[0];
  if (e.length === 1)
    return t;
  const n = () => {
    const o = e.map(
      (r) => ({
        useScope: r(),
        scopeName: r.scopeName
      })
    );
    return function(i) {
      const c = o.reduce((a, { useScope: s, scopeName: l }) => {
        const d = s(i)[`__scope${l}`];
        return {
          ...a,
          ...d
        };
      }, {});
      return Fe(
        () => ({
          [`__scope${t.scopeName}`]: c
        }),
        [
          c
        ]
      );
    };
  };
  return n.scopeName = t.scopeName, n;
}
const Ze = globalThis != null && globalThis.document ? jn : () => {
}, kl = H["useId".toString()] || (() => {
});
let Fl = 0;
function un(e) {
  const [t, n] = H.useState(kl());
  return Ze(() => {
    e || n(
      (o) => o ?? String(Fl++)
    );
  }, [
    e
  ]), e || (t ? `radix-${t}` : "");
}
function wt(e) {
  const t = j(e);
  return G(() => {
    t.current = e;
  }), Fe(
    () => (...n) => {
      var o;
      return (o = t.current) === null || o === void 0 ? void 0 : o.call(t, ...n);
    },
    []
  );
}
function Cn({ prop: e, defaultProp: t, onChange: n = () => {
} }) {
  const [o, r] = Hl({
    defaultProp: t,
    onChange: n
  }), i = e !== void 0, c = i ? e : o, a = wt(n), s = le((l) => {
    if (i) {
      const d = typeof l == "function" ? l(e) : l;
      d !== e && a(d);
    } else
      r(l);
  }, [
    i,
    e,
    r,
    a
  ]);
  return [
    c,
    s
  ];
}
function Hl({ defaultProp: e, onChange: t }) {
  const n = Y(e), [o] = n, r = j(o), i = wt(t);
  return G(() => {
    r.current !== o && (i(o), r.current = o);
  }, [
    o,
    r,
    i
  ]), n;
}
const pn = /* @__PURE__ */ z((e, t) => {
  const { children: n, ...o } = e, r = ge.toArray(n), i = r.find(Wl);
  if (i) {
    const c = i.props.children, a = r.map((s) => s === i ? ge.count(c) > 1 ? ge.only(null) : /* @__PURE__ */ De(c) ? c.props.children : null : s);
    return /* @__PURE__ */ E(_r, F({}, o, {
      ref: t
    }), /* @__PURE__ */ De(c) ? /* @__PURE__ */ Ut(c, void 0, a) : null);
  }
  return /* @__PURE__ */ E(_r, F({}, o, {
    ref: t
  }), n);
});
pn.displayName = "Slot";
const _r = /* @__PURE__ */ z((e, t) => {
  const { children: n, ...o } = e;
  return /* @__PURE__ */ De(n) ? /* @__PURE__ */ Ut(n, {
    ...Vl(o, n.props),
    ref: va(t, n.ref)
  }) : ge.count(n) > 1 ? ge.only(null) : null;
});
_r.displayName = "SlotClone";
const Bl = ({ children: e }) => /* @__PURE__ */ E(wn, null, e);
function Wl(e) {
  return /* @__PURE__ */ De(e) && e.type === Bl;
}
function Vl(e, t) {
  const n = {
    ...t
  };
  for (const o in t) {
    const r = e[o], i = t[o];
    /^on[A-Z]/.test(o) ? r && i ? n[o] = (...a) => {
      i(...a), r(...a);
    } : r && (n[o] = r) : o === "style" ? n[o] = {
      ...r,
      ...i
    } : o === "className" && (n[o] = [
      r,
      i
    ].filter(Boolean).join(" "));
  }
  return {
    ...e,
    ...n
  };
}
const Ul = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], ve = Ul.reduce((e, t) => {
  const n = /* @__PURE__ */ z((o, r) => {
    const { asChild: i, ...c } = o, a = i ? pn : t;
    return G(() => {
      window[Symbol.for("radix-ui")] = !0;
    }, []), /* @__PURE__ */ E(a, F({}, c, {
      ref: r
    }));
  });
  return n.displayName = `Primitive.${t}`, {
    ...e,
    [t]: n
  };
}, {});
function zl(e, t) {
  e && Xr(
    () => e.dispatchEvent(t)
  );
}
function ql(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = wt(e);
  G(() => {
    const o = (r) => {
      r.key === "Escape" && n(r);
    };
    return t.addEventListener("keydown", o), () => t.removeEventListener("keydown", o);
  }, [
    n,
    t
  ]);
}
const Sr = "dismissableLayer.update", Kl = "dismissableLayer.pointerDownOutside", Yl = "dismissableLayer.focusOutside";
let Qi;
const jl = /* @__PURE__ */ rt({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), pa = /* @__PURE__ */ z((e, t) => {
  var n;
  const { disableOutsidePointerEvents: o = !1, onEscapeKeyDown: r, onPointerDownOutside: i, onFocusOutside: c, onInteractOutside: a, onDismiss: s, ...l } = e, u = Vt(jl), [d, h] = Y(null), v = (n = d == null ? void 0 : d.ownerDocument) !== null && n !== void 0 ? n : globalThis == null ? void 0 : globalThis.document, [, p] = Y({}), f = we(
    t,
    (C) => h(C)
  ), g = Array.from(u.layers), [m] = [
    ...u.layersWithOutsidePointerEventsDisabled
  ].slice(-1), $ = g.indexOf(m), b = d ? g.indexOf(d) : -1, y = u.layersWithOutsidePointerEventsDisabled.size > 0, w = b >= $, _ = Gl((C) => {
    const T = C.target, D = [
      ...u.branches
    ].some(
      (S) => S.contains(T)
    );
    !w || D || (i == null || i(C), a == null || a(C), C.defaultPrevented || s == null || s());
  }, v), x = Xl((C) => {
    const T = C.target;
    [
      ...u.branches
    ].some(
      (S) => S.contains(T)
    ) || (c == null || c(C), a == null || a(C), C.defaultPrevented || s == null || s());
  }, v);
  return ql((C) => {
    b === u.layers.size - 1 && (r == null || r(C), !C.defaultPrevented && s && (C.preventDefault(), s()));
  }, v), G(() => {
    if (d)
      return o && (u.layersWithOutsidePointerEventsDisabled.size === 0 && (Qi = v.body.style.pointerEvents, v.body.style.pointerEvents = "none"), u.layersWithOutsidePointerEventsDisabled.add(d)), u.layers.add(d), ec(), () => {
        o && u.layersWithOutsidePointerEventsDisabled.size === 1 && (v.body.style.pointerEvents = Qi);
      };
  }, [
    d,
    v,
    o,
    u
  ]), G(() => () => {
    d && (u.layers.delete(d), u.layersWithOutsidePointerEventsDisabled.delete(d), ec());
  }, [
    d,
    u
  ]), G(() => {
    const C = () => p({});
    return document.addEventListener(Sr, C), () => document.removeEventListener(Sr, C);
  }, []), /* @__PURE__ */ E(ve.div, F({}, l, {
    ref: f,
    style: {
      pointerEvents: y ? w ? "auto" : "none" : void 0,
      ...e.style
    },
    onFocusCapture: $e(e.onFocusCapture, x.onFocusCapture),
    onBlurCapture: $e(e.onBlurCapture, x.onBlurCapture),
    onPointerDownCapture: $e(e.onPointerDownCapture, _.onPointerDownCapture)
  }));
});
function Gl(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = wt(e), o = j(!1), r = j(() => {
  });
  return G(() => {
    const i = (a) => {
      if (a.target && !o.current) {
        let l = function() {
          ha(Kl, n, s, {
            discrete: !0
          });
        };
        const s = {
          originalEvent: a
        };
        a.pointerType === "touch" ? (t.removeEventListener("click", r.current), r.current = l, t.addEventListener("click", r.current, {
          once: !0
        })) : l();
      }
      o.current = !1;
    }, c = window.setTimeout(() => {
      t.addEventListener("pointerdown", i);
    }, 0);
    return () => {
      window.clearTimeout(c), t.removeEventListener("pointerdown", i), t.removeEventListener("click", r.current);
    };
  }, [
    t,
    n
  ]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => o.current = !0
  };
}
function Xl(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = wt(e), o = j(!1);
  return G(() => {
    const r = (i) => {
      i.target && !o.current && ha(Yl, n, {
        originalEvent: i
      }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", r), () => t.removeEventListener("focusin", r);
  }, [
    t,
    n
  ]), {
    onFocusCapture: () => o.current = !0,
    onBlurCapture: () => o.current = !1
  };
}
function ec() {
  const e = new CustomEvent(Sr);
  document.dispatchEvent(e);
}
function ha(e, t, n, { discrete: o }) {
  const r = n.originalEvent.target, i = new CustomEvent(e, {
    bubbles: !1,
    cancelable: !0,
    detail: n
  });
  t && r.addEventListener(e, t, {
    once: !0
  }), o ? zl(r, i) : r.dispatchEvent(i);
}
const lr = "focusScope.autoFocusOnMount", ur = "focusScope.autoFocusOnUnmount", tc = {
  bubbles: !1,
  cancelable: !0
}, ma = /* @__PURE__ */ z((e, t) => {
  const { loop: n = !1, trapped: o = !1, onMountAutoFocus: r, onUnmountAutoFocus: i, ...c } = e, [a, s] = Y(null), l = wt(r), u = wt(i), d = j(null), h = we(
    t,
    (f) => s(f)
  ), v = j({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  G(() => {
    if (o) {
      let f = function(m) {
        if (v.paused || !a)
          return;
        const $ = m.target;
        a.contains($) ? d.current = $ : It(d.current, {
          select: !0
        });
      }, g = function(m) {
        v.paused || !a || a.contains(m.relatedTarget) || It(d.current, {
          select: !0
        });
      };
      return document.addEventListener("focusin", f), document.addEventListener("focusout", g), () => {
        document.removeEventListener("focusin", f), document.removeEventListener("focusout", g);
      };
    }
  }, [
    o,
    a,
    v.paused
  ]), G(() => {
    if (a) {
      oc.add(v);
      const f = document.activeElement;
      if (!a.contains(f)) {
        const m = new CustomEvent(lr, tc);
        a.addEventListener(lr, l), a.dispatchEvent(m), m.defaultPrevented || (Zl(nu(ga(a)), {
          select: !0
        }), document.activeElement === f && It(a));
      }
      return () => {
        a.removeEventListener(lr, l), setTimeout(() => {
          const m = new CustomEvent(ur, tc);
          a.addEventListener(ur, u), a.dispatchEvent(m), m.defaultPrevented || It(f ?? document.body, {
            select: !0
          }), a.removeEventListener(ur, u), oc.remove(v);
        }, 0);
      };
    }
  }, [
    a,
    l,
    u,
    v
  ]);
  const p = le((f) => {
    if (!n && !o || v.paused)
      return;
    const g = f.key === "Tab" && !f.altKey && !f.ctrlKey && !f.metaKey, m = document.activeElement;
    if (g && m) {
      const $ = f.currentTarget, [b, y] = Jl($);
      b && y ? !f.shiftKey && m === y ? (f.preventDefault(), n && It(b, {
        select: !0
      })) : f.shiftKey && m === b && (f.preventDefault(), n && It(y, {
        select: !0
      })) : m === $ && f.preventDefault();
    }
  }, [
    n,
    o,
    v.paused
  ]);
  return /* @__PURE__ */ E(ve.div, F({
    tabIndex: -1
  }, c, {
    ref: h,
    onKeyDown: p
  }));
});
function Zl(e, { select: t = !1 } = {}) {
  const n = document.activeElement;
  for (const o of e)
    if (It(o, {
      select: t
    }), document.activeElement !== n)
      return;
}
function Jl(e) {
  const t = ga(e), n = nc(t, e), o = nc(t.reverse(), e);
  return [
    n,
    o
  ];
}
function ga(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (o) => {
      const r = o.tagName === "INPUT" && o.type === "hidden";
      return o.disabled || o.hidden || r ? NodeFilter.FILTER_SKIP : o.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); )
    t.push(n.currentNode);
  return t;
}
function nc(e, t) {
  for (const n of e)
    if (!Ql(n, {
      upTo: t
    }))
      return n;
}
function Ql(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden")
    return !0;
  for (; e; ) {
    if (t !== void 0 && e === t)
      return !1;
    if (getComputedStyle(e).display === "none")
      return !0;
    e = e.parentElement;
  }
  return !1;
}
function eu(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function It(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const n = document.activeElement;
    e.focus({
      preventScroll: !0
    }), e !== n && eu(e) && t && e.select();
  }
}
const oc = tu();
function tu() {
  let e = [];
  return {
    add(t) {
      const n = e[0];
      t !== n && (n == null || n.pause()), e = rc(e, t), e.unshift(t);
    },
    remove(t) {
      var n;
      e = rc(e, t), (n = e[0]) === null || n === void 0 || n.resume();
    }
  };
}
function rc(e, t) {
  const n = [
    ...e
  ], o = n.indexOf(t);
  return o !== -1 && n.splice(o, 1), n;
}
function nu(e) {
  return e.filter(
    (t) => t.tagName !== "A"
  );
}
const $a = /* @__PURE__ */ z((e, t) => {
  var n;
  const { container: o = globalThis == null || (n = globalThis.document) === null || n === void 0 ? void 0 : n.body, ...r } = e;
  return o ? /* @__PURE__ */ ua.createPortal(/* @__PURE__ */ E(ve.div, F({}, r, {
    ref: t
  })), o) : null;
});
function ou(e, t) {
  return Il((n, o) => {
    const r = t[n][o];
    return r ?? n;
  }, e);
}
const Pt = (e) => {
  const { present: t, children: n } = e, o = ru(t), r = typeof n == "function" ? n({
    present: o.isPresent
  }) : ge.only(n), i = we(o.ref, r.ref);
  return typeof n == "function" || o.isPresent ? /* @__PURE__ */ Ut(r, {
    ref: i
  }) : null;
};
Pt.displayName = "Presence";
function ru(e) {
  const [t, n] = Y(), o = j({}), r = j(e), i = j("none"), c = e ? "mounted" : "unmounted", [a, s] = ou(c, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return G(() => {
    const l = co(o.current);
    i.current = a === "mounted" ? l : "none";
  }, [
    a
  ]), Ze(() => {
    const l = o.current, u = r.current;
    if (u !== e) {
      const h = i.current, v = co(l);
      e ? s("MOUNT") : v === "none" || (l == null ? void 0 : l.display) === "none" ? s("UNMOUNT") : s(u && h !== v ? "ANIMATION_OUT" : "UNMOUNT"), r.current = e;
    }
  }, [
    e,
    s
  ]), Ze(() => {
    if (t) {
      const l = (d) => {
        const v = co(o.current).includes(d.animationName);
        d.target === t && v && Xr(
          () => s("ANIMATION_END")
        );
      }, u = (d) => {
        d.target === t && (i.current = co(o.current));
      };
      return t.addEventListener("animationstart", u), t.addEventListener("animationcancel", l), t.addEventListener("animationend", l), () => {
        t.removeEventListener("animationstart", u), t.removeEventListener("animationcancel", l), t.removeEventListener("animationend", l);
      };
    } else
      s("ANIMATION_END");
  }, [
    t,
    s
  ]), {
    isPresent: [
      "mounted",
      "unmountSuspended"
    ].includes(a),
    ref: le((l) => {
      l && (o.current = getComputedStyle(l)), n(l);
    }, [])
  };
}
function co(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
let dr = 0;
function ba() {
  G(() => {
    var e, t;
    const n = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", (e = n[0]) !== null && e !== void 0 ? e : ic()), document.body.insertAdjacentElement("beforeend", (t = n[1]) !== null && t !== void 0 ? t : ic()), dr++, () => {
      dr === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach(
        (o) => o.remove()
      ), dr--;
    };
  }, []);
}
function ic() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.cssText = "outline: none; opacity: 0; position: fixed; pointer-events: none", e;
}
var Ve = function() {
  return Ve = Object.assign || function(t) {
    for (var n, o = 1, r = arguments.length; o < r; o++) {
      n = arguments[o];
      for (var i in n)
        Object.prototype.hasOwnProperty.call(n, i) && (t[i] = n[i]);
    }
    return t;
  }, Ve.apply(this, arguments);
};
function ya(e, t) {
  var n = {};
  for (var o in e)
    Object.prototype.hasOwnProperty.call(e, o) && t.indexOf(o) < 0 && (n[o] = e[o]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var r = 0, o = Object.getOwnPropertySymbols(e); r < o.length; r++)
      t.indexOf(o[r]) < 0 && Object.prototype.propertyIsEnumerable.call(e, o[r]) && (n[o[r]] = e[o[r]]);
  return n;
}
function iu(e, t, n) {
  if (n || arguments.length === 2)
    for (var o = 0, r = t.length, i; o < r; o++)
      (i || !(o in t)) && (i || (i = Array.prototype.slice.call(t, 0, o)), i[o] = t[o]);
  return e.concat(i || Array.prototype.slice.call(t));
}
var mo = "right-scroll-bar-position", go = "width-before-scroll-bar", cu = "with-scroll-bars-hidden", au = "--removed-body-scroll-bar-size";
function su(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function lu(e, t) {
  var n = Y(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return n.value;
        },
        set current(o) {
          var r = n.value;
          r !== o && (n.value = o, n.callback(o, r));
        }
      }
    };
  })[0];
  return n.callback = t, n.facade;
}
function uu(e, t) {
  return lu(t || null, function(n) {
    return e.forEach(function(o) {
      return su(o, n);
    });
  });
}
function du(e) {
  return e;
}
function fu(e, t) {
  t === void 0 && (t = du);
  var n = [], o = !1, r = {
    read: function() {
      if (o)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return n.length ? n[n.length - 1] : e;
    },
    useMedium: function(i) {
      var c = t(i, o);
      return n.push(c), function() {
        n = n.filter(function(a) {
          return a !== c;
        });
      };
    },
    assignSyncMedium: function(i) {
      for (o = !0; n.length; ) {
        var c = n;
        n = [], c.forEach(i);
      }
      n = {
        push: function(a) {
          return i(a);
        },
        filter: function() {
          return n;
        }
      };
    },
    assignMedium: function(i) {
      o = !0;
      var c = [];
      if (n.length) {
        var a = n;
        n = [], a.forEach(i), c = n;
      }
      var s = function() {
        var u = c;
        c = [], u.forEach(i);
      }, l = function() {
        return Promise.resolve().then(s);
      };
      l(), n = {
        push: function(u) {
          c.push(u), l();
        },
        filter: function(u) {
          return c = c.filter(u), n;
        }
      };
    }
  };
  return r;
}
function vu(e) {
  e === void 0 && (e = {});
  var t = fu(null);
  return t.options = Ve({ async: !0, ssr: !1 }, e), t;
}
var wa = function(e) {
  var t = e.sideCar, n = ya(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var o = t.read();
  if (!o)
    throw new Error("Sidecar medium not found");
  return H.createElement(o, Ve({}, n));
};
wa.isSideCarExport = !0;
function pu(e, t) {
  return e.useMedium(t), wa;
}
var Ca = vu(), fr = function() {
}, Ho = H.forwardRef(function(e, t) {
  var n = H.useRef(null), o = H.useState({
    onScrollCapture: fr,
    onWheelCapture: fr,
    onTouchMoveCapture: fr
  }), r = o[0], i = o[1], c = e.forwardProps, a = e.children, s = e.className, l = e.removeScrollBar, u = e.enabled, d = e.shards, h = e.sideCar, v = e.noIsolation, p = e.inert, f = e.allowPinchZoom, g = e.as, m = g === void 0 ? "div" : g, $ = ya(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as"]), b = h, y = uu([n, t]), w = Ve(Ve({}, $), r);
  return H.createElement(
    H.Fragment,
    null,
    u && H.createElement(b, { sideCar: Ca, removeScrollBar: l, shards: d, noIsolation: v, inert: p, setCallbacks: i, allowPinchZoom: !!f, lockRef: n }),
    c ? H.cloneElement(H.Children.only(a), Ve(Ve({}, w), { ref: y })) : H.createElement(m, Ve({}, w, { className: s, ref: y }), a)
  );
});
Ho.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
Ho.classNames = {
  fullWidth: go,
  zeroRight: mo
};
var cc, hu = function() {
  if (cc)
    return cc;
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function mu() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = hu();
  return t && e.setAttribute("nonce", t), e;
}
function gu(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function $u(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var bu = function() {
  var e = 0, t = null;
  return {
    add: function(n) {
      e == 0 && (t = mu()) && (gu(t, n), $u(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, yu = function() {
  var e = bu();
  return function(t, n) {
    H.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && n]);
  };
}, xa = function() {
  var e = yu(), t = function(n) {
    var o = n.styles, r = n.dynamic;
    return e(o, r), null;
  };
  return t;
}, wu = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, vr = function(e) {
  return parseInt(e || "", 10) || 0;
}, Cu = function(e) {
  var t = window.getComputedStyle(document.body), n = t[e === "padding" ? "paddingLeft" : "marginLeft"], o = t[e === "padding" ? "paddingTop" : "marginTop"], r = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [vr(n), vr(o), vr(r)];
}, xu = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return wu;
  var t = Cu(e), n = document.documentElement.clientWidth, o = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, o - n + t[2] - t[0])
  };
}, Eu = xa(), _u = function(e, t, n, o) {
  var r = e.left, i = e.top, c = e.right, a = e.gap;
  return n === void 0 && (n = "margin"), `
  .`.concat(cu, ` {
   overflow: hidden `).concat(o, `;
   padding-right: `).concat(a, "px ").concat(o, `;
  }
  body {
    overflow: hidden `).concat(o, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(o, ";"),
    n === "margin" && `
    padding-left: `.concat(r, `px;
    padding-top: `).concat(i, `px;
    padding-right: `).concat(c, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(a, "px ").concat(o, `;
    `),
    n === "padding" && "padding-right: ".concat(a, "px ").concat(o, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(mo, ` {
    right: `).concat(a, "px ").concat(o, `;
  }
  
  .`).concat(go, ` {
    margin-right: `).concat(a, "px ").concat(o, `;
  }
  
  .`).concat(mo, " .").concat(mo, ` {
    right: 0 `).concat(o, `;
  }
  
  .`).concat(go, " .").concat(go, ` {
    margin-right: 0 `).concat(o, `;
  }
  
  body {
    `).concat(au, ": ").concat(a, `px;
  }
`);
}, Su = function(e) {
  var t = e.noRelative, n = e.noImportant, o = e.gapMode, r = o === void 0 ? "margin" : o, i = H.useMemo(function() {
    return xu(r);
  }, [r]);
  return H.createElement(Eu, { styles: _u(i, !t, r, n ? "" : "!important") });
}, Ar = !1;
if (typeof window < "u")
  try {
    var ao = Object.defineProperty({}, "passive", {
      get: function() {
        return Ar = !0, !0;
      }
    });
    window.addEventListener("test", ao, ao), window.removeEventListener("test", ao, ao);
  } catch {
    Ar = !1;
  }
var Zt = Ar ? { passive: !1 } : !1, Au = function(e) {
  return e.tagName === "TEXTAREA";
}, Ea = function(e, t) {
  var n = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    n[t] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !Au(e) && n[t] === "visible")
  );
}, Pu = function(e) {
  return Ea(e, "overflowY");
}, Ou = function(e) {
  return Ea(e, "overflowX");
}, ac = function(e, t) {
  var n = t;
  do {
    typeof ShadowRoot < "u" && n instanceof ShadowRoot && (n = n.host);
    var o = _a(e, n);
    if (o) {
      var r = Sa(e, n), i = r[1], c = r[2];
      if (i > c)
        return !0;
    }
    n = n.parentNode;
  } while (n && n !== document.body);
  return !1;
}, Tu = function(e) {
  var t = e.scrollTop, n = e.scrollHeight, o = e.clientHeight;
  return [
    t,
    n,
    o
  ];
}, Du = function(e) {
  var t = e.scrollLeft, n = e.scrollWidth, o = e.clientWidth;
  return [
    t,
    n,
    o
  ];
}, _a = function(e, t) {
  return e === "v" ? Pu(t) : Ou(t);
}, Sa = function(e, t) {
  return e === "v" ? Tu(t) : Du(t);
}, Ru = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, Nu = function(e, t, n, o, r) {
  var i = Ru(e, window.getComputedStyle(t).direction), c = i * o, a = n.target, s = t.contains(a), l = !1, u = c > 0, d = 0, h = 0;
  do {
    var v = Sa(e, a), p = v[0], f = v[1], g = v[2], m = f - g - i * p;
    (p || m) && _a(e, a) && (d += m, h += p), a = a.parentNode;
  } while (
    // portaled content
    !s && a !== document.body || // self content
    s && (t.contains(a) || t === a)
  );
  return (u && (r && d === 0 || !r && c > d) || !u && (r && h === 0 || !r && -c > h)) && (l = !0), l;
}, so = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, sc = function(e) {
  return [e.deltaX, e.deltaY];
}, lc = function(e) {
  return e && "current" in e ? e.current : e;
}, Iu = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, Lu = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, Mu = 0, Jt = [];
function ku(e) {
  var t = H.useRef([]), n = H.useRef([0, 0]), o = H.useRef(), r = H.useState(Mu++)[0], i = H.useState(function() {
    return xa();
  })[0], c = H.useRef(e);
  H.useEffect(function() {
    c.current = e;
  }, [e]), H.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(r));
      var f = iu([e.lockRef.current], (e.shards || []).map(lc), !0).filter(Boolean);
      return f.forEach(function(g) {
        return g.classList.add("allow-interactivity-".concat(r));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(r)), f.forEach(function(g) {
          return g.classList.remove("allow-interactivity-".concat(r));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var a = H.useCallback(function(f, g) {
    if ("touches" in f && f.touches.length === 2)
      return !c.current.allowPinchZoom;
    var m = so(f), $ = n.current, b = "deltaX" in f ? f.deltaX : $[0] - m[0], y = "deltaY" in f ? f.deltaY : $[1] - m[1], w, _ = f.target, x = Math.abs(b) > Math.abs(y) ? "h" : "v";
    if ("touches" in f && x === "h" && _.type === "range")
      return !1;
    var C = ac(x, _);
    if (!C)
      return !0;
    if (C ? w = x : (w = x === "v" ? "h" : "v", C = ac(x, _)), !C)
      return !1;
    if (!o.current && "changedTouches" in f && (b || y) && (o.current = w), !w)
      return !0;
    var T = o.current || w;
    return Nu(T, g, f, T === "h" ? b : y, !0);
  }, []), s = H.useCallback(function(f) {
    var g = f;
    if (!(!Jt.length || Jt[Jt.length - 1] !== i)) {
      var m = "deltaY" in g ? sc(g) : so(g), $ = t.current.filter(function(w) {
        return w.name === g.type && w.target === g.target && Iu(w.delta, m);
      })[0];
      if ($ && $.should) {
        g.cancelable && g.preventDefault();
        return;
      }
      if (!$) {
        var b = (c.current.shards || []).map(lc).filter(Boolean).filter(function(w) {
          return w.contains(g.target);
        }), y = b.length > 0 ? a(g, b[0]) : !c.current.noIsolation;
        y && g.cancelable && g.preventDefault();
      }
    }
  }, []), l = H.useCallback(function(f, g, m, $) {
    var b = { name: f, delta: g, target: m, should: $ };
    t.current.push(b), setTimeout(function() {
      t.current = t.current.filter(function(y) {
        return y !== b;
      });
    }, 1);
  }, []), u = H.useCallback(function(f) {
    n.current = so(f), o.current = void 0;
  }, []), d = H.useCallback(function(f) {
    l(f.type, sc(f), f.target, a(f, e.lockRef.current));
  }, []), h = H.useCallback(function(f) {
    l(f.type, so(f), f.target, a(f, e.lockRef.current));
  }, []);
  H.useEffect(function() {
    return Jt.push(i), e.setCallbacks({
      onScrollCapture: d,
      onWheelCapture: d,
      onTouchMoveCapture: h
    }), document.addEventListener("wheel", s, Zt), document.addEventListener("touchmove", s, Zt), document.addEventListener("touchstart", u, Zt), function() {
      Jt = Jt.filter(function(f) {
        return f !== i;
      }), document.removeEventListener("wheel", s, Zt), document.removeEventListener("touchmove", s, Zt), document.removeEventListener("touchstart", u, Zt);
    };
  }, []);
  var v = e.removeScrollBar, p = e.inert;
  return H.createElement(
    H.Fragment,
    null,
    p ? H.createElement(i, { styles: Lu(r) }) : null,
    v ? H.createElement(Su, { gapMode: "margin" }) : null
  );
}
const Fu = pu(Ca, ku);
var Aa = H.forwardRef(function(e, t) {
  return H.createElement(Ho, Ve({}, e, { ref: t, sideCar: Fu }));
});
Aa.classNames = Ho.classNames;
const Zr = Aa;
var Hu = function(e) {
  if (typeof document > "u")
    return null;
  var t = Array.isArray(e) ? e[0] : e;
  return t.ownerDocument.body;
}, Qt = /* @__PURE__ */ new WeakMap(), lo = /* @__PURE__ */ new WeakMap(), uo = {}, pr = 0, Pa = function(e) {
  return e && (e.host || Pa(e.parentNode));
}, Bu = function(e, t) {
  return t.map(function(n) {
    if (e.contains(n))
      return n;
    var o = Pa(n);
    return o && e.contains(o) ? o : (console.error("aria-hidden", n, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(n) {
    return !!n;
  });
}, Wu = function(e, t, n, o) {
  var r = Bu(t, Array.isArray(e) ? e : [e]);
  uo[n] || (uo[n] = /* @__PURE__ */ new WeakMap());
  var i = uo[n], c = [], a = /* @__PURE__ */ new Set(), s = new Set(r), l = function(d) {
    !d || a.has(d) || (a.add(d), l(d.parentNode));
  };
  r.forEach(l);
  var u = function(d) {
    !d || s.has(d) || Array.prototype.forEach.call(d.children, function(h) {
      if (a.has(h))
        u(h);
      else {
        var v = h.getAttribute(o), p = v !== null && v !== "false", f = (Qt.get(h) || 0) + 1, g = (i.get(h) || 0) + 1;
        Qt.set(h, f), i.set(h, g), c.push(h), f === 1 && p && lo.set(h, !0), g === 1 && h.setAttribute(n, "true"), p || h.setAttribute(o, "true");
      }
    });
  };
  return u(t), a.clear(), pr++, function() {
    c.forEach(function(d) {
      var h = Qt.get(d) - 1, v = i.get(d) - 1;
      Qt.set(d, h), i.set(d, v), h || (lo.has(d) || d.removeAttribute(o), lo.delete(d)), v || d.removeAttribute(n);
    }), pr--, pr || (Qt = /* @__PURE__ */ new WeakMap(), Qt = /* @__PURE__ */ new WeakMap(), lo = /* @__PURE__ */ new WeakMap(), uo = {});
  };
}, Jr = function(e, t, n) {
  n === void 0 && (n = "data-aria-hidden");
  var o = Array.from(Array.isArray(e) ? e : [e]), r = t || Hu(e);
  return r ? (o.push.apply(o, Array.from(r.querySelectorAll("[aria-live]"))), Wu(o, r, n, "aria-hidden")) : function() {
    return null;
  };
};
const Oa = "Dialog", [Ta, fg] = zt(Oa), [Vu, He] = Ta(Oa), Uu = (e) => {
  const { __scopeDialog: t, children: n, open: o, defaultOpen: r, onOpenChange: i, modal: c = !0 } = e, a = j(null), s = j(null), [l = !1, u] = Cn({
    prop: o,
    defaultProp: r,
    onChange: i
  });
  return /* @__PURE__ */ E(Vu, {
    scope: t,
    triggerRef: a,
    contentRef: s,
    contentId: un(),
    titleId: un(),
    descriptionId: un(),
    open: l,
    onOpenChange: u,
    onOpenToggle: le(
      () => u(
        (d) => !d
      ),
      [
        u
      ]
    ),
    modal: c
  }, n);
}, zu = "DialogTrigger", qu = /* @__PURE__ */ z((e, t) => {
  const { __scopeDialog: n, ...o } = e, r = He(zu, n), i = we(t, r.triggerRef);
  return /* @__PURE__ */ E(ve.button, F({
    type: "button",
    "aria-haspopup": "dialog",
    "aria-expanded": r.open,
    "aria-controls": r.contentId,
    "data-state": Qr(r.open)
  }, o, {
    ref: i,
    onClick: $e(e.onClick, r.onOpenToggle)
  }));
}), Da = "DialogPortal", [Ku, Ra] = Ta(Da, {
  forceMount: void 0
}), Yu = (e) => {
  const { __scopeDialog: t, forceMount: n, children: o, container: r } = e, i = He(Da, t);
  return /* @__PURE__ */ E(Ku, {
    scope: t,
    forceMount: n
  }, ge.map(
    o,
    (c) => /* @__PURE__ */ E(Pt, {
      present: n || i.open
    }, /* @__PURE__ */ E($a, {
      asChild: !0,
      container: r
    }, c))
  ));
}, Pr = "DialogOverlay", ju = /* @__PURE__ */ z((e, t) => {
  const n = Ra(Pr, e.__scopeDialog), { forceMount: o = n.forceMount, ...r } = e, i = He(Pr, e.__scopeDialog);
  return i.modal ? /* @__PURE__ */ E(Pt, {
    present: o || i.open
  }, /* @__PURE__ */ E(Gu, F({}, r, {
    ref: t
  }))) : null;
}), Gu = /* @__PURE__ */ z((e, t) => {
  const { __scopeDialog: n, ...o } = e, r = He(Pr, n);
  return (
    // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
    // ie. when `Overlay` and `Content` are siblings
    /* @__PURE__ */ E(Zr, {
      as: pn,
      allowPinchZoom: !0,
      shards: [
        r.contentRef
      ]
    }, /* @__PURE__ */ E(ve.div, F({
      "data-state": Qr(r.open)
    }, o, {
      ref: t,
      style: {
        pointerEvents: "auto",
        ...o.style
      }
    })))
  );
}), Ln = "DialogContent", Xu = /* @__PURE__ */ z((e, t) => {
  const n = Ra(Ln, e.__scopeDialog), { forceMount: o = n.forceMount, ...r } = e, i = He(Ln, e.__scopeDialog);
  return /* @__PURE__ */ E(Pt, {
    present: o || i.open
  }, i.modal ? /* @__PURE__ */ E(Zu, F({}, r, {
    ref: t
  })) : /* @__PURE__ */ E(Ju, F({}, r, {
    ref: t
  })));
}), Zu = /* @__PURE__ */ z((e, t) => {
  const n = He(Ln, e.__scopeDialog), o = j(null), r = we(t, n.contentRef, o);
  return G(() => {
    const i = o.current;
    if (i)
      return Jr(i);
  }, []), /* @__PURE__ */ E(Na, F({}, e, {
    ref: r,
    trapFocus: n.open,
    disableOutsidePointerEvents: !0,
    onCloseAutoFocus: $e(e.onCloseAutoFocus, (i) => {
      var c;
      i.preventDefault(), (c = n.triggerRef.current) === null || c === void 0 || c.focus();
    }),
    onPointerDownOutside: $e(e.onPointerDownOutside, (i) => {
      const c = i.detail.originalEvent, a = c.button === 0 && c.ctrlKey === !0;
      (c.button === 2 || a) && i.preventDefault();
    }),
    onFocusOutside: $e(
      e.onFocusOutside,
      (i) => i.preventDefault()
    )
  }));
}), Ju = /* @__PURE__ */ z((e, t) => {
  const n = He(Ln, e.__scopeDialog), o = j(!1);
  return /* @__PURE__ */ E(Na, F({}, e, {
    ref: t,
    trapFocus: !1,
    disableOutsidePointerEvents: !1,
    onCloseAutoFocus: (r) => {
      var i;
      if ((i = e.onCloseAutoFocus) === null || i === void 0 || i.call(e, r), !r.defaultPrevented) {
        var c;
        o.current || (c = n.triggerRef.current) === null || c === void 0 || c.focus(), r.preventDefault();
      }
      o.current = !1;
    },
    onInteractOutside: (r) => {
      var i, c;
      (i = e.onInteractOutside) === null || i === void 0 || i.call(e, r), r.defaultPrevented || (o.current = !0);
      const a = r.target;
      ((c = n.triggerRef.current) === null || c === void 0 ? void 0 : c.contains(a)) && r.preventDefault();
    }
  }));
}), Na = /* @__PURE__ */ z((e, t) => {
  const { __scopeDialog: n, trapFocus: o, onOpenAutoFocus: r, onCloseAutoFocus: i, ...c } = e, a = He(Ln, n), s = j(null), l = we(t, s);
  return ba(), /* @__PURE__ */ E(wn, null, /* @__PURE__ */ E(ma, {
    asChild: !0,
    loop: !0,
    trapped: o,
    onMountAutoFocus: r,
    onUnmountAutoFocus: i
  }, /* @__PURE__ */ E(pa, F({
    role: "dialog",
    id: a.contentId,
    "aria-describedby": a.descriptionId,
    "aria-labelledby": a.titleId,
    "data-state": Qr(a.open)
  }, c, {
    ref: l,
    onDismiss: () => a.onOpenChange(!1)
  }))), !1);
}), Qu = "DialogTitle", ed = /* @__PURE__ */ z((e, t) => {
  const { __scopeDialog: n, ...o } = e, r = He(Qu, n);
  return /* @__PURE__ */ E(ve.h2, F({
    id: r.titleId
  }, o, {
    ref: t
  }));
}), td = "DialogDescription", nd = /* @__PURE__ */ z((e, t) => {
  const { __scopeDialog: n, ...o } = e, r = He(td, n);
  return /* @__PURE__ */ E(ve.p, F({
    id: r.descriptionId
  }, o, {
    ref: t
  }));
}), od = "DialogClose", rd = /* @__PURE__ */ z((e, t) => {
  const { __scopeDialog: n, ...o } = e, r = He(od, n);
  return /* @__PURE__ */ E(ve.button, F({
    type: "button"
  }, o, {
    ref: t,
    onClick: $e(
      e.onClick,
      () => r.onOpenChange(!1)
    )
  }));
});
function Qr(e) {
  return e ? "open" : "closed";
}
const Ia = Uu, La = qu, Ma = Yu, ka = ju, Fa = Xu, Ha = ed, id = nd, Ba = rd, cd = "_overlay_16hvq_1", ad = "_fadeIn_16hvq_1", sd = "_fadeOut_16hvq_1", ld = "_dialogContent_16hvq_34", ud = "_dialogRight_16hvq_45", dd = "_slideIn_16hvq_1", fd = "_slideOut_16hvq_1", vd = "_dialogBottom_16hvq_56", pd = "_slideUp_16hvq_1", hd = "_slideDown_16hvq_1", md = "_flyoutCloseButton_16hvq_104", fo = {
  overlay: cd,
  fadeIn: ad,
  fadeOut: sd,
  dialogContent: ld,
  dialogRight: ud,
  slideIn: dd,
  slideOut: fd,
  dialogBottom: vd,
  slideUp: pd,
  slideDown: hd,
  flyoutCloseButton: md
};
function Wa({
  children: e,
  className: t = "",
  height: n = "100%",
  open: o = !1,
  onOpenChange: r,
  onOutsideClick: i,
  position: c = "RIGHT",
  trigger: a,
  width: s
}) {
  const l = oe({
    [t]: !!t,
    [fo.dialogContent]: !0,
    [fo.dialogBottom]: c === "BOTTOM",
    [fo.dialogRight]: c === "RIGHT"
  });
  return /* @__PURE__ */ se(Ia, { open: o, onOpenChange: r, children: [
    /* @__PURE__ */ P(La, { asChild: !0, children: a }),
    /* @__PURE__ */ se(Ma, { children: [
      /* @__PURE__ */ P(ka, { className: fo.overlay }),
      /* @__PURE__ */ P(
        Fa,
        {
          className: l,
          onPointerDownOutside: () => {
            i && i();
          },
          style: { height: n, width: s },
          children: e
        }
      )
    ] })
  ] });
}
Wa.CloseButton = Ba;
Wa.Title = Ha;
function vg({
  disabled: e = !1,
  hasError: t = !1,
  helperText: n = "",
  labelText: o = "",
  onClear: r = () => {
  },
  onChange: i = () => {
  },
  placeholder: c = "",
  showClearButton: a = !1,
  suffix: s = "",
  type: l = "text",
  value: u = "",
  ...d
}) {
  const h = j(), v = oe({
    labelContainer: !0,
    hasError: t,
    disabled: e
  }), p = oe({
    input: !0
  }), f = oe({
    label: !0,
    hasPlaceholder: c !== ""
  }), g = oe({
    helperText: !0,
    hasError: t
  }), m = l === "password";
  function $(y) {
    var w;
    y.preventDefault(), y.stopPropagation(), ((w = h.current) == null ? void 0 : w.type) === "password" ? h.current.type = "text" : h.current !== null && (h.current.type = "password");
  }
  function b(y) {
    y.preventDefault(), y.stopPropagation(), r(y);
  }
  return /* @__PURE__ */ se(sa, { children: [
    /* @__PURE__ */ se("label", { className: v, "aria-label": o, children: [
      /* @__PURE__ */ P(
        "input",
        {
          "aria-invalid": t,
          className: p,
          disabled: e,
          type: l,
          onChange: i,
          placeholder: c,
          ref: h,
          required: !0,
          value: u,
          ...d
        }
      ),
      /* @__PURE__ */ P("div", { className: f, children: o }),
      /* @__PURE__ */ se("div", { className: "optionals", children: [
        /* @__PURE__ */ P("div", { className: "suffix", children: s }),
        m && /* @__PURE__ */ P(
          "button",
          {
            className: "revealButton",
            onClick: (y) => $(y),
            children: /* @__PURE__ */ P(gd, {})
          }
        ),
        a && /* @__PURE__ */ P(
          "button",
          {
            className: "clearButton",
            onClick: (y) => b(y),
            children: /* @__PURE__ */ P($d, {})
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ P("div", { className: g, children: n })
  ] });
}
function gd() {
  return /* @__PURE__ */ P(
    "svg",
    {
      width: "24",
      height: "25",
      viewBox: "0 0 24 25",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ P("g", { id: "eye_hide", children: /* @__PURE__ */ P(
        "path",
        {
          id: "Union",
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M11.75 4.5C9.78444 4.5 7.87969 5.34775 6.24762 6.60907C4.61248 7.87277 3.20211 9.5875 2.21168 11.4207C1.92687 11.9393 1.93317 12.5572 2.20824 13.0729L2.20822 13.073L2.21086 13.0778C3.06966 14.6598 4.23426 16.1526 5.59144 17.3479L4.21967 18.7197C3.92678 19.0126 3.92678 19.4874 4.21967 19.7803C4.51256 20.0732 4.98744 20.0732 5.28033 19.7803L7.16171 17.8989C7.21365 17.8597 7.26129 17.8131 7.30304 17.7591C7.30471 17.757 7.30636 17.7548 7.30799 17.7527L10.05 15.0106L10.0503 15.0103L10.0506 15.01L14.5099 10.5507L14.5103 10.5503L14.5107 10.5499L17.3119 7.74879C17.3171 7.74368 17.3223 7.73849 17.3275 7.7332L19.2803 5.78033C19.5732 5.48744 19.5732 5.01256 19.2803 4.71967C18.9874 4.42678 18.5126 4.42678 18.2197 4.71967L16.7145 6.22489C15.2048 5.17849 13.497 4.5 11.75 4.5ZM15.6341 7.30527C14.3689 6.47582 13.0348 6 11.75 6C10.2156 6 8.62531 6.66726 7.16488 7.79593C5.70841 8.92154 4.42942 10.4706 3.52993 12.1364L3.52671 12.1423L3.52668 12.1423C3.49339 12.2026 3.48745 12.2827 3.53084 12.3653C4.32773 13.8324 5.41073 15.2062 6.65449 16.2848L8.51038 14.429C7.48838 12.9115 7.64814 10.8312 8.98967 9.48967C10.3312 8.14814 12.4115 7.98837 13.929 9.01038L15.6341 7.30527ZM10.0503 10.5503C10.8023 9.79832 11.933 9.64978 12.8346 10.1047L9.60472 13.3346C9.14978 12.433 9.29832 11.3023 10.0503 10.5503ZM18.3437 8.59907C18.659 8.33046 19.1323 8.36833 19.4009 8.68365C20.119 9.52658 20.7706 10.4495 21.2897 11.4232C21.5731 11.9413 21.5664 12.558 21.2918 13.0729L21.2883 13.0793C20.2976 14.913 18.8846 16.6276 17.2484 17.8911C15.6155 19.1521 13.7108 20 11.75 20C10.8037 20 9.86031 19.7975 8.97443 19.4475C8.58919 19.2953 8.40027 18.8597 8.55246 18.4744C8.70466 18.0892 9.14033 17.9003 9.52557 18.0525C10.2597 18.3425 11.0163 18.5 11.75 18.5C13.2792 18.5 14.8695 17.8329 16.3316 16.7039C17.7889 15.5785 19.0698 14.0301 19.969 12.3656C20.0126 12.2829 20.0067 12.2027 19.9733 12.1423L19.968 12.1326L19.968 12.1326C19.5075 11.2678 18.92 10.4322 18.2591 9.65635C17.9905 9.34103 18.0283 8.86767 18.3437 8.59907Z",
          fill: "#181386"
        }
      ) })
    }
  );
}
function $d() {
  return /* @__PURE__ */ P(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "25",
      viewBox: "0 0 24 25",
      fill: "none",
      children: /* @__PURE__ */ P(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M3.75 12.5C3.75 7.94321 7.44321 4.25 12 4.25C16.5568 4.25 20.25 7.94321 20.25 12.5C20.25 17.0568 16.5568 20.75 12 20.75C7.44321 20.75 3.75 17.0568 3.75 12.5ZM12 2.75C6.61479 2.75 2.25 7.11479 2.25 12.5C2.25 17.8852 6.61479 22.25 12 22.25C17.3852 22.25 21.75 17.8852 21.75 12.5C21.75 7.11479 17.3852 2.75 12 2.75ZM15.3603 9.13965C15.6531 9.43255 15.6531 9.90742 15.3603 10.2003L13.0606 12.5L15.3603 14.7997C15.6531 15.0925 15.6531 15.5674 15.3603 15.8603C15.0674 16.1532 14.5925 16.1532 14.2996 15.8603L11.9999 13.5606L9.70025 15.8603C9.40736 16.1532 8.93249 16.1532 8.63959 15.8603C8.3467 15.5674 8.3467 15.0925 8.63959 14.7997L10.9393 12.5L8.63959 10.2003C8.3467 9.90742 8.3467 9.43255 8.63959 9.13965C8.93249 8.84676 9.40736 8.84676 9.70025 9.13965L11.9999 11.4393L14.2996 9.13965C14.5925 8.84676 15.0674 8.84676 15.3603 9.13965Z",
          fill: "#ADABC2"
        }
      )
    }
  );
}
function qt(e) {
  return e.split("-")[0];
}
function Gn(e) {
  return e.split("-")[1];
}
function xn(e) {
  return ["top", "bottom"].includes(qt(e)) ? "x" : "y";
}
function ei(e) {
  return e === "y" ? "height" : "width";
}
function uc(e, t, n) {
  let { reference: o, floating: r } = e;
  const i = o.x + o.width / 2 - r.width / 2, c = o.y + o.height / 2 - r.height / 2, a = xn(t), s = ei(a), l = o[s] / 2 - r[s] / 2, u = a === "x";
  let d;
  switch (qt(t)) {
    case "top":
      d = { x: i, y: o.y - r.height };
      break;
    case "bottom":
      d = { x: i, y: o.y + o.height };
      break;
    case "right":
      d = { x: o.x + o.width, y: c };
      break;
    case "left":
      d = { x: o.x - r.width, y: c };
      break;
    default:
      d = { x: o.x, y: o.y };
  }
  switch (Gn(t)) {
    case "start":
      d[a] -= l * (n && u ? -1 : 1);
      break;
    case "end":
      d[a] += l * (n && u ? -1 : 1);
  }
  return d;
}
const bd = async (e, t, n) => {
  const { placement: o = "bottom", strategy: r = "absolute", middleware: i = [], platform: c } = n, a = await (c.isRTL == null ? void 0 : c.isRTL(t));
  let s = await c.getElementRects({ reference: e, floating: t, strategy: r }), { x: l, y: u } = uc(s, o, a), d = o, h = {}, v = 0;
  for (let p = 0; p < i.length; p++) {
    const { name: f, fn: g } = i[p], { x: m, y: $, data: b, reset: y } = await g({ x: l, y: u, initialPlacement: o, placement: d, strategy: r, middlewareData: h, rects: s, platform: c, elements: { reference: e, floating: t } });
    l = m ?? l, u = $ ?? u, h = { ...h, [f]: { ...h[f], ...b } }, y && v <= 50 && (v++, typeof y == "object" && (y.placement && (d = y.placement), y.rects && (s = y.rects === !0 ? await c.getElementRects({ reference: e, floating: t, strategy: r }) : y.rects), { x: l, y: u } = uc(s, d, a)), p = -1);
  }
  return { x: l, y: u, placement: d, strategy: r, middlewareData: h };
};
function Va(e) {
  return typeof e != "number" ? function(t) {
    return { top: 0, right: 0, bottom: 0, left: 0, ...t };
  }(e) : { top: e, right: e, bottom: e, left: e };
}
function Eo(e) {
  return { ...e, top: e.y, left: e.x, right: e.x + e.width, bottom: e.y + e.height };
}
async function Mn(e, t) {
  var n;
  t === void 0 && (t = {});
  const { x: o, y: r, platform: i, rects: c, elements: a, strategy: s } = e, { boundary: l = "clippingAncestors", rootBoundary: u = "viewport", elementContext: d = "floating", altBoundary: h = !1, padding: v = 0 } = t, p = Va(v), f = a[h ? d === "floating" ? "reference" : "floating" : d], g = Eo(await i.getClippingRect({ element: (n = await (i.isElement == null ? void 0 : i.isElement(f))) == null || n ? f : f.contextElement || await (i.getDocumentElement == null ? void 0 : i.getDocumentElement(a.floating)), boundary: l, rootBoundary: u, strategy: s })), m = Eo(i.convertOffsetParentRelativeRectToViewportRelativeRect ? await i.convertOffsetParentRelativeRectToViewportRelativeRect({ rect: d === "floating" ? { ...c.floating, x: o, y: r } : c.reference, offsetParent: await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(a.floating)), strategy: s }) : c[d]);
  return { top: g.top - m.top + p.top, bottom: m.bottom - g.bottom + p.bottom, left: g.left - m.left + p.left, right: m.right - g.right + p.right };
}
const yd = Math.min, Lt = Math.max;
function Or(e, t, n) {
  return Lt(e, yd(t, n));
}
const dc = (e) => ({ name: "arrow", options: e, async fn(t) {
  const { element: n, padding: o = 0 } = e ?? {}, { x: r, y: i, placement: c, rects: a, platform: s } = t;
  if (n == null)
    return {};
  const l = Va(o), u = { x: r, y: i }, d = xn(c), h = Gn(c), v = ei(d), p = await s.getDimensions(n), f = d === "y" ? "top" : "left", g = d === "y" ? "bottom" : "right", m = a.reference[v] + a.reference[d] - u[d] - a.floating[v], $ = u[d] - a.reference[d], b = await (s.getOffsetParent == null ? void 0 : s.getOffsetParent(n));
  let y = b ? d === "y" ? b.clientHeight || 0 : b.clientWidth || 0 : 0;
  y === 0 && (y = a.floating[v]);
  const w = m / 2 - $ / 2, _ = l[f], x = y - p[v] - l[g], C = y / 2 - p[v] / 2 + w, T = Or(_, C, x), D = (h === "start" ? l[f] : l[g]) > 0 && C !== T && a.reference[v] <= a.floating[v];
  return { [d]: u[d] - (D ? C < _ ? _ - C : x - C : 0), data: { [d]: T, centerOffset: C - T } };
} }), wd = { left: "right", right: "left", bottom: "top", top: "bottom" };
function _o(e) {
  return e.replace(/left|right|bottom|top/g, (t) => wd[t]);
}
function Cd(e, t, n) {
  n === void 0 && (n = !1);
  const o = Gn(e), r = xn(e), i = ei(r);
  let c = r === "x" ? o === (n ? "end" : "start") ? "right" : "left" : o === "start" ? "bottom" : "top";
  return t.reference[i] > t.floating[i] && (c = _o(c)), { main: c, cross: _o(c) };
}
const xd = { start: "end", end: "start" };
function fc(e) {
  return e.replace(/start|end/g, (t) => xd[t]);
}
const Ua = ["top", "right", "bottom", "left"];
Ua.reduce((e, t) => e.concat(t, t + "-start", t + "-end"), []);
const Ed = function(e) {
  return e === void 0 && (e = {}), { name: "flip", options: e, async fn(t) {
    var n;
    const { placement: o, middlewareData: r, rects: i, initialPlacement: c, platform: a, elements: s } = t, { mainAxis: l = !0, crossAxis: u = !0, fallbackPlacements: d, fallbackStrategy: h = "bestFit", flipAlignment: v = !0, ...p } = e, f = qt(o), g = d || (f === c || !v ? [_o(c)] : function(C) {
      const T = _o(C);
      return [fc(C), T, fc(T)];
    }(c)), m = [c, ...g], $ = await Mn(t, p), b = [];
    let y = ((n = r.flip) == null ? void 0 : n.overflows) || [];
    if (l && b.push($[f]), u) {
      const { main: C, cross: T } = Cd(o, i, await (a.isRTL == null ? void 0 : a.isRTL(s.floating)));
      b.push($[C], $[T]);
    }
    if (y = [...y, { placement: o, overflows: b }], !b.every((C) => C <= 0)) {
      var w, _;
      const C = ((w = (_ = r.flip) == null ? void 0 : _.index) != null ? w : 0) + 1, T = m[C];
      if (T)
        return { data: { index: C, overflows: y }, reset: { placement: T } };
      let D = "bottom";
      switch (h) {
        case "bestFit": {
          var x;
          const S = (x = y.map((A) => [A, A.overflows.filter((O) => O > 0).reduce((O, I) => O + I, 0)]).sort((A, O) => A[1] - O[1])[0]) == null ? void 0 : x[0].placement;
          S && (D = S);
          break;
        }
        case "initialPlacement":
          D = c;
      }
      if (o !== D)
        return { reset: { placement: D } };
    }
    return {};
  } };
};
function vc(e, t) {
  return { top: e.top - t.height, right: e.right - t.width, bottom: e.bottom - t.height, left: e.left - t.width };
}
function pc(e) {
  return Ua.some((t) => e[t] >= 0);
}
const _d = function(e) {
  let { strategy: t = "referenceHidden", ...n } = e === void 0 ? {} : e;
  return { name: "hide", async fn(o) {
    const { rects: r } = o;
    switch (t) {
      case "referenceHidden": {
        const i = vc(await Mn(o, { ...n, elementContext: "reference" }), r.reference);
        return { data: { referenceHiddenOffsets: i, referenceHidden: pc(i) } };
      }
      case "escaped": {
        const i = vc(await Mn(o, { ...n, altBoundary: !0 }), r.floating);
        return { data: { escapedOffsets: i, escaped: pc(i) } };
      }
      default:
        return {};
    }
  } };
}, Sd = function(e) {
  return e === void 0 && (e = 0), { name: "offset", options: e, async fn(t) {
    const { x: n, y: o } = t, r = await async function(i, c) {
      const { placement: a, platform: s, elements: l } = i, u = await (s.isRTL == null ? void 0 : s.isRTL(l.floating)), d = qt(a), h = Gn(a), v = xn(a) === "x", p = ["left", "top"].includes(d) ? -1 : 1, f = u && v ? -1 : 1, g = typeof c == "function" ? c(i) : c;
      let { mainAxis: m, crossAxis: $, alignmentAxis: b } = typeof g == "number" ? { mainAxis: g, crossAxis: 0, alignmentAxis: null } : { mainAxis: 0, crossAxis: 0, alignmentAxis: null, ...g };
      return h && typeof b == "number" && ($ = h === "end" ? -1 * b : b), v ? { x: $ * f, y: m * p } : { x: m * p, y: $ * f };
    }(t, e);
    return { x: n + r.x, y: o + r.y, data: r };
  } };
};
function za(e) {
  return e === "x" ? "y" : "x";
}
const Ad = function(e) {
  return e === void 0 && (e = {}), { name: "shift", options: e, async fn(t) {
    const { x: n, y: o, placement: r } = t, { mainAxis: i = !0, crossAxis: c = !1, limiter: a = { fn: (g) => {
      let { x: m, y: $ } = g;
      return { x: m, y: $ };
    } }, ...s } = e, l = { x: n, y: o }, u = await Mn(t, s), d = xn(qt(r)), h = za(d);
    let v = l[d], p = l[h];
    if (i) {
      const g = d === "y" ? "bottom" : "right";
      v = Or(v + u[d === "y" ? "top" : "left"], v, v - u[g]);
    }
    if (c) {
      const g = h === "y" ? "bottom" : "right";
      p = Or(p + u[h === "y" ? "top" : "left"], p, p - u[g]);
    }
    const f = a.fn({ ...t, [d]: v, [h]: p });
    return { ...f, data: { x: f.x - n, y: f.y - o } };
  } };
}, Pd = function(e) {
  return e === void 0 && (e = {}), { options: e, fn(t) {
    const { x: n, y: o, placement: r, rects: i, middlewareData: c } = t, { offset: a = 0, mainAxis: s = !0, crossAxis: l = !0 } = e, u = { x: n, y: o }, d = xn(r), h = za(d);
    let v = u[d], p = u[h];
    const f = typeof a == "function" ? a({ ...i, placement: r }) : a, g = typeof f == "number" ? { mainAxis: f, crossAxis: 0 } : { mainAxis: 0, crossAxis: 0, ...f };
    if (s) {
      const w = d === "y" ? "height" : "width", _ = i.reference[d] - i.floating[w] + g.mainAxis, x = i.reference[d] + i.reference[w] - g.mainAxis;
      v < _ ? v = _ : v > x && (v = x);
    }
    if (l) {
      var m, $, b, y;
      const w = d === "y" ? "width" : "height", _ = ["top", "left"].includes(qt(r)), x = i.reference[h] - i.floating[w] + (_ && (m = ($ = c.offset) == null ? void 0 : $[h]) != null ? m : 0) + (_ ? 0 : g.crossAxis), C = i.reference[h] + i.reference[w] + (_ ? 0 : (b = (y = c.offset) == null ? void 0 : y[h]) != null ? b : 0) - (_ ? g.crossAxis : 0);
      p < x ? p = x : p > C && (p = C);
    }
    return { [d]: v, [h]: p };
  } };
}, Od = function(e) {
  return e === void 0 && (e = {}), { name: "size", options: e, async fn(t) {
    const { placement: n, rects: o, platform: r, elements: i } = t, { apply: c, ...a } = e, s = await Mn(t, a), l = qt(n), u = Gn(n);
    let d, h;
    l === "top" || l === "bottom" ? (d = l, h = u === (await (r.isRTL == null ? void 0 : r.isRTL(i.floating)) ? "start" : "end") ? "left" : "right") : (h = l, d = u === "end" ? "top" : "bottom");
    const v = Lt(s.left, 0), p = Lt(s.right, 0), f = Lt(s.top, 0), g = Lt(s.bottom, 0), m = { availableHeight: o.floating.height - (["left", "right"].includes(n) ? 2 * (f !== 0 || g !== 0 ? f + g : Lt(s.top, s.bottom)) : s[d]), availableWidth: o.floating.width - (["top", "bottom"].includes(n) ? 2 * (v !== 0 || p !== 0 ? v + p : Lt(s.left, s.right)) : s[h]) }, $ = await r.getDimensions(i.floating);
    c == null || c({ ...t, ...m });
    const b = await r.getDimensions(i.floating);
    return $.width !== b.width || $.height !== b.height ? { reset: { rects: !0 } } : {};
  } };
};
function qa(e) {
  return e && e.document && e.location && e.alert && e.setInterval;
}
function dt(e) {
  if (e == null)
    return window;
  if (!qa(e)) {
    const t = e.ownerDocument;
    return t && t.defaultView || window;
  }
  return e;
}
function Xn(e) {
  return dt(e).getComputedStyle(e);
}
function et(e) {
  return qa(e) ? "" : e ? (e.nodeName || "").toLowerCase() : "";
}
function Ka() {
  const e = navigator.userAgentData;
  return e != null && e.brands ? e.brands.map((t) => t.brand + "/" + t.version).join(" ") : navigator.userAgent;
}
function Ue(e) {
  return e instanceof dt(e).HTMLElement;
}
function Ct(e) {
  return e instanceof dt(e).Element;
}
function ti(e) {
  return typeof ShadowRoot > "u" ? !1 : e instanceof dt(e).ShadowRoot || e instanceof ShadowRoot;
}
function Bo(e) {
  const { overflow: t, overflowX: n, overflowY: o } = Xn(e);
  return /auto|scroll|overlay|hidden/.test(t + o + n);
}
function Td(e) {
  return ["table", "td", "th"].includes(et(e));
}
function hc(e) {
  const t = /firefox/i.test(Ka()), n = Xn(e);
  return n.transform !== "none" || n.perspective !== "none" || n.contain === "paint" || ["transform", "perspective"].includes(n.willChange) || t && n.willChange === "filter" || t && !!n.filter && n.filter !== "none";
}
function Ya() {
  return !/^((?!chrome|android).)*safari/i.test(Ka());
}
const mc = Math.min, Dn = Math.max, So = Math.round;
function tt(e, t, n) {
  var o, r, i, c;
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const a = e.getBoundingClientRect();
  let s = 1, l = 1;
  t && Ue(e) && (s = e.offsetWidth > 0 && So(a.width) / e.offsetWidth || 1, l = e.offsetHeight > 0 && So(a.height) / e.offsetHeight || 1);
  const u = Ct(e) ? dt(e) : window, d = !Ya() && n, h = (a.left + (d && (o = (r = u.visualViewport) == null ? void 0 : r.offsetLeft) != null ? o : 0)) / s, v = (a.top + (d && (i = (c = u.visualViewport) == null ? void 0 : c.offsetTop) != null ? i : 0)) / l, p = a.width / s, f = a.height / l;
  return { width: p, height: f, top: v, right: h + p, bottom: v + f, left: h, x: h, y: v };
}
function yt(e) {
  return (t = e, (t instanceof dt(t).Node ? e.ownerDocument : e.document) || window.document).documentElement;
  var t;
}
function Wo(e) {
  return Ct(e) ? { scrollLeft: e.scrollLeft, scrollTop: e.scrollTop } : { scrollLeft: e.pageXOffset, scrollTop: e.pageYOffset };
}
function ja(e) {
  return tt(yt(e)).left + Wo(e).scrollLeft;
}
function Dd(e, t, n) {
  const o = Ue(t), r = yt(t), i = tt(e, o && function(s) {
    const l = tt(s);
    return So(l.width) !== s.offsetWidth || So(l.height) !== s.offsetHeight;
  }(t), n === "fixed");
  let c = { scrollLeft: 0, scrollTop: 0 };
  const a = { x: 0, y: 0 };
  if (o || !o && n !== "fixed")
    if ((et(t) !== "body" || Bo(r)) && (c = Wo(t)), Ue(t)) {
      const s = tt(t, !0);
      a.x = s.x + t.clientLeft, a.y = s.y + t.clientTop;
    } else
      r && (a.x = ja(r));
  return { x: i.left + c.scrollLeft - a.x, y: i.top + c.scrollTop - a.y, width: i.width, height: i.height };
}
function Ga(e) {
  return et(e) === "html" ? e : e.assignedSlot || e.parentNode || (ti(e) ? e.host : null) || yt(e);
}
function gc(e) {
  return Ue(e) && getComputedStyle(e).position !== "fixed" ? e.offsetParent : null;
}
function Tr(e) {
  const t = dt(e);
  let n = gc(e);
  for (; n && Td(n) && getComputedStyle(n).position === "static"; )
    n = gc(n);
  return n && (et(n) === "html" || et(n) === "body" && getComputedStyle(n).position === "static" && !hc(n)) ? t : n || function(o) {
    let r = Ga(o);
    for (ti(r) && (r = r.host); Ue(r) && !["html", "body"].includes(et(r)); ) {
      if (hc(r))
        return r;
      r = r.parentNode;
    }
    return null;
  }(e) || t;
}
function $c(e) {
  if (Ue(e))
    return { width: e.offsetWidth, height: e.offsetHeight };
  const t = tt(e);
  return { width: t.width, height: t.height };
}
function Xa(e) {
  const t = Ga(e);
  return ["html", "body", "#document"].includes(et(t)) ? e.ownerDocument.body : Ue(t) && Bo(t) ? t : Xa(t);
}
function Ao(e, t) {
  var n;
  t === void 0 && (t = []);
  const o = Xa(e), r = o === ((n = e.ownerDocument) == null ? void 0 : n.body), i = dt(o), c = r ? [i].concat(i.visualViewport || [], Bo(o) ? o : []) : o, a = t.concat(c);
  return r ? a : a.concat(Ao(c));
}
function bc(e, t, n) {
  return t === "viewport" ? Eo(function(o, r) {
    const i = dt(o), c = yt(o), a = i.visualViewport;
    let s = c.clientWidth, l = c.clientHeight, u = 0, d = 0;
    if (a) {
      s = a.width, l = a.height;
      const h = Ya();
      (h || !h && r === "fixed") && (u = a.offsetLeft, d = a.offsetTop);
    }
    return { width: s, height: l, x: u, y: d };
  }(e, n)) : Ct(t) ? function(o, r) {
    const i = tt(o, !1, r === "fixed"), c = i.top + o.clientTop, a = i.left + o.clientLeft;
    return { top: c, left: a, x: a, y: c, right: a + o.clientWidth, bottom: c + o.clientHeight, width: o.clientWidth, height: o.clientHeight };
  }(t, n) : Eo(function(o) {
    var r;
    const i = yt(o), c = Wo(o), a = (r = o.ownerDocument) == null ? void 0 : r.body, s = Dn(i.scrollWidth, i.clientWidth, a ? a.scrollWidth : 0, a ? a.clientWidth : 0), l = Dn(i.scrollHeight, i.clientHeight, a ? a.scrollHeight : 0, a ? a.clientHeight : 0);
    let u = -c.scrollLeft + ja(o);
    const d = -c.scrollTop;
    return Xn(a || i).direction === "rtl" && (u += Dn(i.clientWidth, a ? a.clientWidth : 0) - s), { width: s, height: l, x: u, y: d };
  }(yt(e)));
}
function Rd(e) {
  const t = Ao(e), n = ["absolute", "fixed"].includes(Xn(e).position) && Ue(e) ? Tr(e) : e;
  return Ct(n) ? t.filter((o) => Ct(o) && function(r, i) {
    const c = i.getRootNode == null ? void 0 : i.getRootNode();
    if (r.contains(i))
      return !0;
    if (c && ti(c)) {
      let a = i;
      do {
        if (a && r === a)
          return !0;
        a = a.parentNode || a.host;
      } while (a);
    }
    return !1;
  }(o, n) && et(o) !== "body") : [];
}
const Nd = { getClippingRect: function(e) {
  let { element: t, boundary: n, rootBoundary: o, strategy: r } = e;
  const i = [...n === "clippingAncestors" ? Rd(t) : [].concat(n), o], c = i[0], a = i.reduce((s, l) => {
    const u = bc(t, l, r);
    return s.top = Dn(u.top, s.top), s.right = mc(u.right, s.right), s.bottom = mc(u.bottom, s.bottom), s.left = Dn(u.left, s.left), s;
  }, bc(t, c, r));
  return { width: a.right - a.left, height: a.bottom - a.top, x: a.left, y: a.top };
}, convertOffsetParentRelativeRectToViewportRelativeRect: function(e) {
  let { rect: t, offsetParent: n, strategy: o } = e;
  const r = Ue(n), i = yt(n);
  if (n === i)
    return t;
  let c = { scrollLeft: 0, scrollTop: 0 };
  const a = { x: 0, y: 0 };
  if ((r || !r && o !== "fixed") && ((et(n) !== "body" || Bo(i)) && (c = Wo(n)), Ue(n))) {
    const s = tt(n, !0);
    a.x = s.x + n.clientLeft, a.y = s.y + n.clientTop;
  }
  return { ...t, x: t.x - c.scrollLeft + a.x, y: t.y - c.scrollTop + a.y };
}, isElement: Ct, getDimensions: $c, getOffsetParent: Tr, getDocumentElement: yt, getElementRects: (e) => {
  let { reference: t, floating: n, strategy: o } = e;
  return { reference: Dd(t, Tr(n), o), floating: { ...$c(n), x: 0, y: 0 } };
}, getClientRects: (e) => Array.from(e.getClientRects()), isRTL: (e) => Xn(e).direction === "rtl" };
function Id(e, t, n, o) {
  o === void 0 && (o = {});
  const { ancestorScroll: r = !0, ancestorResize: i = !0, elementResize: c = !0, animationFrame: a = !1 } = o, s = r && !a, l = i && !a, u = s || l ? [...Ct(e) ? Ao(e) : [], ...Ao(t)] : [];
  u.forEach((p) => {
    s && p.addEventListener("scroll", n, { passive: !0 }), l && p.addEventListener("resize", n);
  });
  let d, h = null;
  if (c) {
    let p = !0;
    h = new ResizeObserver(() => {
      p || n(), p = !1;
    }), Ct(e) && !a && h.observe(e), h.observe(t);
  }
  let v = a ? tt(e) : null;
  return a && function p() {
    const f = tt(e);
    !v || f.x === v.x && f.y === v.y && f.width === v.width && f.height === v.height || n(), v = f, d = requestAnimationFrame(p);
  }(), n(), () => {
    var p;
    u.forEach((f) => {
      s && f.removeEventListener("scroll", n), l && f.removeEventListener("resize", n);
    }), (p = h) == null || p.disconnect(), h = null, a && cancelAnimationFrame(d);
  };
}
const Ld = (e, t, n) => bd(e, t, { platform: Nd, ...n });
var Dr = typeof document < "u" ? jn : G;
function Rr(e, t) {
  if (e === t)
    return !0;
  if (typeof e != typeof t)
    return !1;
  if (typeof e == "function" && e.toString() === t.toString())
    return !0;
  let n, o, r;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (n = e.length, n != t.length)
        return !1;
      for (o = n; o-- !== 0; )
        if (!Rr(e[o], t[o]))
          return !1;
      return !0;
    }
    if (r = Object.keys(e), n = r.length, n !== Object.keys(t).length)
      return !1;
    for (o = n; o-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(t, r[o]))
        return !1;
    for (o = n; o-- !== 0; ) {
      const i = r[o];
      if (!(i === "_owner" && e.$$typeof) && !Rr(e[i], t[i]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function Md(e) {
  const t = H.useRef(e);
  return Dr(() => {
    t.current = e;
  }), t;
}
function kd(e) {
  let {
    middleware: t,
    placement: n = "bottom",
    strategy: o = "absolute",
    whileElementsMounted: r
  } = e === void 0 ? {} : e;
  const i = H.useRef(null), c = H.useRef(null), a = Md(r), s = H.useRef(null), [l, u] = H.useState({
    // Setting these to `null` will allow the consumer to determine if
    // `computePosition()` has run yet
    x: null,
    y: null,
    strategy: o,
    placement: n,
    middlewareData: {}
  }), [d, h] = H.useState(t);
  Rr(d == null ? void 0 : d.map((b) => {
    let {
      options: y
    } = b;
    return y;
  }), t == null ? void 0 : t.map((b) => {
    let {
      options: y
    } = b;
    return y;
  })) || h(t);
  const v = H.useCallback(() => {
    !i.current || !c.current || Ld(i.current, c.current, {
      middleware: d,
      placement: n,
      strategy: o
    }).then((b) => {
      p.current && la.flushSync(() => {
        u(b);
      });
    });
  }, [d, n, o]);
  Dr(() => {
    p.current && v();
  }, [v]);
  const p = H.useRef(!1);
  Dr(() => (p.current = !0, () => {
    p.current = !1;
  }), []);
  const f = H.useCallback(() => {
    if (typeof s.current == "function" && (s.current(), s.current = null), i.current && c.current)
      if (a.current) {
        const b = a.current(i.current, c.current, v);
        s.current = b;
      } else
        v();
  }, [v, a]), g = H.useCallback((b) => {
    i.current = b, f();
  }, [f]), m = H.useCallback((b) => {
    c.current = b, f();
  }, [f]), $ = H.useMemo(() => ({
    reference: i,
    floating: c
  }), []);
  return H.useMemo(() => ({
    ...l,
    update: v,
    refs: $,
    reference: g,
    floating: m
  }), [l, v, $, g, m]);
}
const Fd = (e) => {
  const {
    element: t,
    padding: n
  } = e;
  function o(r) {
    return Object.prototype.hasOwnProperty.call(r, "current");
  }
  return {
    name: "arrow",
    options: e,
    fn(r) {
      return o(t) ? t.current != null ? dc({
        element: t.current,
        padding: n
      }).fn(r) : {} : t ? dc({
        element: t,
        padding: n
      }).fn(r) : {};
    }
  };
}, Hd = /* @__PURE__ */ z((e, t) => {
  const { children: n, width: o = 10, height: r = 5, ...i } = e;
  return /* @__PURE__ */ E(ve.svg, F({}, i, {
    ref: t,
    width: o,
    height: r,
    viewBox: "0 0 30 10",
    preserveAspectRatio: "none"
  }), e.asChild ? n : /* @__PURE__ */ E("polygon", {
    points: "0,0 30,0 15,10"
  }));
}), Bd = Hd;
function Za(e) {
  const [t, n] = Y(void 0);
  return Ze(() => {
    if (e) {
      n({
        width: e.offsetWidth,
        height: e.offsetHeight
      });
      const o = new ResizeObserver((r) => {
        if (!Array.isArray(r) || !r.length)
          return;
        const i = r[0];
        let c, a;
        if ("borderBoxSize" in i) {
          const s = i.borderBoxSize, l = Array.isArray(s) ? s[0] : s;
          c = l.inlineSize, a = l.blockSize;
        } else
          c = e.offsetWidth, a = e.offsetHeight;
        n({
          width: c,
          height: a
        });
      });
      return o.observe(e, {
        box: "border-box"
      }), () => o.unobserve(e);
    } else
      n(void 0);
  }, [
    e
  ]), t;
}
const Ja = "Popper", [ni, Qa] = zt(Ja), [Wd, es] = ni(Ja), Vd = (e) => {
  const { __scopePopper: t, children: n } = e, [o, r] = Y(null);
  return /* @__PURE__ */ E(Wd, {
    scope: t,
    anchor: o,
    onAnchorChange: r
  }, n);
}, Ud = "PopperAnchor", zd = /* @__PURE__ */ z((e, t) => {
  const { __scopePopper: n, virtualRef: o, ...r } = e, i = es(Ud, n), c = j(null), a = we(t, c);
  return G(() => {
    i.onAnchorChange((o == null ? void 0 : o.current) || c.current);
  }), o ? null : /* @__PURE__ */ E(ve.div, F({}, r, {
    ref: a
  }));
}), Po = "PopperContent", [qd, Kd] = ni(Po), [Yd, jd] = ni(Po, {
  hasParent: !1,
  positionUpdateFns: /* @__PURE__ */ new Set()
}), Gd = /* @__PURE__ */ z((e, t) => {
  var n, o, r, i, c, a, s, l;
  const { __scopePopper: u, side: d = "bottom", sideOffset: h = 0, align: v = "center", alignOffset: p = 0, arrowPadding: f = 0, collisionBoundary: g = [], collisionPadding: m = 0, sticky: $ = "partial", hideWhenDetached: b = !1, avoidCollisions: y = !0, onPlaced: w, ..._ } = e, x = es(Po, u), [C, T] = Y(null), D = we(
    t,
    (Xt) => T(Xt)
  ), [S, A] = Y(null), O = Za(S), I = (n = O == null ? void 0 : O.width) !== null && n !== void 0 ? n : 0, M = (o = O == null ? void 0 : O.height) !== null && o !== void 0 ? o : 0, W = d + (v !== "center" ? "-" + v : ""), K = typeof m == "number" ? m : {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...m
  }, B = Array.isArray(g) ? g : [
    g
  ], V = B.length > 0, R = {
    padding: K,
    boundary: B.filter(ef),
    // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
    altBoundary: V
  }, { reference: U, floating: te, strategy: ue, x: re, y: de, placement: N, middlewareData: L, update: X } = kd({
    // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
    strategy: "fixed",
    placement: W,
    whileElementsMounted: Id,
    middleware: [
      tf(),
      Sd({
        mainAxis: h + M,
        alignmentAxis: p
      }),
      y ? Ad({
        mainAxis: !0,
        crossAxis: !1,
        limiter: $ === "partial" ? Pd() : void 0,
        ...R
      }) : void 0,
      S ? Fd({
        element: S,
        padding: f
      }) : void 0,
      y ? Ed({
        ...R
      }) : void 0,
      Od({
        ...R,
        apply: ({ elements: Xt, availableWidth: Rl, availableHeight: Nl }) => {
          Xt.floating.style.setProperty("--radix-popper-available-width", `${Rl}px`), Xt.floating.style.setProperty("--radix-popper-available-height", `${Nl}px`);
        }
      }),
      nf({
        arrowWidth: I,
        arrowHeight: M
      }),
      b ? _d({
        strategy: "referenceHidden"
      }) : void 0
    ].filter(Qd)
  });
  Ze(() => {
    U(x.anchor);
  }, [
    U,
    x.anchor
  ]);
  const J = re !== null && de !== null, [Z, ie] = ts(N), ne = wt(w);
  Ze(() => {
    J && (ne == null || ne());
  }, [
    J,
    ne
  ]);
  const k = (r = L.arrow) === null || r === void 0 ? void 0 : r.x, Q = (i = L.arrow) === null || i === void 0 ? void 0 : i.y, ye = ((c = L.arrow) === null || c === void 0 ? void 0 : c.centerOffset) !== 0, [Ee, je] = Y();
  Ze(() => {
    C && je(window.getComputedStyle(C).zIndex);
  }, [
    C
  ]);
  const { hasParent: sr, positionUpdateFns: vt } = jd(Po, u), We = !sr;
  jn(() => {
    if (!We)
      return vt.add(X), () => {
        vt.delete(X);
      };
  }, [
    We,
    vt,
    X
  ]), Ze(() => {
    We && J && Array.from(vt).reverse().forEach(
      (Xt) => requestAnimationFrame(Xt)
    );
  }, [
    We,
    J,
    vt
  ]);
  const Ji = {
    "data-side": Z,
    "data-align": ie,
    ..._,
    ref: D,
    style: {
      ..._.style,
      // if the PopperContent hasn't been placed yet (not all measurements done)
      // we prevent animations so that users's animation don't kick in too early referring wrong sides
      animation: J ? void 0 : "none",
      // hide the content if using the hide middleware and should be hidden
      opacity: (a = L.hide) !== null && a !== void 0 && a.referenceHidden ? 0 : void 0
    }
  };
  return /* @__PURE__ */ E("div", {
    ref: te,
    "data-radix-popper-content-wrapper": "",
    style: {
      position: ue,
      left: 0,
      top: 0,
      transform: J ? `translate3d(${Math.round(re)}px, ${Math.round(de)}px, 0)` : "translate3d(0, -200%, 0)",
      // keep off the page when measuring
      minWidth: "max-content",
      zIndex: Ee,
      "--radix-popper-transform-origin": [
        (s = L.transformOrigin) === null || s === void 0 ? void 0 : s.x,
        (l = L.transformOrigin) === null || l === void 0 ? void 0 : l.y
      ].join(" ")
    },
    dir: e.dir
  }, /* @__PURE__ */ E(qd, {
    scope: u,
    placedSide: Z,
    onArrowChange: A,
    arrowX: k,
    arrowY: Q,
    shouldHideArrow: ye
  }, We ? /* @__PURE__ */ E(Yd, {
    scope: u,
    hasParent: !0,
    positionUpdateFns: vt
  }, /* @__PURE__ */ E(ve.div, Ji)) : /* @__PURE__ */ E(ve.div, Ji)));
}), Xd = "PopperArrow", Zd = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, Jd = /* @__PURE__ */ z(function(t, n) {
  const { __scopePopper: o, ...r } = t, i = Kd(Xd, o), c = Zd[i.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ E("span", {
      ref: i.onArrowChange,
      style: {
        position: "absolute",
        left: i.arrowX,
        top: i.arrowY,
        [c]: 0,
        transformOrigin: {
          top: "",
          right: "0 0",
          bottom: "center 0",
          left: "100% 0"
        }[i.placedSide],
        transform: {
          top: "translateY(100%)",
          right: "translateY(50%) rotate(90deg) translateX(-50%)",
          bottom: "rotate(180deg)",
          left: "translateY(50%) rotate(-90deg) translateX(50%)"
        }[i.placedSide],
        visibility: i.shouldHideArrow ? "hidden" : void 0
      }
    }, /* @__PURE__ */ E(Bd, F({}, r, {
      ref: n,
      style: {
        ...r.style,
        // ensures the element can be measured correctly (mostly for if SVG)
        display: "block"
      }
    })))
  );
});
function Qd(e) {
  return e !== void 0;
}
function ef(e) {
  return e !== null;
}
const tf = () => ({
  name: "anchorCssProperties",
  fn(e) {
    const { rects: t, elements: n } = e, { width: o, height: r } = t.reference;
    return n.floating.style.setProperty("--radix-popper-anchor-width", `${o}px`), n.floating.style.setProperty("--radix-popper-anchor-height", `${r}px`), {};
  }
}), nf = (e) => ({
  name: "transformOrigin",
  options: e,
  fn(t) {
    var n, o, r, i, c;
    const { placement: a, rects: s, middlewareData: l } = t, d = ((n = l.arrow) === null || n === void 0 ? void 0 : n.centerOffset) !== 0, h = d ? 0 : e.arrowWidth, v = d ? 0 : e.arrowHeight, [p, f] = ts(a), g = {
      start: "0%",
      center: "50%",
      end: "100%"
    }[f], m = ((o = (r = l.arrow) === null || r === void 0 ? void 0 : r.x) !== null && o !== void 0 ? o : 0) + h / 2, $ = ((i = (c = l.arrow) === null || c === void 0 ? void 0 : c.y) !== null && i !== void 0 ? i : 0) + v / 2;
    let b = "", y = "";
    return p === "bottom" ? (b = d ? g : `${m}px`, y = `${-v}px`) : p === "top" ? (b = d ? g : `${m}px`, y = `${s.floating.height + v}px`) : p === "right" ? (b = `${-v}px`, y = d ? g : `${$}px`) : p === "left" && (b = `${s.floating.width + v}px`, y = d ? g : `${$}px`), {
      data: {
        x: b,
        y
      }
    };
  }
});
function ts(e) {
  const [t, n = "center"] = e.split("-");
  return [
    t,
    n
  ];
}
const of = Vd, rf = zd, cf = Gd, af = Jd, ns = "Popover", [os, pg] = zt(ns, [
  Qa
]), Vo = Qa(), [sf, Kt] = os(ns), lf = (e) => {
  const { __scopePopover: t, children: n, open: o, defaultOpen: r, onOpenChange: i, modal: c = !1 } = e, a = Vo(t), s = j(null), [l, u] = Y(!1), [d = !1, h] = Cn({
    prop: o,
    defaultProp: r,
    onChange: i
  });
  return /* @__PURE__ */ E(of, a, /* @__PURE__ */ E(sf, {
    scope: t,
    contentId: un(),
    triggerRef: s,
    open: d,
    onOpenChange: h,
    onOpenToggle: le(
      () => h(
        (v) => !v
      ),
      [
        h
      ]
    ),
    hasCustomAnchor: l,
    onCustomAnchorAdd: le(
      () => u(!0),
      []
    ),
    onCustomAnchorRemove: le(
      () => u(!1),
      []
    ),
    modal: c
  }, n));
}, uf = "PopoverTrigger", df = /* @__PURE__ */ z((e, t) => {
  const { __scopePopover: n, ...o } = e, r = Kt(uf, n), i = Vo(n), c = we(t, r.triggerRef), a = /* @__PURE__ */ E(ve.button, F({
    type: "button",
    "aria-haspopup": "dialog",
    "aria-expanded": r.open,
    "aria-controls": r.contentId,
    "data-state": cs(r.open)
  }, o, {
    ref: c,
    onClick: $e(e.onClick, r.onOpenToggle)
  }));
  return r.hasCustomAnchor ? a : /* @__PURE__ */ E(rf, F({
    asChild: !0
  }, i), a);
}), rs = "PopoverPortal", [ff, vf] = os(rs, {
  forceMount: void 0
}), pf = (e) => {
  const { __scopePopover: t, forceMount: n, children: o, container: r } = e, i = Kt(rs, t);
  return /* @__PURE__ */ E(ff, {
    scope: t,
    forceMount: n
  }, /* @__PURE__ */ E(Pt, {
    present: n || i.open
  }, /* @__PURE__ */ E($a, {
    asChild: !0,
    container: r
  }, o)));
}, kn = "PopoverContent", hf = /* @__PURE__ */ z((e, t) => {
  const n = vf(kn, e.__scopePopover), { forceMount: o = n.forceMount, ...r } = e, i = Kt(kn, e.__scopePopover);
  return /* @__PURE__ */ E(Pt, {
    present: o || i.open
  }, i.modal ? /* @__PURE__ */ E(mf, F({}, r, {
    ref: t
  })) : /* @__PURE__ */ E(gf, F({}, r, {
    ref: t
  })));
}), mf = /* @__PURE__ */ z((e, t) => {
  const n = Kt(kn, e.__scopePopover), o = j(null), r = we(t, o), i = j(!1);
  return G(() => {
    const c = o.current;
    if (c)
      return Jr(c);
  }, []), /* @__PURE__ */ E(Zr, {
    as: pn,
    allowPinchZoom: !0
  }, /* @__PURE__ */ E(is, F({}, e, {
    ref: r,
    trapFocus: n.open,
    disableOutsidePointerEvents: !0,
    onCloseAutoFocus: $e(e.onCloseAutoFocus, (c) => {
      var a;
      c.preventDefault(), i.current || (a = n.triggerRef.current) === null || a === void 0 || a.focus();
    }),
    onPointerDownOutside: $e(e.onPointerDownOutside, (c) => {
      const a = c.detail.originalEvent, s = a.button === 0 && a.ctrlKey === !0, l = a.button === 2 || s;
      i.current = l;
    }, {
      checkForDefaultPrevented: !1
    }),
    onFocusOutside: $e(
      e.onFocusOutside,
      (c) => c.preventDefault(),
      {
        checkForDefaultPrevented: !1
      }
    )
  })));
}), gf = /* @__PURE__ */ z((e, t) => {
  const n = Kt(kn, e.__scopePopover), o = j(!1);
  return /* @__PURE__ */ E(is, F({}, e, {
    ref: t,
    trapFocus: !1,
    disableOutsidePointerEvents: !1,
    onCloseAutoFocus: (r) => {
      var i;
      if ((i = e.onCloseAutoFocus) === null || i === void 0 || i.call(e, r), !r.defaultPrevented) {
        var c;
        o.current || (c = n.triggerRef.current) === null || c === void 0 || c.focus(), r.preventDefault();
      }
      o.current = !1;
    },
    onInteractOutside: (r) => {
      var i, c;
      (i = e.onInteractOutside) === null || i === void 0 || i.call(e, r), r.defaultPrevented || (o.current = !0);
      const a = r.target;
      ((c = n.triggerRef.current) === null || c === void 0 ? void 0 : c.contains(a)) && r.preventDefault();
    }
  }));
}), is = /* @__PURE__ */ z((e, t) => {
  const { __scopePopover: n, trapFocus: o, onOpenAutoFocus: r, onCloseAutoFocus: i, disableOutsidePointerEvents: c, onEscapeKeyDown: a, onPointerDownOutside: s, onFocusOutside: l, onInteractOutside: u, ...d } = e, h = Kt(kn, n), v = Vo(n);
  return ba(), /* @__PURE__ */ E(ma, {
    asChild: !0,
    loop: !0,
    trapped: o,
    onMountAutoFocus: r,
    onUnmountAutoFocus: i
  }, /* @__PURE__ */ E(pa, {
    asChild: !0,
    disableOutsidePointerEvents: c,
    onInteractOutside: u,
    onEscapeKeyDown: a,
    onPointerDownOutside: s,
    onFocusOutside: l,
    onDismiss: () => h.onOpenChange(!1)
  }, /* @__PURE__ */ E(cf, F({
    "data-state": cs(h.open),
    role: "dialog",
    id: h.contentId
  }, v, d, {
    ref: t,
    style: {
      ...d.style,
      "--radix-popover-content-transform-origin": "var(--radix-popper-transform-origin)",
      "--radix-popover-content-available-width": "var(--radix-popper-available-width)",
      "--radix-popover-content-available-height": "var(--radix-popper-available-height)",
      "--radix-popover-trigger-width": "var(--radix-popper-anchor-width)",
      "--radix-popover-trigger-height": "var(--radix-popper-anchor-height)"
    }
  }))));
}), $f = "PopoverClose", bf = /* @__PURE__ */ z((e, t) => {
  const { __scopePopover: n, ...o } = e, r = Kt($f, n);
  return /* @__PURE__ */ E(ve.button, F({
    type: "button"
  }, o, {
    ref: t,
    onClick: $e(
      e.onClick,
      () => r.onOpenChange(!1)
    )
  }));
}), yf = /* @__PURE__ */ z((e, t) => {
  const { __scopePopover: n, ...o } = e, r = Vo(n);
  return /* @__PURE__ */ E(af, F({}, r, o, {
    ref: t
  }));
});
function cs(e) {
  return e ? "open" : "closed";
}
const wf = lf, Cf = df, xf = pf, Ef = hf, _f = bf, Sf = yf, Af = "_content_1ibbd_2", Pf = "_close_1ibbd_18", Of = "_arrow_1ibbd_49", Tf = "_noStyle_1ibbd_56", en = {
  content: Af,
  close: Pf,
  arrow: Of,
  noStyle: Tf
};
function hg({
  className: e,
  arrow: {
    asChild: t,
    className: n,
    ...o
  },
  close: {
    asChild: r,
    className: i,
    closeLabel: c = "Close",
    ...a
  },
  content: {
    asChild: s,
    className: l,
    children: u,
    ...d
  },
  trigger: {
    asChild: h,
    children: v,
    className: p,
    ...f
  },
  preset: g = "default",
  onOpenChange: m
}) {
  const $ = {
    default: en.default,
    noStyle: en.noStyle
  };
  return /* @__PURE__ */ se(wf, { onOpenChange: m, children: [
    /* @__PURE__ */ P(
      Cf,
      {
        className: oe(en.trigger, p),
        asChild: h,
        ...f,
        children: v
      }
    ),
    /* @__PURE__ */ P(xf, { children: /* @__PURE__ */ se(
      Ef,
      {
        className: oe(en.content, $[g], e),
        asChild: s,
        sideOffset: 5,
        ...d,
        children: [
          /* @__PURE__ */ P(
            Sf,
            {
              className: oe(en.arrow, n),
              asChild: t,
              ...o
            }
          ),
          /* @__PURE__ */ P(
            _f,
            {
              className: oe(en.close, $[g], i),
              asChild: r,
              "aria-label": c,
              ...a,
              children: /* @__PURE__ */ P(Df, {})
            }
          ),
          u
        ]
      }
    ) })
  ] });
}
function Df() {
  return /* @__PURE__ */ P("svg", { xmlns: "http://www.w3.org/2000/svg", width: "512", height: "512", viewBox: "0 0 512 512", children: /* @__PURE__ */ P("path", { d: "M256 192.433L433.079 15.354c19.225-19.225 49.04-20.58 66.594-3.027 17.553 17.554 16.198 47.369-3.027 66.594L319.566 256l177.08 177.079c19.225 19.225 20.58 49.04 3.027 66.594-17.554 17.553-47.369 16.198-66.594-3.027L256 319.566 78.921 496.647c-19.225 19.225-49.04 20.58-66.594 3.027-17.553-17.554-16.198-47.369 3.027-66.594L192.434 256 15.353 78.921c-19.225-19.225-20.58-49.04-3.027-66.594C29.881-5.226 59.696-3.87 78.921 15.354L256 192.434z" }) });
}
function Rf(e) {
  const t = e + "CollectionProvider", [n, o] = zt(t), [r, i] = n(t, {
    collectionRef: {
      current: null
    },
    itemMap: /* @__PURE__ */ new Map()
  }), c = (v) => {
    const { scope: p, children: f } = v, g = q.useRef(null), m = q.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ q.createElement(r, {
      scope: p,
      itemMap: m,
      collectionRef: g
    }, f);
  }, a = e + "CollectionSlot", s = /* @__PURE__ */ q.forwardRef((v, p) => {
    const { scope: f, children: g } = v, m = i(a, f), $ = we(p, m.collectionRef);
    return /* @__PURE__ */ q.createElement(pn, {
      ref: $
    }, g);
  }), l = e + "CollectionItemSlot", u = "data-radix-collection-item", d = /* @__PURE__ */ q.forwardRef((v, p) => {
    const { scope: f, children: g, ...m } = v, $ = q.useRef(null), b = we(p, $), y = i(l, f);
    return q.useEffect(() => (y.itemMap.set($, {
      ref: $,
      ...m
    }), () => void y.itemMap.delete($))), /* @__PURE__ */ q.createElement(pn, {
      [u]: "",
      ref: b
    }, g);
  });
  function h(v) {
    const p = i(e + "CollectionConsumer", v);
    return q.useCallback(() => {
      const g = p.collectionRef.current;
      if (!g)
        return [];
      const m = Array.from(g.querySelectorAll(`[${u}]`));
      return Array.from(p.itemMap.values()).sort(
        (y, w) => m.indexOf(y.ref.current) - m.indexOf(w.ref.current)
      );
    }, [
      p.collectionRef,
      p.itemMap
    ]);
  }
  return [
    {
      Provider: c,
      Slot: s,
      ItemSlot: d
    },
    h,
    o
  ];
}
const as = "Collapsible", [Nf, ss] = zt(as), [If, oi] = Nf(as), Lf = /* @__PURE__ */ z((e, t) => {
  const { __scopeCollapsible: n, open: o, defaultOpen: r, disabled: i, onOpenChange: c, ...a } = e, [s = !1, l] = Cn({
    prop: o,
    defaultProp: r,
    onChange: c
  });
  return /* @__PURE__ */ E(If, {
    scope: n,
    disabled: i,
    contentId: un(),
    open: s,
    onOpenToggle: le(
      () => l(
        (u) => !u
      ),
      [
        l
      ]
    )
  }, /* @__PURE__ */ E(ve.div, F({
    "data-state": ri(s),
    "data-disabled": i ? "" : void 0
  }, a, {
    ref: t
  })));
}), Mf = "CollapsibleTrigger", kf = /* @__PURE__ */ z((e, t) => {
  const { __scopeCollapsible: n, ...o } = e, r = oi(Mf, n);
  return /* @__PURE__ */ E(ve.button, F({
    type: "button",
    "aria-controls": r.contentId,
    "aria-expanded": r.open || !1,
    "data-state": ri(r.open),
    "data-disabled": r.disabled ? "" : void 0,
    disabled: r.disabled
  }, o, {
    ref: t,
    onClick: $e(e.onClick, r.onOpenToggle)
  }));
}), ls = "CollapsibleContent", Ff = /* @__PURE__ */ z((e, t) => {
  const { forceMount: n, ...o } = e, r = oi(ls, e.__scopeCollapsible);
  return /* @__PURE__ */ E(
    Pt,
    {
      present: n || r.open
    },
    ({ present: i }) => /* @__PURE__ */ E(Hf, F({}, o, {
      ref: t,
      present: i
    }))
  );
}), Hf = /* @__PURE__ */ z((e, t) => {
  const { __scopeCollapsible: n, present: o, children: r, ...i } = e, c = oi(ls, n), [a, s] = Y(o), l = j(null), u = we(t, l), d = j(0), h = d.current, v = j(0), p = v.current, f = c.open || a, g = j(f), m = j();
  return G(() => {
    const $ = requestAnimationFrame(
      () => g.current = !1
    );
    return () => cancelAnimationFrame($);
  }, []), Ze(() => {
    const $ = l.current;
    if ($) {
      m.current = m.current || {
        transitionDuration: $.style.transitionDuration,
        animationName: $.style.animationName
      }, $.style.transitionDuration = "0s", $.style.animationName = "none";
      const b = $.getBoundingClientRect();
      d.current = b.height, v.current = b.width, g.current || ($.style.transitionDuration = m.current.transitionDuration, $.style.animationName = m.current.animationName), s(o);
    }
  }, [
    c.open,
    o
  ]), /* @__PURE__ */ E(ve.div, F({
    "data-state": ri(c.open),
    "data-disabled": c.disabled ? "" : void 0,
    id: c.contentId,
    hidden: !f
  }, i, {
    ref: u,
    style: {
      "--radix-collapsible-content-height": h ? `${h}px` : void 0,
      "--radix-collapsible-content-width": p ? `${p}px` : void 0,
      ...e.style
    }
  }), f && r);
});
function ri(e) {
  return e ? "open" : "closed";
}
const Bf = Lf, Wf = kf, Vf = Ff, Uf = /* @__PURE__ */ rt(void 0);
function zf(e) {
  const t = Vt(Uf);
  return e || t || "ltr";
}
const Ot = "Accordion", qf = [
  "Home",
  "End",
  "ArrowDown",
  "ArrowUp",
  "ArrowLeft",
  "ArrowRight"
], [ii, Kf, Yf] = Rf(Ot), [Uo, mg] = zt(Ot, [
  Yf,
  ss
]), ci = ss(), us = /* @__PURE__ */ q.forwardRef((e, t) => {
  const { type: n, ...o } = e, r = o, i = o;
  return /* @__PURE__ */ q.createElement(ii.Provider, {
    scope: e.__scopeAccordion
  }, n === "multiple" ? /* @__PURE__ */ q.createElement(Zf, F({}, i, {
    ref: t
  })) : /* @__PURE__ */ q.createElement(Xf, F({}, r, {
    ref: t
  })));
});
us.propTypes = {
  type(e) {
    const t = e.value || e.defaultValue;
    return e.type && ![
      "single",
      "multiple"
    ].includes(e.type) ? new Error("Invalid prop `type` supplied to `Accordion`. Expected one of `single | multiple`.") : e.type === "multiple" && typeof t == "string" ? new Error("Invalid prop `type` supplied to `Accordion`. Expected `single` when `defaultValue` or `value` is type `string`.") : e.type === "single" && Array.isArray(t) ? new Error("Invalid prop `type` supplied to `Accordion`. Expected `multiple` when `defaultValue` or `value` is type `string[]`.") : null;
  }
};
const [ds, jf] = Uo(Ot), [fs, Gf] = Uo(Ot, {
  collapsible: !1
}), Xf = /* @__PURE__ */ q.forwardRef((e, t) => {
  const { value: n, defaultValue: o, onValueChange: r = () => {
  }, collapsible: i = !1, ...c } = e, [a, s] = Cn({
    prop: n,
    defaultProp: o,
    onChange: r
  });
  return /* @__PURE__ */ q.createElement(ds, {
    scope: e.__scopeAccordion,
    value: a ? [
      a
    ] : [],
    onItemOpen: s,
    onItemClose: q.useCallback(
      () => i && s(""),
      [
        i,
        s
      ]
    )
  }, /* @__PURE__ */ q.createElement(fs, {
    scope: e.__scopeAccordion,
    collapsible: i
  }, /* @__PURE__ */ q.createElement(vs, F({}, c, {
    ref: t
  }))));
}), Zf = /* @__PURE__ */ q.forwardRef((e, t) => {
  const { value: n, defaultValue: o, onValueChange: r = () => {
  }, ...i } = e, [c = [], a] = Cn({
    prop: n,
    defaultProp: o,
    onChange: r
  }), s = q.useCallback(
    (u) => a(
      (d = []) => [
        ...d,
        u
      ]
    ),
    [
      a
    ]
  ), l = q.useCallback(
    (u) => a(
      (d = []) => d.filter(
        (h) => h !== u
      )
    ),
    [
      a
    ]
  );
  return /* @__PURE__ */ q.createElement(ds, {
    scope: e.__scopeAccordion,
    value: c,
    onItemOpen: s,
    onItemClose: l
  }, /* @__PURE__ */ q.createElement(fs, {
    scope: e.__scopeAccordion,
    collapsible: !0
  }, /* @__PURE__ */ q.createElement(vs, F({}, i, {
    ref: t
  }))));
}), [Jf, zo] = Uo(Ot), vs = /* @__PURE__ */ q.forwardRef((e, t) => {
  const { __scopeAccordion: n, disabled: o, dir: r, orientation: i = "vertical", ...c } = e, a = q.useRef(null), s = we(a, t), l = Kf(n), d = zf(r) === "ltr", h = $e(e.onKeyDown, (v) => {
    var p;
    if (!qf.includes(v.key))
      return;
    const f = v.target, g = l().filter((T) => {
      var D;
      return !((D = T.ref.current) !== null && D !== void 0 && D.disabled);
    }), m = g.findIndex(
      (T) => T.ref.current === f
    ), $ = g.length;
    if (m === -1)
      return;
    v.preventDefault();
    let b = m;
    const y = 0, w = $ - 1, _ = () => {
      b = m + 1, b > w && (b = y);
    }, x = () => {
      b = m - 1, b < y && (b = w);
    };
    switch (v.key) {
      case "Home":
        b = y;
        break;
      case "End":
        b = w;
        break;
      case "ArrowRight":
        i === "horizontal" && (d ? _() : x());
        break;
      case "ArrowDown":
        i === "vertical" && _();
        break;
      case "ArrowLeft":
        i === "horizontal" && (d ? x() : _());
        break;
      case "ArrowUp":
        i === "vertical" && x();
        break;
    }
    const C = b % $;
    (p = g[C].ref.current) === null || p === void 0 || p.focus();
  });
  return /* @__PURE__ */ q.createElement(Jf, {
    scope: n,
    disabled: o,
    direction: r,
    orientation: i
  }, /* @__PURE__ */ q.createElement(ii.Slot, {
    scope: n
  }, /* @__PURE__ */ q.createElement(ve.div, F({}, c, {
    "data-orientation": i,
    ref: s,
    onKeyDown: o ? void 0 : h
  }))));
}), Nr = "AccordionItem", [Qf, ai] = Uo(Nr), ev = /* @__PURE__ */ q.forwardRef((e, t) => {
  const { __scopeAccordion: n, value: o, ...r } = e, i = zo(Nr, n), c = jf(Nr, n), a = ci(n), s = un(), l = o && c.value.includes(o) || !1, u = i.disabled || e.disabled;
  return /* @__PURE__ */ q.createElement(Qf, {
    scope: n,
    open: l,
    disabled: u,
    triggerId: s
  }, /* @__PURE__ */ q.createElement(Bf, F({
    "data-orientation": i.orientation,
    "data-state": l ? "open" : "closed"
  }, a, r, {
    ref: t,
    disabled: u,
    open: l,
    onOpenChange: (d) => {
      d ? c.onItemOpen(o) : c.onItemClose(o);
    }
  })));
}), tv = "AccordionHeader", nv = /* @__PURE__ */ q.forwardRef((e, t) => {
  const { __scopeAccordion: n, ...o } = e, r = zo(Ot, n), i = ai(tv, n);
  return /* @__PURE__ */ q.createElement(ve.h3, F({
    "data-orientation": r.orientation,
    "data-state": cv(i.open),
    "data-disabled": i.disabled ? "" : void 0
  }, o, {
    ref: t
  }));
}), yc = "AccordionTrigger", ov = /* @__PURE__ */ q.forwardRef((e, t) => {
  const { __scopeAccordion: n, ...o } = e, r = zo(Ot, n), i = ai(yc, n), c = Gf(yc, n), a = ci(n);
  return /* @__PURE__ */ q.createElement(ii.ItemSlot, {
    scope: n
  }, /* @__PURE__ */ q.createElement(Wf, F({
    "aria-disabled": i.open && !c.collapsible || void 0,
    "data-orientation": r.orientation,
    id: i.triggerId
  }, a, o, {
    ref: t
  })));
}), rv = "AccordionContent", iv = /* @__PURE__ */ q.forwardRef((e, t) => {
  const { __scopeAccordion: n, ...o } = e, r = zo(Ot, n), i = ai(rv, n), c = ci(n);
  return /* @__PURE__ */ q.createElement(Vf, F({
    role: "region",
    "aria-labelledby": i.triggerId,
    "data-orientation": r.orientation
  }, c, o, {
    ref: t,
    style: {
      "--radix-accordion-content-height": "var(--radix-collapsible-content-height)",
      "--radix-accordion-content-width": "var(--radix-collapsible-content-width)",
      ...e.style
    }
  }));
});
function cv(e) {
  return e ? "open" : "closed";
}
const wc = us, av = ev, sv = nv, lv = ov, uv = iv;
function ps(e, t) {
  if (e == null)
    return {};
  var n = {}, o = Object.keys(e), r, i;
  for (i = 0; i < o.length; i++)
    r = o[i], !(t.indexOf(r) >= 0) && (n[r] = e[r]);
  return n;
}
var dv = ["color"], fv = /* @__PURE__ */ z(function(e, t) {
  var n = e.color, o = n === void 0 ? "currentColor" : n, r = ps(e, dv);
  return E("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, r, {
    ref: t
  }), E("path", {
    d: "M2.25 7.5C2.25 7.22386 2.47386 7 2.75 7H12.25C12.5261 7 12.75 7.22386 12.75 7.5C12.75 7.77614 12.5261 8 12.25 8H2.75C2.47386 8 2.25 7.77614 2.25 7.5Z",
    fill: o,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
}), vv = ["color"], pv = /* @__PURE__ */ z(function(e, t) {
  var n = e.color, o = n === void 0 ? "currentColor" : n, r = ps(e, vv);
  return E("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, r, {
    ref: t
  }), E("path", {
    d: "M8 2.75C8 2.47386 7.77614 2.25 7.5 2.25C7.22386 2.25 7 2.47386 7 2.75V7H2.75C2.47386 7 2.25 7.22386 2.25 7.5C2.25 7.77614 2.47386 8 2.75 8H7V12.25C7 12.5261 7.22386 12.75 7.5 12.75C7.77614 12.75 8 12.5261 8 12.25V8H12.25C12.5261 8 12.75 7.77614 12.75 7.5C12.75 7.22386 12.5261 7 12.25 7H8V2.75Z",
    fill: o,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});
const hv = "_trigger_jepmi_3", mv = "_faq_jepmi_12", gv = "_item_jepmi_12", $v = "_header_jepmi_16", bv = "_panel_jepmi_25", yv = "_faqTriggerWrapper_jepmi_34", wv = "_minus_jepmi_39", Cv = "_plus_jepmi_45", xv = "_faqTrigger_jepmi_34", Ev = "_slideDown_jepmi_1", _v = "_slideUp_jepmi_1", Pe = {
  trigger: hv,
  faq: mv,
  item: gv,
  header: $v,
  panel: bv,
  faqTriggerWrapper: yv,
  minus: wv,
  plus: Cv,
  faqTrigger: xv,
  slideDown: Ev,
  slideUp: _v
};
function Sv({
  value: e,
  asChild: t,
  className: n,
  trigger: {
    asChild: o,
    triggerNode: r,
    className: i,
    ...c
  },
  header: {
    asChild: a,
    className: s,
    ...l
  } = {},
  panel: {
    asChild: u,
    className: d,
    ...h
  } = {},
  children: v,
  preset: p = "default",
  ...f
}) {
  return p === "faq" && (i = Pe.faqTriggerWrapper, r = /* @__PURE__ */ se("div", { className: Pe.faqTrigger, children: [
    r,
    /* @__PURE__ */ P(pv, { className: Pe.plus }),
    /* @__PURE__ */ P(fv, { className: Pe.minus })
  ] })), /* @__PURE__ */ se(
    av,
    {
      value: e,
      asChild: t,
      className: oe(Pe.item, n),
      ...f,
      children: [
        /* @__PURE__ */ P(
          sv,
          {
            asChild: t,
            className: oe(Pe.header, s),
            ...l,
            children: /* @__PURE__ */ P(
              lv,
              {
                asChild: o,
                className: oe(Pe.trigger, i),
                ...c,
                children: r
              }
            )
          }
        ),
        /* @__PURE__ */ P(
          uv,
          {
            asChild: u,
            className: oe(Pe.panel, d),
            ...h,
            children: v
          }
        )
      ]
    }
  );
}
function Cc(e, t) {
  return e.map((n, o) => /* @__PURE__ */ P(
    Sv,
    {
      value: n.value,
      trigger: n.trigger,
      panel: n.panel,
      preset: t,
      children: n.children
    },
    `${o}-${n.trigger}`
  ));
}
function gg({
  accordionItems: e,
  preset: t = "default",
  type: n,
  className: o,
  collapsible: r = !0,
  value: i,
  defaultValue: c,
  disabled: a,
  onValueChange: s
}) {
  const l = {
    default: Pe.default,
    faq: Pe.faq
  };
  return n === "multiple" ? /* @__PURE__ */ P(
    wc,
    {
      className: oe(Pe.accordion, l[t], o),
      type: n,
      value: Array.isArray(i) ? i : void 0,
      defaultValue: Array.isArray(c) ? c : void 0,
      disabled: a,
      onValueChange: s,
      children: Cc(e, t)
    }
  ) : /* @__PURE__ */ P(
    wc,
    {
      className: oe(Pe.accordion, l[t], o),
      type: n,
      value: typeof i == "string" ? i : void 0,
      defaultValue: typeof c == "string" ? c : void 0,
      disabled: a,
      collapsible: r,
      onValueChange: s,
      children: Cc(e, t)
    }
  );
}
const Av = "_container_15w4n_1", Pv = "_clickable_15w4n_10", Ov = "_content_15w4n_14", Tv = "_withClose_15w4n_18", Dv = "_open_15w4n_22", Rv = "_close_15w4n_27", tn = {
  container: Av,
  clickable: Pv,
  content: Ov,
  withClose: Tv,
  open: Dv,
  close: Rv
};
function $g({
  close: e,
  containerClassName: t,
  content: n,
  onBannerClick: o
}) {
  const [r, i] = Y(!1), c = () => {
    i(!0);
  }, a = () => {
    i(!1), e && e.onCloseClick;
  };
  return G(() => {
    c();
  }, []), /* @__PURE__ */ se(
    "div",
    {
      className: oe(
        tn.container,
        r && tn.open,
        t,
        o && tn.clickable
      ),
      onClick: o,
      children: [
        /* @__PURE__ */ P(
          "div",
          {
            className: oe(
              tn.content,
              e && tn.withClose,
              n.className
            ),
            children: n.children
          }
        ),
        e && /* @__PURE__ */ P(
          "button",
          {
            onClick: a,
            className: oe(tn.close, e.className),
            "aria-label": e.closeLabel,
            children: /* @__PURE__ */ P(Nv, {})
          }
        )
      ]
    }
  );
}
function Nv() {
  return /* @__PURE__ */ P("svg", { xmlns: "http://www.w3.org/2000/svg", width: "512", height: "512", viewBox: "0 0 512 512", children: /* @__PURE__ */ P("path", { d: "M256 192.433L433.079 15.354c19.225-19.225 49.04-20.58 66.594-3.027 17.553 17.554 16.198 47.369-3.027 66.594L319.566 256l177.08 177.079c19.225 19.225 20.58 49.04 3.027 66.594-17.554 17.553-47.369 16.198-66.594-3.027L256 319.566 78.921 496.647c-19.225 19.225-49.04 20.58-66.594 3.027-17.553-17.554-16.198-47.369 3.027-66.594L192.434 256 15.353 78.921c-19.225-19.225-20.58-49.04-3.027-66.594C29.881-5.226 59.696-3.87 78.921 15.354L256 192.434z" }) });
}
const Iv = "_card_186fi_1", Lv = "_content_186fi_11", Mv = "_cardClickable_186fi_15", kv = "_flag_186fi_19", Tn = {
  card: Iv,
  content: Lv,
  cardClickable: Mv,
  flag: kv
};
function bg({
  className: e = "",
  children: t,
  contentClassName: n = "",
  flag: o = "",
  flagClassName: r = "",
  onClick: i
}) {
  const c = i !== void 0;
  return /* @__PURE__ */ se(
    "div",
    {
      onClick: c ? i : () => {
      },
      className: oe(
        {
          [Tn.card]: !0,
          [Tn.cardFlag]: o,
          [Tn.cardClickable]: c
        },
        e
      ),
      children: [
        o && /* @__PURE__ */ P("div", { className: oe(Tn.flag, r), children: o }),
        /* @__PURE__ */ P("div", { className: oe(Tn.content, n), children: t })
      ]
    }
  );
}
function Fv(e) {
  const t = j({
    value: e,
    previous: e
  });
  return Fe(() => (t.current.value !== e && (t.current.previous = t.current.value, t.current.value = e), t.current.previous), [
    e
  ]);
}
const hs = "Checkbox", [Hv, yg] = zt(hs), [Bv, Wv] = Hv(hs), Vv = /* @__PURE__ */ z((e, t) => {
  const { __scopeCheckbox: n, name: o, checked: r, defaultChecked: i, required: c, disabled: a, value: s = "on", onCheckedChange: l, ...u } = e, [d, h] = Y(null), v = we(
    t,
    (b) => h(b)
  ), p = j(!1), f = d ? !!d.closest("form") : !0, [g = !1, m] = Cn({
    prop: r,
    defaultProp: i,
    onChange: l
  }), $ = j(g);
  return G(() => {
    const b = d == null ? void 0 : d.form;
    if (b) {
      const y = () => m($.current);
      return b.addEventListener("reset", y), () => b.removeEventListener("reset", y);
    }
  }, [
    d,
    m
  ]), /* @__PURE__ */ E(Bv, {
    scope: n,
    state: g,
    disabled: a
  }, /* @__PURE__ */ E(ve.button, F({
    type: "button",
    role: "checkbox",
    "aria-checked": Mt(g) ? "mixed" : g,
    "aria-required": c,
    "data-state": ms(g),
    "data-disabled": a ? "" : void 0,
    disabled: a,
    value: s
  }, u, {
    ref: v,
    onKeyDown: $e(e.onKeyDown, (b) => {
      b.key === "Enter" && b.preventDefault();
    }),
    onClick: $e(e.onClick, (b) => {
      m(
        (y) => Mt(y) ? !0 : !y
      ), f && (p.current = b.isPropagationStopped(), p.current || b.stopPropagation());
    })
  })), f && /* @__PURE__ */ E(qv, {
    control: d,
    bubbles: !p.current,
    name: o,
    value: s,
    checked: g,
    required: c,
    disabled: a,
    style: {
      transform: "translateX(-100%)"
    }
  }));
}), Uv = "CheckboxIndicator", zv = /* @__PURE__ */ z((e, t) => {
  const { __scopeCheckbox: n, forceMount: o, ...r } = e, i = Wv(Uv, n);
  return /* @__PURE__ */ E(Pt, {
    present: o || Mt(i.state) || i.state === !0
  }, /* @__PURE__ */ E(ve.span, F({
    "data-state": ms(i.state),
    "data-disabled": i.disabled ? "" : void 0
  }, r, {
    ref: t,
    style: {
      pointerEvents: "none",
      ...e.style
    }
  })));
}), qv = (e) => {
  const { control: t, checked: n, bubbles: o = !0, ...r } = e, i = j(null), c = Fv(n), a = Za(t);
  return G(() => {
    const s = i.current, l = window.HTMLInputElement.prototype, d = Object.getOwnPropertyDescriptor(l, "checked").set;
    if (c !== n && d) {
      const h = new Event("click", {
        bubbles: o
      });
      s.indeterminate = Mt(n), d.call(s, Mt(n) ? !1 : n), s.dispatchEvent(h);
    }
  }, [
    c,
    n,
    o
  ]), /* @__PURE__ */ E("input", F({
    type: "checkbox",
    "aria-hidden": !0,
    defaultChecked: Mt(n) ? !1 : n
  }, r, {
    tabIndex: -1,
    ref: i,
    style: {
      ...e.style,
      ...a,
      position: "absolute",
      pointerEvents: "none",
      opacity: 0,
      margin: 0
    }
  }));
};
function Mt(e) {
  return e === "indeterminate";
}
function ms(e) {
  return Mt(e) ? "indeterminate" : e ? "checked" : "unchecked";
}
const Kv = Vv, Yv = zv, jv = "_wrapper_1pcrt_2", Gv = "_root_1pcrt_7", Xv = "_indicator_1pcrt_44", Zv = "_label_1pcrt_54", Jv = "_noStyle_1pcrt_61", Qv = "_pill_1pcrt_81", ep = "_pillLong_1pcrt_82", pt = {
  wrapper: jv,
  root: Gv,
  indicator: Xv,
  label: Zv,
  noStyle: Jv,
  pill: Qv,
  pillLong: ep
};
function tp({
  attributes: e,
  checkboxClassName: t = "",
  disabled: n = !1,
  id: o = "",
  indicator: {
    asChild: r,
    className: i,
    ...c
  },
  label: a,
  labelClassName: s = "",
  name: l = "",
  preset: u = "default",
  onCheckedChange: d,
  ...h
}) {
  const v = {
    default: pt.default,
    pill: pt.pill,
    pillLong: pt.pillLong,
    noStyle: pt.noStyle
  };
  return /* @__PURE__ */ se("div", { className: oe(pt.wrapper, v[u]), children: [
    /* @__PURE__ */ P(
      Kv,
      {
        className: oe(pt.root, v[u], t),
        disabled: n,
        id: o,
        name: l,
        onCheckedChange: d,
        ...e,
        ...h,
        children: /* @__PURE__ */ P(
          Yv,
          {
            className: oe(
              pt.indicator,
              v[u],
              i
            ),
            asChild: r,
            ...c,
            children: /* @__PURE__ */ P(np, {})
          }
        )
      }
    ),
    a && /* @__PURE__ */ P(
      "label",
      {
        className: oe(pt.label, s),
        ...e,
        htmlFor: o,
        children: a
      }
    )
  ] });
}
function np() {
  return /* @__PURE__ */ P(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "512",
      height: "512",
      viewBox: "0 0 512 512",
      children: /* @__PURE__ */ P("path", { d: "M184.35 446.99c-11.86 0-23.72-4.53-32.77-13.57l-138.01-138c-18.1-18.1-18.1-47.44 0-65.53 18.1-18.09 47.43-18.09 65.53 0l105.24 105.24L432.89 86.57c18.1-18.09 47.43-18.09 65.53 0 18.1 18.1 18.1 47.44 0 65.53L217.11 433.42c-9.05 9.04-20.9 13.57-32.76 13.57z" })
    }
  );
}
const op = "_headingH1_tvhb2_3", rp = "_headingH2_tvhb2_15", ip = "_headingH3_tvhb2_27", cp = "_headingH4_tvhb2_39", ap = "_headingH5_tvhb2_51", sp = "_headingH6_tvhb2_63", lp = {
  headingH1: op,
  headingH2: rp,
  headingH3: ip,
  headingH4: cp,
  headingH5: ap,
  headingH6: sp
};
function up({
  children: e,
  ariaLevel: t,
  className: n,
  ...o
}) {
  const r = `h${t}`;
  return /* @__PURE__ */ P(
    r,
    {
      className: oe(lp[`headingH${t}`], n),
      role: "heading",
      "aria-level": t,
      ...o,
      children: e
    }
  );
}
const dp = "_wrapper_yfwyx_1", fp = "_inlineCheckboxes_yfwyx_6", hr = {
  wrapper: dp,
  inlineCheckboxes: fp
};
function wg({
  heading: e,
  headingClassName: t = "",
  checkboxLabelClassName: n = "",
  checkboxLabelSelectedClassName: o = "",
  checkboxClassName: r = "",
  checkboxSelectedClassName: i = "",
  checkboxesData: c,
  onCheckedChange: a,
  preset: s = "pill"
}) {
  return /* @__PURE__ */ se(sa, { children: [
    e && /* @__PURE__ */ P(up, { ariaLevel: 2, className: t, children: e }),
    /* @__PURE__ */ P(
      "span",
      {
        className: oe(hr.wrapper, {
          [hr.inlineCheckboxes]: s === "pill"
        }),
        children: c.map((l) => /* @__PURE__ */ P(
          tp,
          {
            attributes: l.attributes,
            preset: s,
            id: l.id,
            onCheckedChange: (u) => {
              a(
                !!u,
                l.id,
                l.label
              );
            },
            defaultChecked: l.checked,
            label: l.label,
            labelClassName: oe(
              hr.label,
              n,
              l.checked && o
            ),
            checkboxClassName: oe(
              r,
              l.checked && i
            ),
            indicator: {
              className: ""
            }
          },
          l.id
        ))
      }
    )
  ] });
}
var gs = 60, $s = gs * 60, bs = $s * 24, vp = bs * 7, hn = 1e3, mr = gs * hn, xc = $s * hn, pp = bs * hn, hp = vp * hn, si = "millisecond", rn = "second", cn = "minute", an = "hour", gt = "day", $o = "week", Le = "month", ys = "quarter", $t = "year", sn = "date", mp = "YYYY-MM-DDTHH:mm:ssZ", Ec = "Invalid Date", gp = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, $p = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g;
const bp = {
  name: "en",
  weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
  months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
  ordinal: function(t) {
    var n = ["th", "st", "nd", "rd"], o = t % 100;
    return "[" + t + (n[(o - 20) % 10] || n[o] || n[0]) + "]";
  }
};
var Ir = function(t, n, o) {
  var r = String(t);
  return !r || r.length >= n ? t : "" + Array(n + 1 - r.length).join(o) + t;
}, yp = function(t) {
  var n = -t.utcOffset(), o = Math.abs(n), r = Math.floor(o / 60), i = o % 60;
  return (n <= 0 ? "+" : "-") + Ir(r, 2, "0") + ":" + Ir(i, 2, "0");
}, wp = function e(t, n) {
  if (t.date() < n.date())
    return -e(n, t);
  var o = (n.year() - t.year()) * 12 + (n.month() - t.month()), r = t.clone().add(o, Le), i = n - r < 0, c = t.clone().add(o + (i ? -1 : 1), Le);
  return +(-(o + (n - r) / (i ? r - c : c - r)) || 0);
}, Cp = function(t) {
  return t < 0 ? Math.ceil(t) || 0 : Math.floor(t);
}, xp = function(t) {
  var n = {
    M: Le,
    y: $t,
    w: $o,
    d: gt,
    D: sn,
    h: an,
    m: cn,
    s: rn,
    ms: si,
    Q: ys
  };
  return n[t] || String(t || "").toLowerCase().replace(/s$/, "");
}, Ep = function(t) {
  return t === void 0;
};
const _p = {
  s: Ir,
  z: yp,
  m: wp,
  a: Cp,
  p: xp,
  u: Ep
};
var Rn = "en", kt = {};
kt[Rn] = bp;
var ws = "$isDayjsObject", li = function(t) {
  return t instanceof qo || !!(t && t[ws]);
}, Oo = function e(t, n, o) {
  var r;
  if (!t)
    return Rn;
  if (typeof t == "string") {
    var i = t.toLowerCase();
    kt[i] && (r = i), n && (kt[i] = n, r = i);
    var c = t.split("-");
    if (!r && c.length > 1)
      return e(c[0]);
  } else {
    var a = t.name;
    kt[a] = t, r = a;
  }
  return !o && r && (Rn = r), r || !o && Rn;
}, me = function(t, n) {
  if (li(t))
    return t.clone();
  var o = typeof n == "object" ? n : {};
  return o.date = t, o.args = arguments, new qo(o);
}, Sp = function(t, n) {
  return me(t, {
    locale: n.$L,
    utc: n.$u,
    x: n.$x,
    $offset: n.$offset
    // todo: refactor; do not use this.$offset in you code
  });
}, ce = _p;
ce.l = Oo;
ce.i = li;
ce.w = Sp;
var Ap = function(t) {
  var n = t.date, o = t.utc;
  if (n === null)
    return /* @__PURE__ */ new Date(NaN);
  if (ce.u(n))
    return /* @__PURE__ */ new Date();
  if (n instanceof Date)
    return new Date(n);
  if (typeof n == "string" && !/Z$/i.test(n)) {
    var r = n.match(gp);
    if (r) {
      var i = r[2] - 1 || 0, c = (r[7] || "0").substring(0, 3);
      return o ? new Date(Date.UTC(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, c)) : new Date(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, c);
    }
  }
  return new Date(n);
}, qo = /* @__PURE__ */ function() {
  function e(n) {
    this.$L = Oo(n.locale, null, !0), this.parse(n), this.$x = this.$x || n.x || {}, this[ws] = !0;
  }
  var t = e.prototype;
  return t.parse = function(o) {
    this.$d = Ap(o), this.init();
  }, t.init = function() {
    var o = this.$d;
    this.$y = o.getFullYear(), this.$M = o.getMonth(), this.$D = o.getDate(), this.$W = o.getDay(), this.$H = o.getHours(), this.$m = o.getMinutes(), this.$s = o.getSeconds(), this.$ms = o.getMilliseconds();
  }, t.$utils = function() {
    return ce;
  }, t.isValid = function() {
    return this.$d.toString() !== Ec;
  }, t.isSame = function(o, r) {
    var i = me(o);
    return this.startOf(r) <= i && i <= this.endOf(r);
  }, t.isAfter = function(o, r) {
    return me(o) < this.startOf(r);
  }, t.isBefore = function(o, r) {
    return this.endOf(r) < me(o);
  }, t.$g = function(o, r, i) {
    return ce.u(o) ? this[r] : this.set(i, o);
  }, t.unix = function() {
    return Math.floor(this.valueOf() / 1e3);
  }, t.valueOf = function() {
    return this.$d.getTime();
  }, t.startOf = function(o, r) {
    var i = this, c = ce.u(r) ? !0 : r, a = ce.p(o), s = function(m, $) {
      var b = ce.w(i.$u ? Date.UTC(i.$y, $, m) : new Date(i.$y, $, m), i);
      return c ? b : b.endOf(gt);
    }, l = function(m, $) {
      var b = [0, 0, 0, 0], y = [23, 59, 59, 999];
      return ce.w(i.toDate()[m].apply(
        // eslint-disable-line prefer-spread
        i.toDate("s"),
        (c ? b : y).slice($)
      ), i);
    }, u = this.$W, d = this.$M, h = this.$D, v = "set" + (this.$u ? "UTC" : "");
    switch (a) {
      case $t:
        return c ? s(1, 0) : s(31, 11);
      case Le:
        return c ? s(1, d) : s(0, d + 1);
      case $o: {
        var p = this.$locale().weekStart || 0, f = (u < p ? u + 7 : u) - p;
        return s(c ? h - f : h + (6 - f), d);
      }
      case gt:
      case sn:
        return l(v + "Hours", 0);
      case an:
        return l(v + "Minutes", 1);
      case cn:
        return l(v + "Seconds", 2);
      case rn:
        return l(v + "Milliseconds", 3);
      default:
        return this.clone();
    }
  }, t.endOf = function(o) {
    return this.startOf(o, !1);
  }, t.$set = function(o, r) {
    var i, c = ce.p(o), a = "set" + (this.$u ? "UTC" : ""), s = (i = {}, i[gt] = a + "Date", i[sn] = a + "Date", i[Le] = a + "Month", i[$t] = a + "FullYear", i[an] = a + "Hours", i[cn] = a + "Minutes", i[rn] = a + "Seconds", i[si] = a + "Milliseconds", i)[c], l = c === gt ? this.$D + (r - this.$W) : r;
    if (c === Le || c === $t) {
      var u = this.clone().set(sn, 1);
      u.$d[s](l), u.init(), this.$d = u.set(sn, Math.min(this.$D, u.daysInMonth())).$d;
    } else
      s && this.$d[s](l);
    return this.init(), this;
  }, t.set = function(o, r) {
    return this.clone().$set(o, r);
  }, t.get = function(o) {
    return this[ce.p(o)]();
  }, t.add = function(o, r) {
    var i = this, c;
    o = Number(o);
    var a = ce.p(r), s = function(h) {
      var v = me(i);
      return ce.w(v.date(v.date() + Math.round(h * o)), i);
    };
    if (a === Le)
      return this.set(Le, this.$M + o);
    if (a === $t)
      return this.set($t, this.$y + o);
    if (a === gt)
      return s(1);
    if (a === $o)
      return s(7);
    var l = (c = {}, c[cn] = mr, c[an] = xc, c[rn] = hn, c)[a] || 1, u = this.$d.getTime() + o * l;
    return ce.w(u, this);
  }, t.subtract = function(o, r) {
    return this.add(o * -1, r);
  }, t.format = function(o) {
    var r = this, i = this.$locale();
    if (!this.isValid())
      return i.invalidDate || Ec;
    var c = o || mp, a = ce.z(this), s = this.$H, l = this.$m, u = this.$M, d = i.weekdays, h = i.months, v = i.meridiem, p = function(b, y, w, _) {
      return b && (b[y] || b(r, c)) || w[y].slice(0, _);
    }, f = function(b) {
      return ce.s(s % 12 || 12, b, "0");
    }, g = v || function($, b, y) {
      var w = $ < 12 ? "AM" : "PM";
      return y ? w.toLowerCase() : w;
    }, m = function(b) {
      switch (b) {
        case "YY":
          return String(r.$y).slice(-2);
        case "YYYY":
          return ce.s(r.$y, 4, "0");
        case "M":
          return u + 1;
        case "MM":
          return ce.s(u + 1, 2, "0");
        case "MMM":
          return p(i.monthsShort, u, h, 3);
        case "MMMM":
          return p(h, u);
        case "D":
          return r.$D;
        case "DD":
          return ce.s(r.$D, 2, "0");
        case "d":
          return String(r.$W);
        case "dd":
          return p(i.weekdaysMin, r.$W, d, 2);
        case "ddd":
          return p(i.weekdaysShort, r.$W, d, 3);
        case "dddd":
          return d[r.$W];
        case "H":
          return String(s);
        case "HH":
          return ce.s(s, 2, "0");
        case "h":
          return f(1);
        case "hh":
          return f(2);
        case "a":
          return g(s, l, !0);
        case "A":
          return g(s, l, !1);
        case "m":
          return String(l);
        case "mm":
          return ce.s(l, 2, "0");
        case "s":
          return String(r.$s);
        case "ss":
          return ce.s(r.$s, 2, "0");
        case "SSS":
          return ce.s(r.$ms, 3, "0");
        case "Z":
          return a;
      }
      return null;
    };
    return c.replace($p, function($, b) {
      return b || m($) || a.replace(":", "");
    });
  }, t.utcOffset = function() {
    return -Math.round(this.$d.getTimezoneOffset() / 15) * 15;
  }, t.diff = function(o, r, i) {
    var c = this, a = ce.p(r), s = me(o), l = (s.utcOffset() - this.utcOffset()) * mr, u = this - s, d = function() {
      return ce.m(c, s);
    }, h;
    switch (a) {
      case $t:
        h = d() / 12;
        break;
      case Le:
        h = d();
        break;
      case ys:
        h = d() / 3;
        break;
      case $o:
        h = (u - l) / hp;
        break;
      case gt:
        h = (u - l) / pp;
        break;
      case an:
        h = u / xc;
        break;
      case cn:
        h = u / mr;
        break;
      case rn:
        h = u / hn;
        break;
      default:
        h = u;
        break;
    }
    return i ? h : ce.a(h);
  }, t.daysInMonth = function() {
    return this.endOf(Le).$D;
  }, t.$locale = function() {
    return kt[this.$L];
  }, t.locale = function(o, r) {
    if (!o)
      return this.$L;
    var i = this.clone(), c = Oo(o, r, !0);
    return c && (i.$L = c), i;
  }, t.clone = function() {
    return ce.w(this.$d, this);
  }, t.toDate = function() {
    return new Date(this.valueOf());
  }, t.toJSON = function() {
    return this.isValid() ? this.toISOString() : null;
  }, t.toISOString = function() {
    return this.$d.toISOString();
  }, t.toString = function() {
    return this.$d.toUTCString();
  }, e;
}(), Cs = qo.prototype;
me.prototype = Cs;
[["$ms", si], ["$s", rn], ["$m", cn], ["$H", an], ["$W", gt], ["$M", Le], ["$y", $t], ["$D", sn]].forEach(function(e) {
  Cs[e[1]] = function(t) {
    return this.$g(t, e[0], e[1]);
  };
});
me.extend = function(e, t) {
  return e.$i || (e(t, qo, me), e.$i = !0), me;
};
me.locale = Oo;
me.isDayjs = li;
me.unix = function(e) {
  return me(e * 1e3);
};
me.en = kt[Rn];
me.Ls = kt;
me.p = {};
function _c(e, [t, n]) {
  return Math.min(n, Math.max(t, e));
}
function he(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(r) {
    if (e == null || e(r), n === !1 || !r.defaultPrevented)
      return t == null ? void 0 : t(r);
  };
}
function ui(e, t = []) {
  let n = [];
  function o(i, c) {
    const a = /* @__PURE__ */ rt(c), s = n.length;
    n = [
      ...n,
      c
    ];
    function l(d) {
      const { scope: h, children: v, ...p } = d, f = (h == null ? void 0 : h[e][s]) || a, g = Fe(
        () => p,
        Object.values(p)
      );
      return /* @__PURE__ */ E(f.Provider, {
        value: g
      }, v);
    }
    function u(d, h) {
      const v = (h == null ? void 0 : h[e][s]) || a, p = Vt(v);
      if (p)
        return p;
      if (c !== void 0)
        return c;
      throw new Error(`\`${d}\` must be used within \`${i}\``);
    }
    return l.displayName = i + "Provider", [
      l,
      u
    ];
  }
  const r = () => {
    const i = n.map((c) => /* @__PURE__ */ rt(c));
    return function(a) {
      const s = (a == null ? void 0 : a[e]) || i;
      return Fe(
        () => ({
          [`__scope${e}`]: {
            ...a,
            [e]: s
          }
        }),
        [
          a,
          s
        ]
      );
    };
  };
  return r.scopeName = e, [
    o,
    Pp(r, ...t)
  ];
}
function Pp(...e) {
  const t = e[0];
  if (e.length === 1)
    return t;
  const n = () => {
    const o = e.map(
      (r) => ({
        useScope: r(),
        scopeName: r.scopeName
      })
    );
    return function(i) {
      const c = o.reduce((a, { useScope: s, scopeName: l }) => {
        const d = s(i)[`__scope${l}`];
        return {
          ...a,
          ...d
        };
      }, {});
      return Fe(
        () => ({
          [`__scope${t.scopeName}`]: c
        }),
        [
          c
        ]
      );
    };
  };
  return n.scopeName = t.scopeName, n;
}
function Op(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function xs(...e) {
  return (t) => e.forEach(
    (n) => Op(n, t)
  );
}
function be(...e) {
  return le(xs(...e), e);
}
const Fn = /* @__PURE__ */ z((e, t) => {
  const { children: n, ...o } = e, r = ge.toArray(n), i = r.find(Dp);
  if (i) {
    const c = i.props.children, a = r.map((s) => s === i ? ge.count(c) > 1 ? ge.only(null) : /* @__PURE__ */ De(c) ? c.props.children : null : s);
    return /* @__PURE__ */ E(Lr, F({}, o, {
      ref: t
    }), /* @__PURE__ */ De(c) ? /* @__PURE__ */ Ut(c, void 0, a) : null);
  }
  return /* @__PURE__ */ E(Lr, F({}, o, {
    ref: t
  }), n);
});
Fn.displayName = "Slot";
const Lr = /* @__PURE__ */ z((e, t) => {
  const { children: n, ...o } = e;
  return /* @__PURE__ */ De(n) ? /* @__PURE__ */ Ut(n, {
    ...Rp(o, n.props),
    ref: t ? xs(t, n.ref) : n.ref
  }) : ge.count(n) > 1 ? ge.only(null) : null;
});
Lr.displayName = "SlotClone";
const Tp = ({ children: e }) => /* @__PURE__ */ E(wn, null, e);
function Dp(e) {
  return /* @__PURE__ */ De(e) && e.type === Tp;
}
function Rp(e, t) {
  const n = {
    ...t
  };
  for (const o in t) {
    const r = e[o], i = t[o];
    /^on[A-Z]/.test(o) ? r && i ? n[o] = (...a) => {
      i(...a), r(...a);
    } : r && (n[o] = r) : o === "style" ? n[o] = {
      ...r,
      ...i
    } : o === "className" && (n[o] = [
      r,
      i
    ].filter(Boolean).join(" "));
  }
  return {
    ...e,
    ...n
  };
}
function Np(e) {
  const t = e + "CollectionProvider", [n, o] = ui(t), [r, i] = n(t, {
    collectionRef: {
      current: null
    },
    itemMap: /* @__PURE__ */ new Map()
  }), c = (v) => {
    const { scope: p, children: f } = v, g = q.useRef(null), m = q.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ q.createElement(r, {
      scope: p,
      itemMap: m,
      collectionRef: g
    }, f);
  }, a = e + "CollectionSlot", s = /* @__PURE__ */ q.forwardRef((v, p) => {
    const { scope: f, children: g } = v, m = i(a, f), $ = be(p, m.collectionRef);
    return /* @__PURE__ */ q.createElement(Fn, {
      ref: $
    }, g);
  }), l = e + "CollectionItemSlot", u = "data-radix-collection-item", d = /* @__PURE__ */ q.forwardRef((v, p) => {
    const { scope: f, children: g, ...m } = v, $ = q.useRef(null), b = be(p, $), y = i(l, f);
    return q.useEffect(() => (y.itemMap.set($, {
      ref: $,
      ...m
    }), () => void y.itemMap.delete($))), /* @__PURE__ */ q.createElement(Fn, {
      [u]: "",
      ref: b
    }, g);
  });
  function h(v) {
    const p = i(e + "CollectionConsumer", v);
    return q.useCallback(() => {
      const g = p.collectionRef.current;
      if (!g)
        return [];
      const m = Array.from(g.querySelectorAll(`[${u}]`));
      return Array.from(p.itemMap.values()).sort(
        (y, w) => m.indexOf(y.ref.current) - m.indexOf(w.ref.current)
      );
    }, [
      p.collectionRef,
      p.itemMap
    ]);
  }
  return [
    {
      Provider: c,
      Slot: s,
      ItemSlot: d
    },
    h,
    o
  ];
}
const Ip = /* @__PURE__ */ rt(void 0);
function Lp(e) {
  const t = Vt(Ip);
  return e || t || "ltr";
}
const Mp = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], Ae = Mp.reduce((e, t) => {
  const n = /* @__PURE__ */ z((o, r) => {
    const { asChild: i, ...c } = o, a = i ? Fn : t;
    return G(() => {
      window[Symbol.for("radix-ui")] = !0;
    }, []), /* @__PURE__ */ E(a, F({}, c, {
      ref: r
    }));
  });
  return n.displayName = `Primitive.${t}`, {
    ...e,
    [t]: n
  };
}, {});
function kp(e, t) {
  e && Xr(
    () => e.dispatchEvent(t)
  );
}
function it(e) {
  const t = j(e);
  return G(() => {
    t.current = e;
  }), Fe(
    () => (...n) => {
      var o;
      return (o = t.current) === null || o === void 0 ? void 0 : o.call(t, ...n);
    },
    []
  );
}
function Fp(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = it(e);
  G(() => {
    const o = (r) => {
      r.key === "Escape" && n(r);
    };
    return t.addEventListener("keydown", o), () => t.removeEventListener("keydown", o);
  }, [
    n,
    t
  ]);
}
const Mr = "dismissableLayer.update", Hp = "dismissableLayer.pointerDownOutside", Bp = "dismissableLayer.focusOutside";
let Sc;
const Wp = /* @__PURE__ */ rt({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), Vp = /* @__PURE__ */ z((e, t) => {
  var n;
  const { disableOutsidePointerEvents: o = !1, onEscapeKeyDown: r, onPointerDownOutside: i, onFocusOutside: c, onInteractOutside: a, onDismiss: s, ...l } = e, u = Vt(Wp), [d, h] = Y(null), v = (n = d == null ? void 0 : d.ownerDocument) !== null && n !== void 0 ? n : globalThis == null ? void 0 : globalThis.document, [, p] = Y({}), f = be(
    t,
    (C) => h(C)
  ), g = Array.from(u.layers), [m] = [
    ...u.layersWithOutsidePointerEventsDisabled
  ].slice(-1), $ = g.indexOf(m), b = d ? g.indexOf(d) : -1, y = u.layersWithOutsidePointerEventsDisabled.size > 0, w = b >= $, _ = Up((C) => {
    const T = C.target, D = [
      ...u.branches
    ].some(
      (S) => S.contains(T)
    );
    !w || D || (i == null || i(C), a == null || a(C), C.defaultPrevented || s == null || s());
  }, v), x = zp((C) => {
    const T = C.target;
    [
      ...u.branches
    ].some(
      (S) => S.contains(T)
    ) || (c == null || c(C), a == null || a(C), C.defaultPrevented || s == null || s());
  }, v);
  return Fp((C) => {
    b === u.layers.size - 1 && (r == null || r(C), !C.defaultPrevented && s && (C.preventDefault(), s()));
  }, v), G(() => {
    if (d)
      return o && (u.layersWithOutsidePointerEventsDisabled.size === 0 && (Sc = v.body.style.pointerEvents, v.body.style.pointerEvents = "none"), u.layersWithOutsidePointerEventsDisabled.add(d)), u.layers.add(d), Ac(), () => {
        o && u.layersWithOutsidePointerEventsDisabled.size === 1 && (v.body.style.pointerEvents = Sc);
      };
  }, [
    d,
    v,
    o,
    u
  ]), G(() => () => {
    d && (u.layers.delete(d), u.layersWithOutsidePointerEventsDisabled.delete(d), Ac());
  }, [
    d,
    u
  ]), G(() => {
    const C = () => p({});
    return document.addEventListener(Mr, C), () => document.removeEventListener(Mr, C);
  }, []), /* @__PURE__ */ E(Ae.div, F({}, l, {
    ref: f,
    style: {
      pointerEvents: y ? w ? "auto" : "none" : void 0,
      ...e.style
    },
    onFocusCapture: he(e.onFocusCapture, x.onFocusCapture),
    onBlurCapture: he(e.onBlurCapture, x.onBlurCapture),
    onPointerDownCapture: he(e.onPointerDownCapture, _.onPointerDownCapture)
  }));
});
function Up(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = it(e), o = j(!1), r = j(() => {
  });
  return G(() => {
    const i = (a) => {
      if (a.target && !o.current) {
        let l = function() {
          Es(Hp, n, s, {
            discrete: !0
          });
        };
        const s = {
          originalEvent: a
        };
        a.pointerType === "touch" ? (t.removeEventListener("click", r.current), r.current = l, t.addEventListener("click", r.current, {
          once: !0
        })) : l();
      }
      o.current = !1;
    }, c = window.setTimeout(() => {
      t.addEventListener("pointerdown", i);
    }, 0);
    return () => {
      window.clearTimeout(c), t.removeEventListener("pointerdown", i), t.removeEventListener("click", r.current);
    };
  }, [
    t,
    n
  ]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => o.current = !0
  };
}
function zp(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = it(e), o = j(!1);
  return G(() => {
    const r = (i) => {
      i.target && !o.current && Es(Bp, n, {
        originalEvent: i
      }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", r), () => t.removeEventListener("focusin", r);
  }, [
    t,
    n
  ]), {
    onFocusCapture: () => o.current = !0,
    onBlurCapture: () => o.current = !1
  };
}
function Ac() {
  const e = new CustomEvent(Mr);
  document.dispatchEvent(e);
}
function Es(e, t, n, { discrete: o }) {
  const r = n.originalEvent.target, i = new CustomEvent(e, {
    bubbles: !1,
    cancelable: !0,
    detail: n
  });
  t && r.addEventListener(e, t, {
    once: !0
  }), o ? kp(r, i) : r.dispatchEvent(i);
}
let gr = 0;
function qp() {
  G(() => {
    var e, t;
    const n = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", (e = n[0]) !== null && e !== void 0 ? e : Pc()), document.body.insertAdjacentElement("beforeend", (t = n[1]) !== null && t !== void 0 ? t : Pc()), gr++, () => {
      gr === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach(
        (o) => o.remove()
      ), gr--;
    };
  }, []);
}
function Pc() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.cssText = "outline: none; opacity: 0; position: fixed; pointer-events: none", e;
}
const $r = "focusScope.autoFocusOnMount", br = "focusScope.autoFocusOnUnmount", Oc = {
  bubbles: !1,
  cancelable: !0
}, Kp = /* @__PURE__ */ z((e, t) => {
  const { loop: n = !1, trapped: o = !1, onMountAutoFocus: r, onUnmountAutoFocus: i, ...c } = e, [a, s] = Y(null), l = it(r), u = it(i), d = j(null), h = be(
    t,
    (f) => s(f)
  ), v = j({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  G(() => {
    if (o) {
      let f = function(b) {
        if (v.paused || !a)
          return;
        const y = b.target;
        a.contains(y) ? d.current = y : mt(d.current, {
          select: !0
        });
      }, g = function(b) {
        if (v.paused || !a)
          return;
        const y = b.relatedTarget;
        y !== null && (a.contains(y) || mt(d.current, {
          select: !0
        }));
      }, m = function(b) {
        const y = document.activeElement;
        for (const w of b)
          w.removedNodes.length > 0 && (a != null && a.contains(y) || mt(a));
      };
      document.addEventListener("focusin", f), document.addEventListener("focusout", g);
      const $ = new MutationObserver(m);
      return a && $.observe(a, {
        childList: !0,
        subtree: !0
      }), () => {
        document.removeEventListener("focusin", f), document.removeEventListener("focusout", g), $.disconnect();
      };
    }
  }, [
    o,
    a,
    v.paused
  ]), G(() => {
    if (a) {
      Dc.add(v);
      const f = document.activeElement;
      if (!a.contains(f)) {
        const m = new CustomEvent($r, Oc);
        a.addEventListener($r, l), a.dispatchEvent(m), m.defaultPrevented || (Yp(Jp(_s(a)), {
          select: !0
        }), document.activeElement === f && mt(a));
      }
      return () => {
        a.removeEventListener($r, l), setTimeout(() => {
          const m = new CustomEvent(br, Oc);
          a.addEventListener(br, u), a.dispatchEvent(m), m.defaultPrevented || mt(f ?? document.body, {
            select: !0
          }), a.removeEventListener(br, u), Dc.remove(v);
        }, 0);
      };
    }
  }, [
    a,
    l,
    u,
    v
  ]);
  const p = le((f) => {
    if (!n && !o || v.paused)
      return;
    const g = f.key === "Tab" && !f.altKey && !f.ctrlKey && !f.metaKey, m = document.activeElement;
    if (g && m) {
      const $ = f.currentTarget, [b, y] = jp($);
      b && y ? !f.shiftKey && m === y ? (f.preventDefault(), n && mt(b, {
        select: !0
      })) : f.shiftKey && m === b && (f.preventDefault(), n && mt(y, {
        select: !0
      })) : m === $ && f.preventDefault();
    }
  }, [
    n,
    o,
    v.paused
  ]);
  return /* @__PURE__ */ E(Ae.div, F({
    tabIndex: -1
  }, c, {
    ref: h,
    onKeyDown: p
  }));
});
function Yp(e, { select: t = !1 } = {}) {
  const n = document.activeElement;
  for (const o of e)
    if (mt(o, {
      select: t
    }), document.activeElement !== n)
      return;
}
function jp(e) {
  const t = _s(e), n = Tc(t, e), o = Tc(t.reverse(), e);
  return [
    n,
    o
  ];
}
function _s(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (o) => {
      const r = o.tagName === "INPUT" && o.type === "hidden";
      return o.disabled || o.hidden || r ? NodeFilter.FILTER_SKIP : o.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); )
    t.push(n.currentNode);
  return t;
}
function Tc(e, t) {
  for (const n of e)
    if (!Gp(n, {
      upTo: t
    }))
      return n;
}
function Gp(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden")
    return !0;
  for (; e; ) {
    if (t !== void 0 && e === t)
      return !1;
    if (getComputedStyle(e).display === "none")
      return !0;
    e = e.parentElement;
  }
  return !1;
}
function Xp(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function mt(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const n = document.activeElement;
    e.focus({
      preventScroll: !0
    }), e !== n && Xp(e) && t && e.select();
  }
}
const Dc = Zp();
function Zp() {
  let e = [];
  return {
    add(t) {
      const n = e[0];
      t !== n && (n == null || n.pause()), e = Rc(e, t), e.unshift(t);
    },
    remove(t) {
      var n;
      e = Rc(e, t), (n = e[0]) === null || n === void 0 || n.resume();
    }
  };
}
function Rc(e, t) {
  const n = [
    ...e
  ], o = n.indexOf(t);
  return o !== -1 && n.splice(o, 1), n;
}
function Jp(e) {
  return e.filter(
    (t) => t.tagName !== "A"
  );
}
const Re = globalThis != null && globalThis.document ? jn : () => {
}, Qp = H["useId".toString()] || (() => {
});
let eh = 0;
function Ss(e) {
  const [t, n] = H.useState(Qp());
  return Re(() => {
    e || n(
      (o) => o ?? String(eh++)
    );
  }, [
    e
  ]), e || (t ? `radix-${t}` : "");
}
const th = ["top", "right", "bottom", "left"], xt = Math.min, _e = Math.max, To = Math.round, vo = Math.floor, Et = (e) => ({
  x: e,
  y: e
}), nh = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, oh = {
  start: "end",
  end: "start"
};
function kr(e, t, n) {
  return _e(e, xt(t, n));
}
function ct(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function at(e) {
  return e.split("-")[0];
}
function En(e) {
  return e.split("-")[1];
}
function di(e) {
  return e === "x" ? "y" : "x";
}
function fi(e) {
  return e === "y" ? "height" : "width";
}
function _n(e) {
  return ["top", "bottom"].includes(at(e)) ? "y" : "x";
}
function vi(e) {
  return di(_n(e));
}
function rh(e, t, n) {
  n === void 0 && (n = !1);
  const o = En(e), r = vi(e), i = fi(r);
  let c = r === "x" ? o === (n ? "end" : "start") ? "right" : "left" : o === "start" ? "bottom" : "top";
  return t.reference[i] > t.floating[i] && (c = Do(c)), [c, Do(c)];
}
function ih(e) {
  const t = Do(e);
  return [Fr(e), t, Fr(t)];
}
function Fr(e) {
  return e.replace(/start|end/g, (t) => oh[t]);
}
function ch(e, t, n) {
  const o = ["left", "right"], r = ["right", "left"], i = ["top", "bottom"], c = ["bottom", "top"];
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? r : o : t ? o : r;
    case "left":
    case "right":
      return t ? i : c;
    default:
      return [];
  }
}
function ah(e, t, n, o) {
  const r = En(e);
  let i = ch(at(e), n === "start", o);
  return r && (i = i.map((c) => c + "-" + r), t && (i = i.concat(i.map(Fr)))), i;
}
function Do(e) {
  return e.replace(/left|right|bottom|top/g, (t) => nh[t]);
}
function sh(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function As(e) {
  return typeof e != "number" ? sh(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function Ro(e) {
  return {
    ...e,
    top: e.y,
    left: e.x,
    right: e.x + e.width,
    bottom: e.y + e.height
  };
}
function Nc(e, t, n) {
  let {
    reference: o,
    floating: r
  } = e;
  const i = _n(t), c = vi(t), a = fi(c), s = at(t), l = i === "y", u = o.x + o.width / 2 - r.width / 2, d = o.y + o.height / 2 - r.height / 2, h = o[a] / 2 - r[a] / 2;
  let v;
  switch (s) {
    case "top":
      v = {
        x: u,
        y: o.y - r.height
      };
      break;
    case "bottom":
      v = {
        x: u,
        y: o.y + o.height
      };
      break;
    case "right":
      v = {
        x: o.x + o.width,
        y: d
      };
      break;
    case "left":
      v = {
        x: o.x - r.width,
        y: d
      };
      break;
    default:
      v = {
        x: o.x,
        y: o.y
      };
  }
  switch (En(t)) {
    case "start":
      v[c] -= h * (n && l ? -1 : 1);
      break;
    case "end":
      v[c] += h * (n && l ? -1 : 1);
      break;
  }
  return v;
}
const lh = async (e, t, n) => {
  const {
    placement: o = "bottom",
    strategy: r = "absolute",
    middleware: i = [],
    platform: c
  } = n, a = i.filter(Boolean), s = await (c.isRTL == null ? void 0 : c.isRTL(t));
  let l = await c.getElementRects({
    reference: e,
    floating: t,
    strategy: r
  }), {
    x: u,
    y: d
  } = Nc(l, o, s), h = o, v = {}, p = 0;
  for (let f = 0; f < a.length; f++) {
    const {
      name: g,
      fn: m
    } = a[f], {
      x: $,
      y: b,
      data: y,
      reset: w
    } = await m({
      x: u,
      y: d,
      initialPlacement: o,
      placement: h,
      strategy: r,
      middlewareData: v,
      rects: l,
      platform: c,
      elements: {
        reference: e,
        floating: t
      }
    });
    if (u = $ ?? u, d = b ?? d, v = {
      ...v,
      [g]: {
        ...v[g],
        ...y
      }
    }, w && p <= 50) {
      p++, typeof w == "object" && (w.placement && (h = w.placement), w.rects && (l = w.rects === !0 ? await c.getElementRects({
        reference: e,
        floating: t,
        strategy: r
      }) : w.rects), {
        x: u,
        y: d
      } = Nc(l, h, s)), f = -1;
      continue;
    }
  }
  return {
    x: u,
    y: d,
    placement: h,
    strategy: r,
    middlewareData: v
  };
};
async function Hn(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    x: o,
    y: r,
    platform: i,
    rects: c,
    elements: a,
    strategy: s
  } = e, {
    boundary: l = "clippingAncestors",
    rootBoundary: u = "viewport",
    elementContext: d = "floating",
    altBoundary: h = !1,
    padding: v = 0
  } = ct(t, e), p = As(v), g = a[h ? d === "floating" ? "reference" : "floating" : d], m = Ro(await i.getClippingRect({
    element: (n = await (i.isElement == null ? void 0 : i.isElement(g))) == null || n ? g : g.contextElement || await (i.getDocumentElement == null ? void 0 : i.getDocumentElement(a.floating)),
    boundary: l,
    rootBoundary: u,
    strategy: s
  })), $ = d === "floating" ? {
    ...c.floating,
    x: o,
    y: r
  } : c.reference, b = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(a.floating)), y = await (i.isElement == null ? void 0 : i.isElement(b)) ? await (i.getScale == null ? void 0 : i.getScale(b)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, w = Ro(i.convertOffsetParentRelativeRectToViewportRelativeRect ? await i.convertOffsetParentRelativeRectToViewportRelativeRect({
    rect: $,
    offsetParent: b,
    strategy: s
  }) : $);
  return {
    top: (m.top - w.top + p.top) / y.y,
    bottom: (w.bottom - m.bottom + p.bottom) / y.y,
    left: (m.left - w.left + p.left) / y.x,
    right: (w.right - m.right + p.right) / y.x
  };
}
const uh = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: n,
      y: o,
      placement: r,
      rects: i,
      platform: c,
      elements: a,
      middlewareData: s
    } = t, {
      element: l,
      padding: u = 0
    } = ct(e, t) || {};
    if (l == null)
      return {};
    const d = As(u), h = {
      x: n,
      y: o
    }, v = vi(r), p = fi(v), f = await c.getDimensions(l), g = v === "y", m = g ? "top" : "left", $ = g ? "bottom" : "right", b = g ? "clientHeight" : "clientWidth", y = i.reference[p] + i.reference[v] - h[v] - i.floating[p], w = h[v] - i.reference[v], _ = await (c.getOffsetParent == null ? void 0 : c.getOffsetParent(l));
    let x = _ ? _[b] : 0;
    (!x || !await (c.isElement == null ? void 0 : c.isElement(_))) && (x = a.floating[b] || i.floating[p]);
    const C = y / 2 - w / 2, T = x / 2 - f[p] / 2 - 1, D = xt(d[m], T), S = xt(d[$], T), A = D, O = x - f[p] - S, I = x / 2 - f[p] / 2 + C, M = kr(A, I, O), W = !s.arrow && En(r) != null && I != M && i.reference[p] / 2 - (I < A ? D : S) - f[p] / 2 < 0, K = W ? I < A ? I - A : I - O : 0;
    return {
      [v]: h[v] + K,
      data: {
        [v]: M,
        centerOffset: I - M - K,
        ...W && {
          alignmentOffset: K
        }
      },
      reset: W
    };
  }
}), dh = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n, o;
      const {
        placement: r,
        middlewareData: i,
        rects: c,
        initialPlacement: a,
        platform: s,
        elements: l
      } = t, {
        mainAxis: u = !0,
        crossAxis: d = !0,
        fallbackPlacements: h,
        fallbackStrategy: v = "bestFit",
        fallbackAxisSideDirection: p = "none",
        flipAlignment: f = !0,
        ...g
      } = ct(e, t);
      if ((n = i.arrow) != null && n.alignmentOffset)
        return {};
      const m = at(r), $ = at(a) === a, b = await (s.isRTL == null ? void 0 : s.isRTL(l.floating)), y = h || ($ || !f ? [Do(a)] : ih(a));
      !h && p !== "none" && y.push(...ah(a, f, p, b));
      const w = [a, ...y], _ = await Hn(t, g), x = [];
      let C = ((o = i.flip) == null ? void 0 : o.overflows) || [];
      if (u && x.push(_[m]), d) {
        const A = rh(r, c, b);
        x.push(_[A[0]], _[A[1]]);
      }
      if (C = [...C, {
        placement: r,
        overflows: x
      }], !x.every((A) => A <= 0)) {
        var T, D;
        const A = (((T = i.flip) == null ? void 0 : T.index) || 0) + 1, O = w[A];
        if (O)
          return {
            data: {
              index: A,
              overflows: C
            },
            reset: {
              placement: O
            }
          };
        let I = (D = C.filter((M) => M.overflows[0] <= 0).sort((M, W) => M.overflows[1] - W.overflows[1])[0]) == null ? void 0 : D.placement;
        if (!I)
          switch (v) {
            case "bestFit": {
              var S;
              const M = (S = C.map((W) => [W.placement, W.overflows.filter((K) => K > 0).reduce((K, B) => K + B, 0)]).sort((W, K) => W[1] - K[1])[0]) == null ? void 0 : S[0];
              M && (I = M);
              break;
            }
            case "initialPlacement":
              I = a;
              break;
          }
        if (r !== I)
          return {
            reset: {
              placement: I
            }
          };
      }
      return {};
    }
  };
};
function Ic(e, t) {
  return {
    top: e.top - t.height,
    right: e.right - t.width,
    bottom: e.bottom - t.height,
    left: e.left - t.width
  };
}
function Lc(e) {
  return th.some((t) => e[t] >= 0);
}
const fh = function(e) {
  return e === void 0 && (e = {}), {
    name: "hide",
    options: e,
    async fn(t) {
      const {
        rects: n
      } = t, {
        strategy: o = "referenceHidden",
        ...r
      } = ct(e, t);
      switch (o) {
        case "referenceHidden": {
          const i = await Hn(t, {
            ...r,
            elementContext: "reference"
          }), c = Ic(i, n.reference);
          return {
            data: {
              referenceHiddenOffsets: c,
              referenceHidden: Lc(c)
            }
          };
        }
        case "escaped": {
          const i = await Hn(t, {
            ...r,
            altBoundary: !0
          }), c = Ic(i, n.floating);
          return {
            data: {
              escapedOffsets: c,
              escaped: Lc(c)
            }
          };
        }
        default:
          return {};
      }
    }
  };
};
async function vh(e, t) {
  const {
    placement: n,
    platform: o,
    elements: r
  } = e, i = await (o.isRTL == null ? void 0 : o.isRTL(r.floating)), c = at(n), a = En(n), s = _n(n) === "y", l = ["left", "top"].includes(c) ? -1 : 1, u = i && s ? -1 : 1, d = ct(t, e);
  let {
    mainAxis: h,
    crossAxis: v,
    alignmentAxis: p
  } = typeof d == "number" ? {
    mainAxis: d,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: 0,
    crossAxis: 0,
    alignmentAxis: null,
    ...d
  };
  return a && typeof p == "number" && (v = a === "end" ? p * -1 : p), s ? {
    x: v * u,
    y: h * l
  } : {
    x: h * l,
    y: v * u
  };
}
const ph = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var n, o;
      const {
        x: r,
        y: i,
        placement: c,
        middlewareData: a
      } = t, s = await vh(t, e);
      return c === ((n = a.offset) == null ? void 0 : n.placement) && (o = a.arrow) != null && o.alignmentOffset ? {} : {
        x: r + s.x,
        y: i + s.y,
        data: {
          ...s,
          placement: c
        }
      };
    }
  };
}, hh = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: o,
        placement: r
      } = t, {
        mainAxis: i = !0,
        crossAxis: c = !1,
        limiter: a = {
          fn: (g) => {
            let {
              x: m,
              y: $
            } = g;
            return {
              x: m,
              y: $
            };
          }
        },
        ...s
      } = ct(e, t), l = {
        x: n,
        y: o
      }, u = await Hn(t, s), d = _n(at(r)), h = di(d);
      let v = l[h], p = l[d];
      if (i) {
        const g = h === "y" ? "top" : "left", m = h === "y" ? "bottom" : "right", $ = v + u[g], b = v - u[m];
        v = kr($, v, b);
      }
      if (c) {
        const g = d === "y" ? "top" : "left", m = d === "y" ? "bottom" : "right", $ = p + u[g], b = p - u[m];
        p = kr($, p, b);
      }
      const f = a.fn({
        ...t,
        [h]: v,
        [d]: p
      });
      return {
        ...f,
        data: {
          x: f.x - n,
          y: f.y - o
        }
      };
    }
  };
}, mh = function(e) {
  return e === void 0 && (e = {}), {
    options: e,
    fn(t) {
      const {
        x: n,
        y: o,
        placement: r,
        rects: i,
        middlewareData: c
      } = t, {
        offset: a = 0,
        mainAxis: s = !0,
        crossAxis: l = !0
      } = ct(e, t), u = {
        x: n,
        y: o
      }, d = _n(r), h = di(d);
      let v = u[h], p = u[d];
      const f = ct(a, t), g = typeof f == "number" ? {
        mainAxis: f,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...f
      };
      if (s) {
        const b = h === "y" ? "height" : "width", y = i.reference[h] - i.floating[b] + g.mainAxis, w = i.reference[h] + i.reference[b] - g.mainAxis;
        v < y ? v = y : v > w && (v = w);
      }
      if (l) {
        var m, $;
        const b = h === "y" ? "width" : "height", y = ["top", "left"].includes(at(r)), w = i.reference[d] - i.floating[b] + (y && ((m = c.offset) == null ? void 0 : m[d]) || 0) + (y ? 0 : g.crossAxis), _ = i.reference[d] + i.reference[b] + (y ? 0 : (($ = c.offset) == null ? void 0 : $[d]) || 0) - (y ? g.crossAxis : 0);
        p < w ? p = w : p > _ && (p = _);
      }
      return {
        [h]: v,
        [d]: p
      };
    }
  };
}, gh = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      const {
        placement: n,
        rects: o,
        platform: r,
        elements: i
      } = t, {
        apply: c = () => {
        },
        ...a
      } = ct(e, t), s = await Hn(t, a), l = at(n), u = En(n), d = _n(n) === "y", {
        width: h,
        height: v
      } = o.floating;
      let p, f;
      l === "top" || l === "bottom" ? (p = l, f = u === (await (r.isRTL == null ? void 0 : r.isRTL(i.floating)) ? "start" : "end") ? "left" : "right") : (f = l, p = u === "end" ? "top" : "bottom");
      const g = v - s[p], m = h - s[f], $ = !t.middlewareData.shift;
      let b = g, y = m;
      if (d) {
        const _ = h - s.left - s.right;
        y = u || $ ? xt(m, _) : _;
      } else {
        const _ = v - s.top - s.bottom;
        b = u || $ ? xt(g, _) : _;
      }
      if ($ && !u) {
        const _ = _e(s.left, 0), x = _e(s.right, 0), C = _e(s.top, 0), T = _e(s.bottom, 0);
        d ? y = h - 2 * (_ !== 0 || x !== 0 ? _ + x : _e(s.left, s.right)) : b = v - 2 * (C !== 0 || T !== 0 ? C + T : _e(s.top, s.bottom));
      }
      await c({
        ...t,
        availableWidth: y,
        availableHeight: b
      });
      const w = await r.getDimensions(i.floating);
      return h !== w.width || v !== w.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function _t(e) {
  return Ps(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function Se(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function ft(e) {
  var t;
  return (t = (Ps(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function Ps(e) {
  return e instanceof Node || e instanceof Se(e).Node;
}
function st(e) {
  return e instanceof Element || e instanceof Se(e).Element;
}
function ze(e) {
  return e instanceof HTMLElement || e instanceof Se(e).HTMLElement;
}
function Mc(e) {
  return typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof Se(e).ShadowRoot;
}
function Zn(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: o,
    display: r
  } = Ne(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + o + n) && !["inline", "contents"].includes(r);
}
function $h(e) {
  return ["table", "td", "th"].includes(_t(e));
}
function pi(e) {
  const t = hi(), n = Ne(e);
  return n.transform !== "none" || n.perspective !== "none" || (n.containerType ? n.containerType !== "normal" : !1) || !t && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !t && (n.filter ? n.filter !== "none" : !1) || ["transform", "perspective", "filter"].some((o) => (n.willChange || "").includes(o)) || ["paint", "layout", "strict", "content"].some((o) => (n.contain || "").includes(o));
}
function bh(e) {
  let t = mn(e);
  for (; ze(t) && !Ko(t); ) {
    if (pi(t))
      return t;
    t = mn(t);
  }
  return null;
}
function hi() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function Ko(e) {
  return ["html", "body", "#document"].includes(_t(e));
}
function Ne(e) {
  return Se(e).getComputedStyle(e);
}
function Yo(e) {
  return st(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.pageXOffset,
    scrollTop: e.pageYOffset
  };
}
function mn(e) {
  if (_t(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    Mc(e) && e.host || // Fallback.
    ft(e)
  );
  return Mc(t) ? t.host : t;
}
function Os(e) {
  const t = mn(e);
  return Ko(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : ze(t) && Zn(t) ? t : Os(t);
}
function Bn(e, t, n) {
  var o;
  t === void 0 && (t = []), n === void 0 && (n = !0);
  const r = Os(e), i = r === ((o = e.ownerDocument) == null ? void 0 : o.body), c = Se(r);
  return i ? t.concat(c, c.visualViewport || [], Zn(r) ? r : [], c.frameElement && n ? Bn(c.frameElement) : []) : t.concat(r, Bn(r, [], n));
}
function Ts(e) {
  const t = Ne(e);
  let n = parseFloat(t.width) || 0, o = parseFloat(t.height) || 0;
  const r = ze(e), i = r ? e.offsetWidth : n, c = r ? e.offsetHeight : o, a = To(n) !== i || To(o) !== c;
  return a && (n = i, o = c), {
    width: n,
    height: o,
    $: a
  };
}
function mi(e) {
  return st(e) ? e : e.contextElement;
}
function dn(e) {
  const t = mi(e);
  if (!ze(t))
    return Et(1);
  const n = t.getBoundingClientRect(), {
    width: o,
    height: r,
    $: i
  } = Ts(t);
  let c = (i ? To(n.width) : n.width) / o, a = (i ? To(n.height) : n.height) / r;
  return (!c || !Number.isFinite(c)) && (c = 1), (!a || !Number.isFinite(a)) && (a = 1), {
    x: c,
    y: a
  };
}
const yh = /* @__PURE__ */ Et(0);
function Ds(e) {
  const t = Se(e);
  return !hi() || !t.visualViewport ? yh : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function wh(e, t, n) {
  return t === void 0 && (t = !1), !n || t && n !== Se(e) ? !1 : t;
}
function Ht(e, t, n, o) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const r = e.getBoundingClientRect(), i = mi(e);
  let c = Et(1);
  t && (o ? st(o) && (c = dn(o)) : c = dn(e));
  const a = wh(i, n, o) ? Ds(i) : Et(0);
  let s = (r.left + a.x) / c.x, l = (r.top + a.y) / c.y, u = r.width / c.x, d = r.height / c.y;
  if (i) {
    const h = Se(i), v = o && st(o) ? Se(o) : o;
    let p = h.frameElement;
    for (; p && o && v !== h; ) {
      const f = dn(p), g = p.getBoundingClientRect(), m = Ne(p), $ = g.left + (p.clientLeft + parseFloat(m.paddingLeft)) * f.x, b = g.top + (p.clientTop + parseFloat(m.paddingTop)) * f.y;
      s *= f.x, l *= f.y, u *= f.x, d *= f.y, s += $, l += b, p = Se(p).frameElement;
    }
  }
  return Ro({
    width: u,
    height: d,
    x: s,
    y: l
  });
}
function Ch(e) {
  let {
    rect: t,
    offsetParent: n,
    strategy: o
  } = e;
  const r = ze(n), i = ft(n);
  if (n === i)
    return t;
  let c = {
    scrollLeft: 0,
    scrollTop: 0
  }, a = Et(1);
  const s = Et(0);
  if ((r || !r && o !== "fixed") && ((_t(n) !== "body" || Zn(i)) && (c = Yo(n)), ze(n))) {
    const l = Ht(n);
    a = dn(n), s.x = l.x + n.clientLeft, s.y = l.y + n.clientTop;
  }
  return {
    width: t.width * a.x,
    height: t.height * a.y,
    x: t.x * a.x - c.scrollLeft * a.x + s.x,
    y: t.y * a.y - c.scrollTop * a.y + s.y
  };
}
function xh(e) {
  return Array.from(e.getClientRects());
}
function Rs(e) {
  return Ht(ft(e)).left + Yo(e).scrollLeft;
}
function Eh(e) {
  const t = ft(e), n = Yo(e), o = e.ownerDocument.body, r = _e(t.scrollWidth, t.clientWidth, o.scrollWidth, o.clientWidth), i = _e(t.scrollHeight, t.clientHeight, o.scrollHeight, o.clientHeight);
  let c = -n.scrollLeft + Rs(e);
  const a = -n.scrollTop;
  return Ne(o).direction === "rtl" && (c += _e(t.clientWidth, o.clientWidth) - r), {
    width: r,
    height: i,
    x: c,
    y: a
  };
}
function _h(e, t) {
  const n = Se(e), o = ft(e), r = n.visualViewport;
  let i = o.clientWidth, c = o.clientHeight, a = 0, s = 0;
  if (r) {
    i = r.width, c = r.height;
    const l = hi();
    (!l || l && t === "fixed") && (a = r.offsetLeft, s = r.offsetTop);
  }
  return {
    width: i,
    height: c,
    x: a,
    y: s
  };
}
function Sh(e, t) {
  const n = Ht(e, !0, t === "fixed"), o = n.top + e.clientTop, r = n.left + e.clientLeft, i = ze(e) ? dn(e) : Et(1), c = e.clientWidth * i.x, a = e.clientHeight * i.y, s = r * i.x, l = o * i.y;
  return {
    width: c,
    height: a,
    x: s,
    y: l
  };
}
function kc(e, t, n) {
  let o;
  if (t === "viewport")
    o = _h(e, n);
  else if (t === "document")
    o = Eh(ft(e));
  else if (st(t))
    o = Sh(t, n);
  else {
    const r = Ds(e);
    o = {
      ...t,
      x: t.x - r.x,
      y: t.y - r.y
    };
  }
  return Ro(o);
}
function Ns(e, t) {
  const n = mn(e);
  return n === t || !st(n) || Ko(n) ? !1 : Ne(n).position === "fixed" || Ns(n, t);
}
function Ah(e, t) {
  const n = t.get(e);
  if (n)
    return n;
  let o = Bn(e, [], !1).filter((a) => st(a) && _t(a) !== "body"), r = null;
  const i = Ne(e).position === "fixed";
  let c = i ? mn(e) : e;
  for (; st(c) && !Ko(c); ) {
    const a = Ne(c), s = pi(c);
    !s && a.position === "fixed" && (r = null), (i ? !s && !r : !s && a.position === "static" && !!r && ["absolute", "fixed"].includes(r.position) || Zn(c) && !s && Ns(e, c)) ? o = o.filter((u) => u !== c) : r = a, c = mn(c);
  }
  return t.set(e, o), o;
}
function Ph(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: o,
    strategy: r
  } = e;
  const c = [...n === "clippingAncestors" ? Ah(t, this._c) : [].concat(n), o], a = c[0], s = c.reduce((l, u) => {
    const d = kc(t, u, r);
    return l.top = _e(d.top, l.top), l.right = xt(d.right, l.right), l.bottom = xt(d.bottom, l.bottom), l.left = _e(d.left, l.left), l;
  }, kc(t, a, r));
  return {
    width: s.right - s.left,
    height: s.bottom - s.top,
    x: s.left,
    y: s.top
  };
}
function Oh(e) {
  const {
    width: t,
    height: n
  } = Ts(e);
  return {
    width: t,
    height: n
  };
}
function Th(e, t, n) {
  const o = ze(t), r = ft(t), i = n === "fixed", c = Ht(e, !0, i, t);
  let a = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const s = Et(0);
  if (o || !o && !i)
    if ((_t(t) !== "body" || Zn(r)) && (a = Yo(t)), o) {
      const l = Ht(t, !0, i, t);
      s.x = l.x + t.clientLeft, s.y = l.y + t.clientTop;
    } else
      r && (s.x = Rs(r));
  return {
    x: c.left + a.scrollLeft - s.x,
    y: c.top + a.scrollTop - s.y,
    width: c.width,
    height: c.height
  };
}
function Fc(e, t) {
  return !ze(e) || Ne(e).position === "fixed" ? null : t ? t(e) : e.offsetParent;
}
function Is(e, t) {
  const n = Se(e);
  if (!ze(e))
    return n;
  let o = Fc(e, t);
  for (; o && $h(o) && Ne(o).position === "static"; )
    o = Fc(o, t);
  return o && (_t(o) === "html" || _t(o) === "body" && Ne(o).position === "static" && !pi(o)) ? n : o || bh(e) || n;
}
const Dh = async function(e) {
  let {
    reference: t,
    floating: n,
    strategy: o
  } = e;
  const r = this.getOffsetParent || Is, i = this.getDimensions;
  return {
    reference: Th(t, await r(n), o),
    floating: {
      x: 0,
      y: 0,
      ...await i(n)
    }
  };
};
function Rh(e) {
  return Ne(e).direction === "rtl";
}
const Nh = {
  convertOffsetParentRelativeRectToViewportRelativeRect: Ch,
  getDocumentElement: ft,
  getClippingRect: Ph,
  getOffsetParent: Is,
  getElementRects: Dh,
  getClientRects: xh,
  getDimensions: Oh,
  getScale: dn,
  isElement: st,
  isRTL: Rh
};
function Ih(e, t) {
  let n = null, o;
  const r = ft(e);
  function i() {
    clearTimeout(o), n && n.disconnect(), n = null;
  }
  function c(a, s) {
    a === void 0 && (a = !1), s === void 0 && (s = 1), i();
    const {
      left: l,
      top: u,
      width: d,
      height: h
    } = e.getBoundingClientRect();
    if (a || t(), !d || !h)
      return;
    const v = vo(u), p = vo(r.clientWidth - (l + d)), f = vo(r.clientHeight - (u + h)), g = vo(l), $ = {
      rootMargin: -v + "px " + -p + "px " + -f + "px " + -g + "px",
      threshold: _e(0, xt(1, s)) || 1
    };
    let b = !0;
    function y(w) {
      const _ = w[0].intersectionRatio;
      if (_ !== s) {
        if (!b)
          return c();
        _ ? c(!1, _) : o = setTimeout(() => {
          c(!1, 1e-7);
        }, 100);
      }
      b = !1;
    }
    try {
      n = new IntersectionObserver(y, {
        ...$,
        // Handle <iframe>s
        root: r.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(y, $);
    }
    n.observe(e);
  }
  return c(!0), i;
}
function Lh(e, t, n, o) {
  o === void 0 && (o = {});
  const {
    ancestorScroll: r = !0,
    ancestorResize: i = !0,
    elementResize: c = typeof ResizeObserver == "function",
    layoutShift: a = typeof IntersectionObserver == "function",
    animationFrame: s = !1
  } = o, l = mi(e), u = r || i ? [...l ? Bn(l) : [], ...Bn(t)] : [];
  u.forEach((m) => {
    r && m.addEventListener("scroll", n, {
      passive: !0
    }), i && m.addEventListener("resize", n);
  });
  const d = l && a ? Ih(l, n) : null;
  let h = -1, v = null;
  c && (v = new ResizeObserver((m) => {
    let [$] = m;
    $ && $.target === l && v && (v.unobserve(t), cancelAnimationFrame(h), h = requestAnimationFrame(() => {
      v && v.observe(t);
    })), n();
  }), l && !s && v.observe(l), v.observe(t));
  let p, f = s ? Ht(e) : null;
  s && g();
  function g() {
    const m = Ht(e);
    f && (m.x !== f.x || m.y !== f.y || m.width !== f.width || m.height !== f.height) && n(), f = m, p = requestAnimationFrame(g);
  }
  return n(), () => {
    u.forEach((m) => {
      r && m.removeEventListener("scroll", n), i && m.removeEventListener("resize", n);
    }), d && d(), v && v.disconnect(), v = null, s && cancelAnimationFrame(p);
  };
}
const Mh = hh, kh = dh, Fh = gh, Hh = fh, Hc = uh, Bh = mh, Wh = (e, t, n) => {
  const o = /* @__PURE__ */ new Map(), r = {
    platform: Nh,
    ...n
  }, i = {
    ...r.platform,
    _c: o
  };
  return lh(e, t, {
    ...r,
    platform: i
  });
}, Vh = (e) => {
  function t(n) {
    return {}.hasOwnProperty.call(n, "current");
  }
  return {
    name: "arrow",
    options: e,
    fn(n) {
      const {
        element: o,
        padding: r
      } = typeof e == "function" ? e(n) : e;
      return o && t(o) ? o.current != null ? Hc({
        element: o.current,
        padding: r
      }).fn(n) : {} : o ? Hc({
        element: o,
        padding: r
      }).fn(n) : {};
    }
  };
};
var bo = typeof document < "u" ? jn : G;
function No(e, t) {
  if (e === t)
    return !0;
  if (typeof e != typeof t)
    return !1;
  if (typeof e == "function" && e.toString() === t.toString())
    return !0;
  let n, o, r;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (n = e.length, n != t.length)
        return !1;
      for (o = n; o-- !== 0; )
        if (!No(e[o], t[o]))
          return !1;
      return !0;
    }
    if (r = Object.keys(e), n = r.length, n !== Object.keys(t).length)
      return !1;
    for (o = n; o-- !== 0; )
      if (!{}.hasOwnProperty.call(t, r[o]))
        return !1;
    for (o = n; o-- !== 0; ) {
      const i = r[o];
      if (!(i === "_owner" && e.$$typeof) && !No(e[i], t[i]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function Ls(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function Bc(e, t) {
  const n = Ls(e);
  return Math.round(t * n) / n;
}
function Wc(e) {
  const t = H.useRef(e);
  return bo(() => {
    t.current = e;
  }), t;
}
function Uh(e) {
  e === void 0 && (e = {});
  const {
    placement: t = "bottom",
    strategy: n = "absolute",
    middleware: o = [],
    platform: r,
    elements: {
      reference: i,
      floating: c
    } = {},
    transform: a = !0,
    whileElementsMounted: s,
    open: l
  } = e, [u, d] = H.useState({
    x: 0,
    y: 0,
    strategy: n,
    placement: t,
    middlewareData: {},
    isPositioned: !1
  }), [h, v] = H.useState(o);
  No(h, o) || v(o);
  const [p, f] = H.useState(null), [g, m] = H.useState(null), $ = H.useCallback((W) => {
    W != _.current && (_.current = W, f(W));
  }, [f]), b = H.useCallback((W) => {
    W !== x.current && (x.current = W, m(W));
  }, [m]), y = i || p, w = c || g, _ = H.useRef(null), x = H.useRef(null), C = H.useRef(u), T = Wc(s), D = Wc(r), S = H.useCallback(() => {
    if (!_.current || !x.current)
      return;
    const W = {
      placement: t,
      strategy: n,
      middleware: h
    };
    D.current && (W.platform = D.current), Wh(_.current, x.current, W).then((K) => {
      const B = {
        ...K,
        isPositioned: !0
      };
      A.current && !No(C.current, B) && (C.current = B, la.flushSync(() => {
        d(B);
      }));
    });
  }, [h, t, n, D]);
  bo(() => {
    l === !1 && C.current.isPositioned && (C.current.isPositioned = !1, d((W) => ({
      ...W,
      isPositioned: !1
    })));
  }, [l]);
  const A = H.useRef(!1);
  bo(() => (A.current = !0, () => {
    A.current = !1;
  }), []), bo(() => {
    if (y && (_.current = y), w && (x.current = w), y && w) {
      if (T.current)
        return T.current(y, w, S);
      S();
    }
  }, [y, w, S, T]);
  const O = H.useMemo(() => ({
    reference: _,
    floating: x,
    setReference: $,
    setFloating: b
  }), [$, b]), I = H.useMemo(() => ({
    reference: y,
    floating: w
  }), [y, w]), M = H.useMemo(() => {
    const W = {
      position: n,
      left: 0,
      top: 0
    };
    if (!I.floating)
      return W;
    const K = Bc(I.floating, u.x), B = Bc(I.floating, u.y);
    return a ? {
      ...W,
      transform: "translate(" + K + "px, " + B + "px)",
      ...Ls(I.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: n,
      left: K,
      top: B
    };
  }, [n, a, I.floating, u.x, u.y]);
  return H.useMemo(() => ({
    ...u,
    update: S,
    refs: O,
    elements: I,
    floatingStyles: M
  }), [u, S, O, I, M]);
}
function zh(e) {
  const [t, n] = Y(void 0);
  return Re(() => {
    if (e) {
      n({
        width: e.offsetWidth,
        height: e.offsetHeight
      });
      const o = new ResizeObserver((r) => {
        if (!Array.isArray(r) || !r.length)
          return;
        const i = r[0];
        let c, a;
        if ("borderBoxSize" in i) {
          const s = i.borderBoxSize, l = Array.isArray(s) ? s[0] : s;
          c = l.inlineSize, a = l.blockSize;
        } else
          c = e.offsetWidth, a = e.offsetHeight;
        n({
          width: c,
          height: a
        });
      });
      return o.observe(e, {
        box: "border-box"
      }), () => o.unobserve(e);
    } else
      n(void 0);
  }, [
    e
  ]), t;
}
const Ms = "Popper", [ks, Fs] = ui(Ms), [qh, Hs] = ks(Ms), Kh = (e) => {
  const { __scopePopper: t, children: n } = e, [o, r] = Y(null);
  return /* @__PURE__ */ E(qh, {
    scope: t,
    anchor: o,
    onAnchorChange: r
  }, n);
}, Yh = "PopperAnchor", jh = /* @__PURE__ */ z((e, t) => {
  const { __scopePopper: n, virtualRef: o, ...r } = e, i = Hs(Yh, n), c = j(null), a = be(t, c);
  return G(() => {
    i.onAnchorChange((o == null ? void 0 : o.current) || c.current);
  }), o ? null : /* @__PURE__ */ E(Ae.div, F({}, r, {
    ref: a
  }));
}), Bs = "PopperContent", [Gh, Cg] = ks(Bs), Xh = /* @__PURE__ */ z((e, t) => {
  var n, o, r, i, c, a, s, l;
  const { __scopePopper: u, side: d = "bottom", sideOffset: h = 0, align: v = "center", alignOffset: p = 0, arrowPadding: f = 0, collisionBoundary: g = [], collisionPadding: m = 0, sticky: $ = "partial", hideWhenDetached: b = !1, avoidCollisions: y = !0, onPlaced: w, ..._ } = e, x = Hs(Bs, u), [C, T] = Y(null), D = be(
    t,
    (Q) => T(Q)
  ), [S, A] = Y(null), O = zh(S), I = (n = O == null ? void 0 : O.width) !== null && n !== void 0 ? n : 0, M = (o = O == null ? void 0 : O.height) !== null && o !== void 0 ? o : 0, W = d + (v !== "center" ? "-" + v : ""), K = typeof m == "number" ? m : {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...m
  }, B = Array.isArray(g) ? g : [
    g
  ], V = B.length > 0, R = {
    padding: K,
    boundary: B.filter(Zh),
    // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
    altBoundary: V
  }, { refs: U, floatingStyles: te, placement: ue, isPositioned: re, middlewareData: de } = Uh({
    // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
    strategy: "fixed",
    placement: W,
    whileElementsMounted: Lh,
    elements: {
      reference: x.anchor
    },
    middleware: [
      ph({
        mainAxis: h + M,
        alignmentAxis: p
      }),
      y && Mh({
        mainAxis: !0,
        crossAxis: !1,
        limiter: $ === "partial" ? Bh() : void 0,
        ...R
      }),
      y && kh({
        ...R
      }),
      Fh({
        ...R,
        apply: ({ elements: Q, rects: ye, availableWidth: Ee, availableHeight: je }) => {
          const { width: sr, height: vt } = ye.reference, We = Q.floating.style;
          We.setProperty("--radix-popper-available-width", `${Ee}px`), We.setProperty("--radix-popper-available-height", `${je}px`), We.setProperty("--radix-popper-anchor-width", `${sr}px`), We.setProperty("--radix-popper-anchor-height", `${vt}px`);
        }
      }),
      S && Vh({
        element: S,
        padding: f
      }),
      Jh({
        arrowWidth: I,
        arrowHeight: M
      }),
      b && Hh({
        strategy: "referenceHidden"
      })
    ]
  }), [N, L] = Ws(ue), X = it(w);
  Re(() => {
    re && (X == null || X());
  }, [
    re,
    X
  ]);
  const J = (r = de.arrow) === null || r === void 0 ? void 0 : r.x, Z = (i = de.arrow) === null || i === void 0 ? void 0 : i.y, ie = ((c = de.arrow) === null || c === void 0 ? void 0 : c.centerOffset) !== 0, [ne, k] = Y();
  return Re(() => {
    C && k(window.getComputedStyle(C).zIndex);
  }, [
    C
  ]), /* @__PURE__ */ E("div", {
    ref: U.setFloating,
    "data-radix-popper-content-wrapper": "",
    style: {
      ...te,
      transform: re ? te.transform : "translate(0, -200%)",
      // keep off the page when measuring
      minWidth: "max-content",
      zIndex: ne,
      "--radix-popper-transform-origin": [
        (a = de.transformOrigin) === null || a === void 0 ? void 0 : a.x,
        (s = de.transformOrigin) === null || s === void 0 ? void 0 : s.y
      ].join(" ")
    },
    dir: e.dir
  }, /* @__PURE__ */ E(Gh, {
    scope: u,
    placedSide: N,
    onArrowChange: A,
    arrowX: J,
    arrowY: Z,
    shouldHideArrow: ie
  }, /* @__PURE__ */ E(Ae.div, F({
    "data-side": N,
    "data-align": L
  }, _, {
    ref: D,
    style: {
      ..._.style,
      // if the PopperContent hasn't been placed yet (not all measurements done)
      // we prevent animations so that users's animation don't kick in too early referring wrong sides
      animation: re ? void 0 : "none",
      // hide the content if using the hide middleware and should be hidden
      opacity: (l = de.hide) !== null && l !== void 0 && l.referenceHidden ? 0 : void 0
    }
  }))));
});
function Zh(e) {
  return e !== null;
}
const Jh = (e) => ({
  name: "transformOrigin",
  options: e,
  fn(t) {
    var n, o, r, i, c;
    const { placement: a, rects: s, middlewareData: l } = t, d = ((n = l.arrow) === null || n === void 0 ? void 0 : n.centerOffset) !== 0, h = d ? 0 : e.arrowWidth, v = d ? 0 : e.arrowHeight, [p, f] = Ws(a), g = {
      start: "0%",
      center: "50%",
      end: "100%"
    }[f], m = ((o = (r = l.arrow) === null || r === void 0 ? void 0 : r.x) !== null && o !== void 0 ? o : 0) + h / 2, $ = ((i = (c = l.arrow) === null || c === void 0 ? void 0 : c.y) !== null && i !== void 0 ? i : 0) + v / 2;
    let b = "", y = "";
    return p === "bottom" ? (b = d ? g : `${m}px`, y = `${-v}px`) : p === "top" ? (b = d ? g : `${m}px`, y = `${s.floating.height + v}px`) : p === "right" ? (b = `${-v}px`, y = d ? g : `${$}px`) : p === "left" && (b = `${s.floating.width + v}px`, y = d ? g : `${$}px`), {
      data: {
        x: b,
        y
      }
    };
  }
});
function Ws(e) {
  const [t, n = "center"] = e.split("-");
  return [
    t,
    n
  ];
}
const Qh = Kh, em = jh, tm = Xh, nm = /* @__PURE__ */ z((e, t) => {
  var n;
  const { container: o = globalThis == null || (n = globalThis.document) === null || n === void 0 ? void 0 : n.body, ...r } = e;
  return o ? /* @__PURE__ */ ua.createPortal(/* @__PURE__ */ E(Ae.div, F({}, r, {
    ref: t
  })), o) : null;
});
function Vc({ prop: e, defaultProp: t, onChange: n = () => {
} }) {
  const [o, r] = om({
    defaultProp: t,
    onChange: n
  }), i = e !== void 0, c = i ? e : o, a = it(n), s = le((l) => {
    if (i) {
      const d = typeof l == "function" ? l(e) : l;
      d !== e && a(d);
    } else
      r(l);
  }, [
    i,
    e,
    r,
    a
  ]);
  return [
    c,
    s
  ];
}
function om({ defaultProp: e, onChange: t }) {
  const n = Y(e), [o] = n, r = j(o), i = it(t);
  return G(() => {
    r.current !== o && (i(o), r.current = o);
  }, [
    o,
    r,
    i
  ]), n;
}
function rm(e) {
  const t = j({
    value: e,
    previous: e
  });
  return Fe(() => (t.current.value !== e && (t.current.previous = t.current.value, t.current.value = e), t.current.previous), [
    e
  ]);
}
function im(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function cm(...e) {
  return (t) => e.forEach(
    (n) => im(n, t)
  );
}
const Vs = /* @__PURE__ */ z((e, t) => {
  const { children: n, ...o } = e, r = ge.toArray(n), i = r.find(sm);
  if (i) {
    const c = i.props.children, a = r.map((s) => s === i ? ge.count(c) > 1 ? ge.only(null) : /* @__PURE__ */ De(c) ? c.props.children : null : s);
    return /* @__PURE__ */ E(Hr, F({}, o, {
      ref: t
    }), /* @__PURE__ */ De(c) ? /* @__PURE__ */ Ut(c, void 0, a) : null);
  }
  return /* @__PURE__ */ E(Hr, F({}, o, {
    ref: t
  }), n);
});
Vs.displayName = "Slot";
const Hr = /* @__PURE__ */ z((e, t) => {
  const { children: n, ...o } = e;
  return /* @__PURE__ */ De(n) ? /* @__PURE__ */ Ut(n, {
    ...lm(o, n.props),
    ref: t ? cm(t, n.ref) : n.ref
  }) : ge.count(n) > 1 ? ge.only(null) : null;
});
Hr.displayName = "SlotClone";
const am = ({ children: e }) => /* @__PURE__ */ E(wn, null, e);
function sm(e) {
  return /* @__PURE__ */ De(e) && e.type === am;
}
function lm(e, t) {
  const n = {
    ...t
  };
  for (const o in t) {
    const r = e[o], i = t[o];
    /^on[A-Z]/.test(o) ? r && i ? n[o] = (...a) => {
      i(...a), r(...a);
    } : r && (n[o] = r) : o === "style" ? n[o] = {
      ...r,
      ...i
    } : o === "className" && (n[o] = [
      r,
      i
    ].filter(Boolean).join(" "));
  }
  return {
    ...e,
    ...n
  };
}
const um = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], dm = um.reduce((e, t) => {
  const n = /* @__PURE__ */ z((o, r) => {
    const { asChild: i, ...c } = o, a = i ? Vs : t;
    return G(() => {
      window[Symbol.for("radix-ui")] = !0;
    }, []), /* @__PURE__ */ E(a, F({}, c, {
      ref: r
    }));
  });
  return n.displayName = `Primitive.${t}`, {
    ...e,
    [t]: n
  };
}, {}), fm = /* @__PURE__ */ z((e, t) => /* @__PURE__ */ E(dm.span, F({}, e, {
  ref: t,
  style: {
    // See: https://github.com/twbs/bootstrap/blob/master/scss/mixins/_screen-reader.scss
    position: "absolute",
    border: 0,
    width: 1,
    height: 1,
    padding: 0,
    margin: -1,
    overflow: "hidden",
    clip: "rect(0, 0, 0, 0)",
    whiteSpace: "nowrap",
    wordWrap: "normal",
    ...e.style
  }
}))), vm = [
  " ",
  "Enter",
  "ArrowUp",
  "ArrowDown"
], pm = [
  " ",
  "Enter"
], jo = "Select", [Go, Xo, hm] = Np(jo), [Sn, xg] = ui(jo, [
  hm,
  Fs
]), gi = Fs(), [mm, Yt] = Sn(jo), [gm, $m] = Sn(jo), bm = (e) => {
  const { __scopeSelect: t, children: n, open: o, defaultOpen: r, onOpenChange: i, value: c, defaultValue: a, onValueChange: s, dir: l, name: u, autoComplete: d, disabled: h, required: v } = e, p = gi(t), [f, g] = Y(null), [m, $] = Y(null), [b, y] = Y(!1), w = Lp(l), [_ = !1, x] = Vc({
    prop: o,
    defaultProp: r,
    onChange: i
  }), [C, T] = Vc({
    prop: c,
    defaultProp: a,
    onChange: s
  }), D = j(null), S = f ? !!f.closest("form") : !0, [A, O] = Y(/* @__PURE__ */ new Set()), I = Array.from(A).map(
    (M) => M.props.value
  ).join(";");
  return /* @__PURE__ */ E(Qh, p, /* @__PURE__ */ E(mm, {
    required: v,
    scope: t,
    trigger: f,
    onTriggerChange: g,
    valueNode: m,
    onValueNodeChange: $,
    valueNodeHasChildren: b,
    onValueNodeHasChildrenChange: y,
    contentId: Ss(),
    value: C,
    onValueChange: T,
    open: _,
    onOpenChange: x,
    dir: w,
    triggerPointerDownPosRef: D,
    disabled: h
  }, /* @__PURE__ */ E(Go.Provider, {
    scope: t
  }, /* @__PURE__ */ E(gm, {
    scope: e.__scopeSelect,
    onNativeOptionAdd: le((M) => {
      O(
        (W) => new Set(W).add(M)
      );
    }, []),
    onNativeOptionRemove: le((M) => {
      O((W) => {
        const K = new Set(W);
        return K.delete(M), K;
      });
    }, [])
  }, n)), S ? /* @__PURE__ */ E(qs, {
    key: I,
    "aria-hidden": !0,
    required: v,
    tabIndex: -1,
    name: u,
    autoComplete: d,
    value: C,
    onChange: (M) => T(M.target.value),
    disabled: h
  }, C === void 0 ? /* @__PURE__ */ E("option", {
    value: ""
  }) : null, Array.from(A)) : null));
}, ym = "SelectTrigger", wm = /* @__PURE__ */ z((e, t) => {
  const { __scopeSelect: n, disabled: o = !1, ...r } = e, i = gi(n), c = Yt(ym, n), a = c.disabled || o, s = be(t, c.onTriggerChange), l = Xo(n), [u, d, h] = Ks((p) => {
    const f = l().filter(
      ($) => !$.disabled
    ), g = f.find(
      ($) => $.value === c.value
    ), m = Ys(f, p, g);
    m !== void 0 && c.onValueChange(m.value);
  }), v = () => {
    a || (c.onOpenChange(!0), h());
  };
  return /* @__PURE__ */ E(em, F({
    asChild: !0
  }, i), /* @__PURE__ */ E(Ae.button, F({
    type: "button",
    role: "combobox",
    "aria-controls": c.contentId,
    "aria-expanded": c.open,
    "aria-required": c.required,
    "aria-autocomplete": "none",
    dir: c.dir,
    "data-state": c.open ? "open" : "closed",
    disabled: a,
    "data-disabled": a ? "" : void 0,
    "data-placeholder": c.value === void 0 ? "" : void 0
  }, r, {
    ref: s,
    onClick: he(r.onClick, (p) => {
      p.currentTarget.focus();
    }),
    onPointerDown: he(r.onPointerDown, (p) => {
      const f = p.target;
      f.hasPointerCapture(p.pointerId) && f.releasePointerCapture(p.pointerId), p.button === 0 && p.ctrlKey === !1 && (v(), c.triggerPointerDownPosRef.current = {
        x: Math.round(p.pageX),
        y: Math.round(p.pageY)
      }, p.preventDefault());
    }),
    onKeyDown: he(r.onKeyDown, (p) => {
      const f = u.current !== "";
      !(p.ctrlKey || p.altKey || p.metaKey) && p.key.length === 1 && d(p.key), !(f && p.key === " ") && vm.includes(p.key) && (v(), p.preventDefault());
    })
  })));
}), Cm = "SelectValue", xm = /* @__PURE__ */ z((e, t) => {
  const { __scopeSelect: n, className: o, style: r, children: i, placeholder: c, ...a } = e, s = Yt(Cm, n), { onValueNodeHasChildrenChange: l } = s, u = i !== void 0, d = be(t, s.onValueNodeChange);
  return Re(() => {
    l(u);
  }, [
    l,
    u
  ]), /* @__PURE__ */ E(Ae.span, F({}, a, {
    ref: d,
    style: {
      pointerEvents: "none"
    }
  }), s.value === void 0 && c !== void 0 ? c : i);
}), Em = /* @__PURE__ */ z((e, t) => {
  const { __scopeSelect: n, children: o, ...r } = e;
  return /* @__PURE__ */ E(Ae.span, F({
    "aria-hidden": !0
  }, r, {
    ref: t
  }), o || "▼");
}), _m = (e) => /* @__PURE__ */ E(nm, F({
  asChild: !0
}, e)), gn = "SelectContent", Sm = /* @__PURE__ */ z((e, t) => {
  const n = Yt(gn, e.__scopeSelect), [o, r] = Y();
  if (Re(() => {
    r(new DocumentFragment());
  }, []), !n.open) {
    const i = o;
    return i ? /* @__PURE__ */ da(/* @__PURE__ */ E(Us, {
      scope: e.__scopeSelect
    }, /* @__PURE__ */ E(Go.Slot, {
      scope: e.__scopeSelect
    }, /* @__PURE__ */ E("div", null, e.children))), i) : null;
  }
  return /* @__PURE__ */ E(Am, F({}, e, {
    ref: t
  }));
}), Ge = 10, [Us, jt] = Sn(gn), Am = /* @__PURE__ */ z((e, t) => {
  const {
    __scopeSelect: n,
    position: o = "item-aligned",
    onCloseAutoFocus: r,
    onEscapeKeyDown: i,
    onPointerDownOutside: c,
    side: a,
    sideOffset: s,
    align: l,
    alignOffset: u,
    arrowPadding: d,
    collisionBoundary: h,
    collisionPadding: v,
    sticky: p,
    hideWhenDetached: f,
    avoidCollisions: g,
    //
    ...m
  } = e, $ = Yt(gn, n), [b, y] = Y(null), [w, _] = Y(null), x = be(
    t,
    (L) => y(L)
  ), [C, T] = Y(null), [D, S] = Y(null), A = Xo(n), [O, I] = Y(!1), M = j(!1);
  G(() => {
    if (b)
      return Jr(b);
  }, [
    b
  ]), qp();
  const W = le((L) => {
    const [X, ...J] = A().map(
      (ne) => ne.ref.current
    ), [Z] = J.slice(-1), ie = document.activeElement;
    for (const ne of L)
      if (ne === ie || (ne == null || ne.scrollIntoView({
        block: "nearest"
      }), ne === X && w && (w.scrollTop = 0), ne === Z && w && (w.scrollTop = w.scrollHeight), ne == null || ne.focus(), document.activeElement !== ie))
        return;
  }, [
    A,
    w
  ]), K = le(
    () => W([
      C,
      b
    ]),
    [
      W,
      C,
      b
    ]
  );
  G(() => {
    O && K();
  }, [
    O,
    K
  ]);
  const { onOpenChange: B, triggerPointerDownPosRef: V } = $;
  G(() => {
    if (b) {
      let L = {
        x: 0,
        y: 0
      };
      const X = (Z) => {
        var ie, ne, k, Q;
        L = {
          x: Math.abs(Math.round(Z.pageX) - ((ie = (ne = V.current) === null || ne === void 0 ? void 0 : ne.x) !== null && ie !== void 0 ? ie : 0)),
          y: Math.abs(Math.round(Z.pageY) - ((k = (Q = V.current) === null || Q === void 0 ? void 0 : Q.y) !== null && k !== void 0 ? k : 0))
        };
      }, J = (Z) => {
        L.x <= 10 && L.y <= 10 ? Z.preventDefault() : b.contains(Z.target) || B(!1), document.removeEventListener("pointermove", X), V.current = null;
      };
      return V.current !== null && (document.addEventListener("pointermove", X), document.addEventListener("pointerup", J, {
        capture: !0,
        once: !0
      })), () => {
        document.removeEventListener("pointermove", X), document.removeEventListener("pointerup", J, {
          capture: !0
        });
      };
    }
  }, [
    b,
    B,
    V
  ]), G(() => {
    const L = () => B(!1);
    return window.addEventListener("blur", L), window.addEventListener("resize", L), () => {
      window.removeEventListener("blur", L), window.removeEventListener("resize", L);
    };
  }, [
    B
  ]);
  const [R, U] = Ks((L) => {
    const X = A().filter(
      (ie) => !ie.disabled
    ), J = X.find(
      (ie) => ie.ref.current === document.activeElement
    ), Z = Ys(X, L, J);
    Z && setTimeout(
      () => Z.ref.current.focus()
    );
  }), te = le((L, X, J) => {
    const Z = !M.current && !J;
    ($.value !== void 0 && $.value === X || Z) && (T(L), Z && (M.current = !0));
  }, [
    $.value
  ]), ue = le(
    () => b == null ? void 0 : b.focus(),
    [
      b
    ]
  ), re = le((L, X, J) => {
    const Z = !M.current && !J;
    ($.value !== void 0 && $.value === X || Z) && S(L);
  }, [
    $.value
  ]), de = o === "popper" ? Uc : Pm, N = de === Uc ? {
    side: a,
    sideOffset: s,
    align: l,
    alignOffset: u,
    arrowPadding: d,
    collisionBoundary: h,
    collisionPadding: v,
    sticky: p,
    hideWhenDetached: f,
    avoidCollisions: g
  } : {};
  return /* @__PURE__ */ E(Us, {
    scope: n,
    content: b,
    viewport: w,
    onViewportChange: _,
    itemRefCallback: te,
    selectedItem: C,
    onItemLeave: ue,
    itemTextRefCallback: re,
    focusSelectedItem: K,
    selectedItemText: D,
    position: o,
    isPositioned: O,
    searchRef: R
  }, /* @__PURE__ */ E(Zr, {
    as: Fn,
    allowPinchZoom: !0
  }, /* @__PURE__ */ E(Kp, {
    asChild: !0,
    trapped: $.open,
    onMountAutoFocus: (L) => {
      L.preventDefault();
    },
    onUnmountAutoFocus: he(r, (L) => {
      var X;
      (X = $.trigger) === null || X === void 0 || X.focus({
        preventScroll: !0
      }), L.preventDefault();
    })
  }, /* @__PURE__ */ E(Vp, {
    asChild: !0,
    disableOutsidePointerEvents: !0,
    onEscapeKeyDown: i,
    onPointerDownOutside: c,
    onFocusOutside: (L) => L.preventDefault(),
    onDismiss: () => $.onOpenChange(!1)
  }, /* @__PURE__ */ E(de, F({
    role: "listbox",
    id: $.contentId,
    "data-state": $.open ? "open" : "closed",
    dir: $.dir,
    onContextMenu: (L) => L.preventDefault()
  }, m, N, {
    onPlaced: () => I(!0),
    ref: x,
    style: {
      // flex layout so we can place the scroll buttons properly
      display: "flex",
      flexDirection: "column",
      // reset the outline by default as the content MAY get focused
      outline: "none",
      ...m.style
    },
    onKeyDown: he(m.onKeyDown, (L) => {
      const X = L.ctrlKey || L.altKey || L.metaKey;
      if (L.key === "Tab" && L.preventDefault(), !X && L.key.length === 1 && U(L.key), [
        "ArrowUp",
        "ArrowDown",
        "Home",
        "End"
      ].includes(L.key)) {
        let Z = A().filter(
          (ie) => !ie.disabled
        ).map(
          (ie) => ie.ref.current
        );
        if ([
          "ArrowUp",
          "End"
        ].includes(L.key) && (Z = Z.slice().reverse()), [
          "ArrowUp",
          "ArrowDown"
        ].includes(L.key)) {
          const ie = L.target, ne = Z.indexOf(ie);
          Z = Z.slice(ne + 1);
        }
        setTimeout(
          () => W(Z)
        ), L.preventDefault();
      }
    })
  }))))));
}), Pm = /* @__PURE__ */ z((e, t) => {
  const { __scopeSelect: n, onPlaced: o, ...r } = e, i = Yt(gn, n), c = jt(gn, n), [a, s] = Y(null), [l, u] = Y(null), d = be(
    t,
    (x) => u(x)
  ), h = Xo(n), v = j(!1), p = j(!0), { viewport: f, selectedItem: g, selectedItemText: m, focusSelectedItem: $ } = c, b = le(() => {
    if (i.trigger && i.valueNode && a && l && f && g && m) {
      const x = i.trigger.getBoundingClientRect(), C = l.getBoundingClientRect(), T = i.valueNode.getBoundingClientRect(), D = m.getBoundingClientRect();
      if (i.dir !== "rtl") {
        const ie = D.left - C.left, ne = T.left - ie, k = x.left - ne, Q = x.width + k, ye = Math.max(Q, C.width), Ee = window.innerWidth - Ge, je = _c(ne, [
          Ge,
          Ee - ye
        ]);
        a.style.minWidth = Q + "px", a.style.left = je + "px";
      } else {
        const ie = C.right - D.right, ne = window.innerWidth - T.right - ie, k = window.innerWidth - x.right - ne, Q = x.width + k, ye = Math.max(Q, C.width), Ee = window.innerWidth - Ge, je = _c(ne, [
          Ge,
          Ee - ye
        ]);
        a.style.minWidth = Q + "px", a.style.right = je + "px";
      }
      const S = h(), A = window.innerHeight - Ge * 2, O = f.scrollHeight, I = window.getComputedStyle(l), M = parseInt(I.borderTopWidth, 10), W = parseInt(I.paddingTop, 10), K = parseInt(I.borderBottomWidth, 10), B = parseInt(I.paddingBottom, 10), V = M + W + O + B + K, R = Math.min(g.offsetHeight * 5, V), U = window.getComputedStyle(f), te = parseInt(U.paddingTop, 10), ue = parseInt(U.paddingBottom, 10), re = x.top + x.height / 2 - Ge, de = A - re, N = g.offsetHeight / 2, L = g.offsetTop + N, X = M + W + L, J = V - X;
      if (X <= re) {
        const ie = g === S[S.length - 1].ref.current;
        a.style.bottom = "0px";
        const ne = l.clientHeight - f.offsetTop - f.offsetHeight, k = Math.max(de, N + (ie ? ue : 0) + ne + K), Q = X + k;
        a.style.height = Q + "px";
      } else {
        const ie = g === S[0].ref.current;
        a.style.top = "0px";
        const k = Math.max(re, M + f.offsetTop + (ie ? te : 0) + N) + J;
        a.style.height = k + "px", f.scrollTop = X - re + f.offsetTop;
      }
      a.style.margin = `${Ge}px 0`, a.style.minHeight = R + "px", a.style.maxHeight = A + "px", o == null || o(), requestAnimationFrame(
        () => v.current = !0
      );
    }
  }, [
    h,
    i.trigger,
    i.valueNode,
    a,
    l,
    f,
    g,
    m,
    i.dir,
    o
  ]);
  Re(
    () => b(),
    [
      b
    ]
  );
  const [y, w] = Y();
  Re(() => {
    l && w(window.getComputedStyle(l).zIndex);
  }, [
    l
  ]);
  const _ = le((x) => {
    x && p.current === !0 && (b(), $ == null || $(), p.current = !1);
  }, [
    b,
    $
  ]);
  return /* @__PURE__ */ E(Om, {
    scope: n,
    contentWrapper: a,
    shouldExpandOnScrollRef: v,
    onScrollButtonChange: _
  }, /* @__PURE__ */ E("div", {
    ref: s,
    style: {
      display: "flex",
      flexDirection: "column",
      position: "fixed",
      zIndex: y
    }
  }, /* @__PURE__ */ E(Ae.div, F({}, r, {
    ref: d,
    style: {
      // When we get the height of the content, it includes borders. If we were to set
      // the height without having `boxSizing: 'border-box'` it would be too big.
      boxSizing: "border-box",
      // We need to ensure the content doesn't get taller than the wrapper
      maxHeight: "100%",
      ...r.style
    }
  }))));
}), Uc = /* @__PURE__ */ z((e, t) => {
  const { __scopeSelect: n, align: o = "start", collisionPadding: r = Ge, ...i } = e, c = gi(n);
  return /* @__PURE__ */ E(tm, F({}, c, i, {
    ref: t,
    align: o,
    collisionPadding: r,
    style: {
      // Ensure border-box for floating-ui calculations
      boxSizing: "border-box",
      ...i.style,
      "--radix-select-content-transform-origin": "var(--radix-popper-transform-origin)",
      "--radix-select-content-available-width": "var(--radix-popper-available-width)",
      "--radix-select-content-available-height": "var(--radix-popper-available-height)",
      "--radix-select-trigger-width": "var(--radix-popper-anchor-width)",
      "--radix-select-trigger-height": "var(--radix-popper-anchor-height)"
    }
  }));
}), [Om, $i] = Sn(gn, {}), zc = "SelectViewport", Tm = /* @__PURE__ */ z((e, t) => {
  const { __scopeSelect: n, ...o } = e, r = jt(zc, n), i = $i(zc, n), c = be(t, r.onViewportChange), a = j(0);
  return /* @__PURE__ */ E(wn, null, /* @__PURE__ */ E("style", {
    dangerouslySetInnerHTML: {
      __html: "[data-radix-select-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-select-viewport]::-webkit-scrollbar{display:none}"
    }
  }), /* @__PURE__ */ E(Go.Slot, {
    scope: n
  }, /* @__PURE__ */ E(Ae.div, F({
    "data-radix-select-viewport": "",
    role: "presentation"
  }, o, {
    ref: c,
    style: {
      // we use position: 'relative' here on the `viewport` so that when we call
      // `selectedItem.offsetTop` in calculations, the offset is relative to the viewport
      // (independent of the scrollUpButton).
      position: "relative",
      flex: 1,
      overflow: "auto",
      ...o.style
    },
    onScroll: he(o.onScroll, (s) => {
      const l = s.currentTarget, { contentWrapper: u, shouldExpandOnScrollRef: d } = i;
      if (d != null && d.current && u) {
        const h = Math.abs(a.current - l.scrollTop);
        if (h > 0) {
          const v = window.innerHeight - Ge * 2, p = parseFloat(u.style.minHeight), f = parseFloat(u.style.height), g = Math.max(p, f);
          if (g < v) {
            const m = g + h, $ = Math.min(v, m), b = m - $;
            u.style.height = $ + "px", u.style.bottom === "0px" && (l.scrollTop = b > 0 ? b : 0, u.style.justifyContent = "flex-end");
          }
        }
      }
      a.current = l.scrollTop;
    })
  }))));
}), Dm = "SelectGroup";
Sn(Dm);
const Br = "SelectItem", [Rm, Nm] = Sn(Br), Im = /* @__PURE__ */ z((e, t) => {
  const { __scopeSelect: n, value: o, disabled: r = !1, textValue: i, ...c } = e, a = Yt(Br, n), s = jt(Br, n), l = a.value === o, [u, d] = Y(i ?? ""), [h, v] = Y(!1), p = be(t, (m) => {
    var $;
    return ($ = s.itemRefCallback) === null || $ === void 0 ? void 0 : $.call(s, m, o, r);
  }), f = Ss(), g = () => {
    r || (a.onValueChange(o), a.onOpenChange(!1));
  };
  return /* @__PURE__ */ E(Rm, {
    scope: n,
    value: o,
    disabled: r,
    textId: f,
    isSelected: l,
    onItemTextChange: le((m) => {
      d(($) => {
        var b;
        return $ || ((b = m == null ? void 0 : m.textContent) !== null && b !== void 0 ? b : "").trim();
      });
    }, [])
  }, /* @__PURE__ */ E(Go.ItemSlot, {
    scope: n,
    value: o,
    disabled: r,
    textValue: u
  }, /* @__PURE__ */ E(Ae.div, F({
    role: "option",
    "aria-labelledby": f,
    "data-highlighted": h ? "" : void 0,
    "aria-selected": l && h,
    "data-state": l ? "checked" : "unchecked",
    "aria-disabled": r || void 0,
    "data-disabled": r ? "" : void 0,
    tabIndex: r ? void 0 : -1
  }, c, {
    ref: p,
    onFocus: he(
      c.onFocus,
      () => v(!0)
    ),
    onBlur: he(
      c.onBlur,
      () => v(!1)
    ),
    onPointerUp: he(c.onPointerUp, g),
    onPointerMove: he(c.onPointerMove, (m) => {
      if (r) {
        var $;
        ($ = s.onItemLeave) === null || $ === void 0 || $.call(s);
      } else
        m.currentTarget.focus({
          preventScroll: !0
        });
    }),
    onPointerLeave: he(c.onPointerLeave, (m) => {
      if (m.currentTarget === document.activeElement) {
        var $;
        ($ = s.onItemLeave) === null || $ === void 0 || $.call(s);
      }
    }),
    onKeyDown: he(c.onKeyDown, (m) => {
      var $;
      (($ = s.searchRef) === null || $ === void 0 ? void 0 : $.current) !== "" && m.key === " " || (pm.includes(m.key) && g(), m.key === " " && m.preventDefault());
    })
  }))));
}), po = "SelectItemText", Lm = /* @__PURE__ */ z((e, t) => {
  const { __scopeSelect: n, className: o, style: r, ...i } = e, c = Yt(po, n), a = jt(po, n), s = Nm(po, n), l = $m(po, n), [u, d] = Y(null), h = be(
    t,
    (m) => d(m),
    s.onItemTextChange,
    (m) => {
      var $;
      return ($ = a.itemTextRefCallback) === null || $ === void 0 ? void 0 : $.call(a, m, s.value, s.disabled);
    }
  ), v = u == null ? void 0 : u.textContent, p = Fe(
    () => /* @__PURE__ */ E("option", {
      key: s.value,
      value: s.value,
      disabled: s.disabled
    }, v),
    [
      s.disabled,
      s.value,
      v
    ]
  ), { onNativeOptionAdd: f, onNativeOptionRemove: g } = l;
  return Re(() => (f(p), () => g(p)), [
    f,
    g,
    p
  ]), /* @__PURE__ */ E(wn, null, /* @__PURE__ */ E(Ae.span, F({
    id: s.textId
  }, i, {
    ref: h
  })), s.isSelected && c.valueNode && !c.valueNodeHasChildren ? /* @__PURE__ */ da(i.children, c.valueNode) : null);
}), qc = "SelectScrollUpButton", Mm = /* @__PURE__ */ z((e, t) => {
  const n = jt(qc, e.__scopeSelect), o = $i(qc, e.__scopeSelect), [r, i] = Y(!1), c = be(t, o.onScrollButtonChange);
  return Re(() => {
    if (n.viewport && n.isPositioned) {
      let s = function() {
        const l = a.scrollTop > 0;
        i(l);
      };
      const a = n.viewport;
      return s(), a.addEventListener("scroll", s), () => a.removeEventListener("scroll", s);
    }
  }, [
    n.viewport,
    n.isPositioned
  ]), r ? /* @__PURE__ */ E(zs, F({}, e, {
    ref: c,
    onAutoScroll: () => {
      const { viewport: a, selectedItem: s } = n;
      a && s && (a.scrollTop = a.scrollTop - s.offsetHeight);
    }
  })) : null;
}), Kc = "SelectScrollDownButton", km = /* @__PURE__ */ z((e, t) => {
  const n = jt(Kc, e.__scopeSelect), o = $i(Kc, e.__scopeSelect), [r, i] = Y(!1), c = be(t, o.onScrollButtonChange);
  return Re(() => {
    if (n.viewport && n.isPositioned) {
      let s = function() {
        const l = a.scrollHeight - a.clientHeight, u = Math.ceil(a.scrollTop) < l;
        i(u);
      };
      const a = n.viewport;
      return s(), a.addEventListener("scroll", s), () => a.removeEventListener("scroll", s);
    }
  }, [
    n.viewport,
    n.isPositioned
  ]), r ? /* @__PURE__ */ E(zs, F({}, e, {
    ref: c,
    onAutoScroll: () => {
      const { viewport: a, selectedItem: s } = n;
      a && s && (a.scrollTop = a.scrollTop + s.offsetHeight);
    }
  })) : null;
}), zs = /* @__PURE__ */ z((e, t) => {
  const { __scopeSelect: n, onAutoScroll: o, ...r } = e, i = jt("SelectScrollButton", n), c = j(null), a = Xo(n), s = le(() => {
    c.current !== null && (window.clearInterval(c.current), c.current = null);
  }, []);
  return G(() => () => s(), [
    s
  ]), Re(() => {
    var l;
    const u = a().find(
      (d) => d.ref.current === document.activeElement
    );
    u == null || (l = u.ref.current) === null || l === void 0 || l.scrollIntoView({
      block: "nearest"
    });
  }, [
    a
  ]), /* @__PURE__ */ E(Ae.div, F({
    "aria-hidden": !0
  }, r, {
    ref: t,
    style: {
      flexShrink: 0,
      ...r.style
    },
    onPointerDown: he(r.onPointerDown, () => {
      c.current === null && (c.current = window.setInterval(o, 50));
    }),
    onPointerMove: he(r.onPointerMove, () => {
      var l;
      (l = i.onItemLeave) === null || l === void 0 || l.call(i), c.current === null && (c.current = window.setInterval(o, 50));
    }),
    onPointerLeave: he(r.onPointerLeave, () => {
      s();
    })
  }));
}), qs = /* @__PURE__ */ z((e, t) => {
  const { value: n, ...o } = e, r = j(null), i = be(t, r), c = rm(n);
  return G(() => {
    const a = r.current, s = window.HTMLSelectElement.prototype, u = Object.getOwnPropertyDescriptor(s, "value").set;
    if (c !== n && u) {
      const d = new Event("change", {
        bubbles: !0
      });
      u.call(a, n), a.dispatchEvent(d);
    }
  }, [
    c,
    n
  ]), /* @__PURE__ */ E(fm, {
    asChild: !0
  }, /* @__PURE__ */ E("select", F({}, o, {
    ref: i,
    defaultValue: n
  })));
});
qs.displayName = "BubbleSelect";
function Ks(e) {
  const t = it(e), n = j(""), o = j(0), r = le((c) => {
    const a = n.current + c;
    t(a), function s(l) {
      n.current = l, window.clearTimeout(o.current), l !== "" && (o.current = window.setTimeout(
        () => s(""),
        1e3
      ));
    }(a);
  }, [
    t
  ]), i = le(() => {
    n.current = "", window.clearTimeout(o.current);
  }, []);
  return G(() => () => window.clearTimeout(o.current), []), [
    n,
    r,
    i
  ];
}
function Ys(e, t, n) {
  const r = t.length > 1 && Array.from(t).every(
    (l) => l === t[0]
  ) ? t[0] : t, i = n ? e.indexOf(n) : -1;
  let c = Fm(e, Math.max(i, 0));
  r.length === 1 && (c = c.filter(
    (l) => l !== n
  ));
  const s = c.find(
    (l) => l.textValue.toLowerCase().startsWith(r.toLowerCase())
  );
  return s !== n ? s : void 0;
}
function Fm(e, t) {
  return e.map(
    (n, o) => e[(t + o) % e.length]
  );
}
const bi = bm, yi = wm, wi = xm, Ci = Em, xi = _m, Ei = Sm, _i = Tm, Si = Im, Ai = Lm, Pi = Mm, Oi = km;
function Hm(e, t) {
  const n = [
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20,
    21,
    22,
    23,
    24,
    25,
    26,
    27,
    28,
    29
  ], o = n.concat([30]), r = o.concat([31]);
  if (e && t === void 0)
    switch (e) {
      case 1:
        return n;
      case 0:
      case 2:
      case 4:
      case 6:
      case 7:
      case 9:
      case 11:
        return r;
      default:
        return o;
    }
  if (t === void 0 || e === void 0)
    return r;
  const i = new Date(t, e + 1, 0).getDate();
  return Array.from({ length: i }, (a, s) => s + 1);
}
const js = rt(
  {}
), Ti = () => Vt(js);
function Bm({
  children: e,
  onDateComplete: t,
  date: n = null,
  portalClassName: o = ""
}) {
  const [r, i] = Y(), [c, a] = Y(), [s, l] = Y(), [u, d] = Y(!1), [h, v] = Y(!1), [p, f] = Y(!1), [g, m] = Y([]), $ = j([2e3, 0, 1]);
  G(() => {
    if (n !== null) {
      const y = me(n);
      i(y.year()), a(y.month()), isNaN(y.date()) || l(y.date());
    }
  }, [n]), G(() => {
    const y = Hm(c, r);
    if (m(y), r !== void 0 && ($.current[0] = r), c !== void 0 && ($.current[1] = c), s !== void 0 && ($.current[2] = s), (u && r !== void 0 || u === !1) && (h && c !== void 0 || h === !1) && (p && s !== void 0 || p === !1) && !(r === void 0 && c === void 0 && s === void 0)) {
      const D = `${($.current[1] ?? 0) + 1}/${$.current[2]}/${$.current[0]} EST`, S = new Date(D);
      t(S);
    }
  }, [r, c, s]);
  const b = {
    portalClassName: o,
    updateYear: (y) => i(y),
    updateMonth: (y) => a(y),
    updateDay: (y) => {
      isNaN(y) || l(y);
    },
    updateYearIsRequired: (y) => d(y),
    updateMonthIsRequired: (y) => v(y),
    updateDayIsRequired: (y) => f(y),
    validDays: g,
    day: s,
    month: c,
    year: r
  };
  return /* @__PURE__ */ P(js.Provider, { value: b, children: e });
}
function Di({
  children: e = null,
  onDateComplete: t,
  date: n,
  portalClassName: o
}) {
  return /* @__PURE__ */ P(
    Bm,
    {
      onDateComplete: t,
      date: n,
      portalClassName: o,
      children: e
    }
  );
}
function Wm({
  startYear: e = 1900,
  endYear: t = (/* @__PURE__ */ new Date()).getFullYear(),
  label: n = "Year",
  placeHolder: o = "",
  sortDescending: r = !1
}) {
  const { updateYear: i, updateYearIsRequired: c, year: a, portalClassName: s } = Ti();
  G(() => {
    c(!0);
  }, []);
  const l = Array.from({ length: t - e + 1 }, (u, d) => r ? t - d : e + d);
  return /* @__PURE__ */ se(
    bi,
    {
      value: a == null ? void 0 : a.toString(),
      onValueChange: (u) => i(parseInt(u)),
      children: [
        /* @__PURE__ */ se(
          yi,
          {
            className: "selectTrigger",
            "aria-label": n,
            "data-testid": "year selector trigger",
            children: [
              /* @__PURE__ */ P(wi, { placeholder: o }),
              /* @__PURE__ */ P(Ci, { className: "selectIcon", children: /* @__PURE__ */ P(nt, {}) })
            ]
          }
        ),
        /* @__PURE__ */ P(xi, { className: s, children: /* @__PURE__ */ P("div", { className: s, children: /* @__PURE__ */ se(Ei, { className: "selectContent", children: [
          /* @__PURE__ */ P(Pi, { className: "selectScrollButton", children: /* @__PURE__ */ P(nt, {}) }),
          /* @__PURE__ */ P(_i, { className: "selectViewport", children: l.map((u) => /* @__PURE__ */ P(
            Si,
            {
              className: "selectItem",
              value: u.toString(),
              children: /* @__PURE__ */ P(Ai, { children: u })
            },
            u
          )) }),
          /* @__PURE__ */ P(Oi, { className: "selectScrollButton", children: /* @__PURE__ */ P(nt, {}) })
        ] }) }) })
      ]
    }
  );
}
function Vm({
  label: e = "",
  monthNames: t = [],
  placeHolder: n = ""
}) {
  const { updateMonth: o, updateMonthIsRequired: r, month: i } = Ti();
  return G(() => {
    r(!0);
  }, []), /* @__PURE__ */ se(
    bi,
    {
      value: i == null ? void 0 : i.toString(),
      onValueChange: (c) => o(parseInt(c)),
      children: [
        /* @__PURE__ */ se(
          yi,
          {
            "data-testid": "month selector trigger",
            className: "selectTrigger",
            "aria-label": e,
            children: [
              /* @__PURE__ */ P(wi, { placeholder: n }),
              /* @__PURE__ */ P(Ci, { className: "selectIcon", children: /* @__PURE__ */ P(nt, {}) })
            ]
          }
        ),
        /* @__PURE__ */ P(xi, { children: /* @__PURE__ */ se(Ei, { className: "selectContent", children: [
          /* @__PURE__ */ P(Pi, { className: "selectScrollButton", children: /* @__PURE__ */ P(nt, {}) }),
          /* @__PURE__ */ P(_i, { className: "selectViewport", children: t.map((c, a) => /* @__PURE__ */ P(
            Si,
            {
              className: "selectItem",
              value: a.toString(),
              children: /* @__PURE__ */ P(Ai, { children: c })
            },
            c
          )) }),
          /* @__PURE__ */ P(Oi, { className: "selectScrollButton", children: /* @__PURE__ */ P(nt, {}) })
        ] }) })
      ]
    }
  );
}
function Um({ label: e = "", placeHolder: t = "" }) {
  const { day: n, updateDay: o, updateDayIsRequired: r, validDays: i } = Ti();
  return G(() => {
    r(!0);
  }, []), /* @__PURE__ */ se(
    bi,
    {
      value: n == null ? void 0 : n.toString(),
      onValueChange: (c) => o(parseInt(c)),
      children: [
        /* @__PURE__ */ se(
          yi,
          {
            "data-testid": "day selector trigger",
            className: "selectTrigger",
            "aria-label": e,
            children: [
              /* @__PURE__ */ P(wi, { placeholder: t }),
              /* @__PURE__ */ P(Ci, { className: "selectIcon", children: /* @__PURE__ */ P(nt, {}) })
            ]
          }
        ),
        /* @__PURE__ */ P(xi, { children: /* @__PURE__ */ se(Ei, { className: "selectContent", children: [
          /* @__PURE__ */ P(Pi, { className: "selectScrollButton", children: /* @__PURE__ */ P(nt, {}) }),
          /* @__PURE__ */ P(_i, { className: "selectViewport", children: i.map((c) => /* @__PURE__ */ P(
            Si,
            {
              className: "selectItem",
              value: c.toString(),
              children: /* @__PURE__ */ P(Ai, { children: c })
            },
            c
          )) }),
          /* @__PURE__ */ P(Oi, { className: "selectScrollButton", children: /* @__PURE__ */ P(nt, {}) })
        ] }) })
      ]
    }
  );
}
function nt({ fill: e = "#454545" }) {
  return /* @__PURE__ */ P(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      fill: "none",
      children: /* @__PURE__ */ P(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12.9202 4.84175C13.1672 4.59442 13.5677 4.59442 13.8147 4.84175C14.0618 5.08907 14.0618 5.49007 13.8147 5.7374L8.44729 11.1583C8.20026 11.4056 7.79974 11.4056 7.55271 11.1583L2.18527 5.7374C1.93824 5.49007 1.93824 5.08907 2.18527 4.84174C2.4323 4.59442 2.83282 4.59442 3.07985 4.84174L8 9.81477L12.9202 4.84175Z",
          fill: e
        }
      )
    }
  );
}
Di.YearSelector = Wm;
Di.MonthSelector = Vm;
Di.DaySelector = Um;
function Yc(e, t) {
  for (var n = 0; n < t.length; n++) {
    var o = t[n];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
  }
}
function zm(e, t, n) {
  return t && Yc(e.prototype, t), n && Yc(e, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var jc = "(prefers-reduced-motion: reduce)", ln = 1, qm = 2, $n = 3, An = 4, Jn = 5, yo = 6, Io = 7, Km = {
  CREATED: ln,
  MOUNTED: qm,
  IDLE: $n,
  MOVING: An,
  SCROLLING: Jn,
  DRAGGING: yo,
  DESTROYED: Io
};
function lt(e) {
  e.length = 0;
}
function Tt(e, t, n) {
  return Array.prototype.slice.call(e, t, n);
}
function ae(e) {
  return e.bind.apply(e, [null].concat(Tt(arguments, 1)));
}
var Gs = setTimeout, Wr = function() {
};
function Gc(e) {
  return requestAnimationFrame(e);
}
function Zo(e, t) {
  return typeof t === e;
}
function Wn(e) {
  return !Ni(e) && Zo("object", e);
}
var Ri = Array.isArray, Xs = ae(Zo, "function"), St = ae(Zo, "string"), Qn = ae(Zo, "undefined");
function Ni(e) {
  return e === null;
}
function Zs(e) {
  try {
    return e instanceof (e.ownerDocument.defaultView || window).HTMLElement;
  } catch {
    return !1;
  }
}
function eo(e) {
  return Ri(e) ? e : [e];
}
function Ie(e, t) {
  eo(e).forEach(t);
}
function Ii(e, t) {
  return e.indexOf(t) > -1;
}
function wo(e, t) {
  return e.push.apply(e, eo(t)), e;
}
function Je(e, t, n) {
  e && Ie(t, function(o) {
    o && e.classList[n ? "add" : "remove"](o);
  });
}
function qe(e, t) {
  Je(e, St(t) ? t.split(" ") : t, !0);
}
function to(e, t) {
  Ie(t, e.appendChild.bind(e));
}
function Li(e, t) {
  Ie(e, function(n) {
    var o = (t || n).parentNode;
    o && o.insertBefore(n, t);
  });
}
function Vn(e, t) {
  return Zs(e) && (e.msMatchesSelector || e.matches).call(e, t);
}
function Js(e, t) {
  var n = e ? Tt(e.children) : [];
  return t ? n.filter(function(o) {
    return Vn(o, t);
  }) : n;
}
function no(e, t) {
  return t ? Js(e, t)[0] : e.firstElementChild;
}
var Un = Object.keys;
function Ft(e, t, n) {
  return e && (n ? Un(e).reverse() : Un(e)).forEach(function(o) {
    o !== "__proto__" && t(e[o], o);
  }), e;
}
function zn(e) {
  return Tt(arguments, 1).forEach(function(t) {
    Ft(t, function(n, o) {
      e[o] = t[o];
    });
  }), e;
}
function bt(e) {
  return Tt(arguments, 1).forEach(function(t) {
    Ft(t, function(n, o) {
      Ri(n) ? e[o] = n.slice() : Wn(n) ? e[o] = bt({}, Wn(e[o]) ? e[o] : {}, n) : e[o] = n;
    });
  }), e;
}
function Xc(e, t) {
  Ie(t || Un(e), function(n) {
    delete e[n];
  });
}
function Ke(e, t) {
  Ie(e, function(n) {
    Ie(t, function(o) {
      n && n.removeAttribute(o);
    });
  });
}
function ee(e, t, n) {
  Wn(t) ? Ft(t, function(o, r) {
    ee(e, r, o);
  }) : Ie(e, function(o) {
    Ni(n) || n === "" ? Ke(o, t) : o.setAttribute(t, String(n));
  });
}
function fn(e, t, n) {
  var o = document.createElement(e);
  return t && (St(t) ? qe(o, t) : ee(o, t)), n && to(n, o), o;
}
function Me(e, t, n) {
  if (Qn(n))
    return getComputedStyle(e)[t];
  Ni(n) || (e.style[t] = "" + n);
}
function qn(e, t) {
  Me(e, "display", t);
}
function Qs(e) {
  e.setActive && e.setActive() || e.focus({
    preventScroll: !0
  });
}
function ke(e, t) {
  return e.getAttribute(t);
}
function Zc(e, t) {
  return e && e.classList.contains(t);
}
function Oe(e) {
  return e.getBoundingClientRect();
}
function Bt(e) {
  Ie(e, function(t) {
    t && t.parentNode && t.parentNode.removeChild(t);
  });
}
function el(e) {
  return no(new DOMParser().parseFromString(e, "text/html").body);
}
function Xe(e, t) {
  e.preventDefault(), t && (e.stopPropagation(), e.stopImmediatePropagation());
}
function tl(e, t) {
  return e && e.querySelector(t);
}
function Mi(e, t) {
  return t ? Tt(e.querySelectorAll(t)) : [];
}
function Qe(e, t) {
  Je(e, t, !1);
}
function Vr(e) {
  return e.timeStamp;
}
function Nt(e) {
  return St(e) ? e : e ? e + "px" : "";
}
var oo = "splide", ki = "data-" + oo;
function Nn(e, t) {
  if (!e)
    throw new Error("[" + oo + "] " + (t || ""));
}
var At = Math.min, Lo = Math.max, Mo = Math.floor, Kn = Math.ceil, xe = Math.abs;
function nl(e, t, n) {
  return xe(e - t) < n;
}
function Co(e, t, n, o) {
  var r = At(t, n), i = Lo(t, n);
  return o ? r < e && e < i : r <= e && e <= i;
}
function nn(e, t, n) {
  var o = At(t, n), r = Lo(t, n);
  return At(Lo(o, e), r);
}
function Ur(e) {
  return +(e > 0) - +(e < 0);
}
function zr(e, t) {
  return Ie(t, function(n) {
    e = e.replace("%s", "" + n);
  }), e;
}
function Fi(e) {
  return e < 10 ? "0" + e : "" + e;
}
var Jc = {};
function Ym(e) {
  return "" + e + Fi(Jc[e] = (Jc[e] || 0) + 1);
}
function ol() {
  var e = [];
  function t(c, a, s, l) {
    r(c, a, function(u, d, h) {
      var v = "addEventListener" in u, p = v ? u.removeEventListener.bind(u, d, s, l) : u.removeListener.bind(u, s);
      v ? u.addEventListener(d, s, l) : u.addListener(s), e.push([u, d, h, s, p]);
    });
  }
  function n(c, a, s) {
    r(c, a, function(l, u, d) {
      e = e.filter(function(h) {
        return h[0] === l && h[1] === u && h[2] === d && (!s || h[3] === s) ? (h[4](), !1) : !0;
      });
    });
  }
  function o(c, a, s) {
    var l, u = !0;
    return typeof CustomEvent == "function" ? l = new CustomEvent(a, {
      bubbles: u,
      detail: s
    }) : (l = document.createEvent("CustomEvent"), l.initCustomEvent(a, u, !1, s)), c.dispatchEvent(l), l;
  }
  function r(c, a, s) {
    Ie(c, function(l) {
      l && Ie(a, function(u) {
        u.split(" ").forEach(function(d) {
          var h = d.split(".");
          s(l, h[0], h[1]);
        });
      });
    });
  }
  function i() {
    e.forEach(function(c) {
      c[4]();
    }), lt(e);
  }
  return {
    bind: t,
    unbind: n,
    dispatch: o,
    destroy: i
  };
}
var Dt = "mounted", qr = "ready", ut = "move", Pn = "moved", Hi = "click", rl = "active", il = "inactive", cl = "visible", al = "hidden", pe = "refresh", Ce = "updated", bn = "resize", Jo = "resized", sl = "drag", ll = "dragging", ul = "dragged", Qo = "scroll", Gt = "scrolled", jm = "overflow", Bi = "destroy", dl = "arrows:mounted", fl = "arrows:updated", vl = "pagination:mounted", pl = "pagination:updated", Wi = "navigation:mounted", Vi = "autoplay:play", hl = "autoplay:playing", Ui = "autoplay:pause", zi = "lazyload:loaded", ml = "sk", gl = "sh", ko = "ei";
function fe(e) {
  var t = e ? e.event.bus : document.createDocumentFragment(), n = ol();
  function o(i, c) {
    n.bind(t, eo(i).join(" "), function(a) {
      c.apply(c, Ri(a.detail) ? a.detail : []);
    });
  }
  function r(i) {
    n.dispatch(t, i, Tt(arguments, 1));
  }
  return e && e.event.on(Bi, n.destroy), zn(n, {
    bus: t,
    on: o,
    off: ae(n.unbind, t),
    emit: r
  });
}
function er(e, t, n, o) {
  var r = Date.now, i, c = 0, a, s = !0, l = 0;
  function u() {
    if (!s) {
      if (c = e ? At((r() - i) / e, 1) : 1, n && n(c), c >= 1 && (t(), i = r(), o && ++l >= o))
        return h();
      a = Gc(u);
    }
  }
  function d(m) {
    m || p(), i = r() - (m ? c * e : 0), s = !1, a = Gc(u);
  }
  function h() {
    s = !0;
  }
  function v() {
    i = r(), c = 0, n && n(c);
  }
  function p() {
    a && cancelAnimationFrame(a), c = 0, a = 0, s = !0;
  }
  function f(m) {
    e = m;
  }
  function g() {
    return s;
  }
  return {
    start: d,
    rewind: v,
    pause: h,
    cancel: p,
    set: f,
    isPaused: g
  };
}
function Gm(e) {
  var t = e;
  function n(r) {
    t = r;
  }
  function o(r) {
    return Ii(eo(r), t);
  }
  return {
    set: n,
    is: o
  };
}
function Xm(e, t) {
  var n = er(t || 0, e, null, 1);
  return function() {
    n.isPaused() && n.start();
  };
}
function Zm(e, t, n) {
  var o = e.state, r = n.breakpoints || {}, i = n.reducedMotion || {}, c = ol(), a = [];
  function s() {
    var p = n.mediaQuery === "min";
    Un(r).sort(function(f, g) {
      return p ? +f - +g : +g - +f;
    }).forEach(function(f) {
      u(r[f], "(" + (p ? "min" : "max") + "-width:" + f + "px)");
    }), u(i, jc), d();
  }
  function l(p) {
    p && c.destroy();
  }
  function u(p, f) {
    var g = matchMedia(f);
    c.bind(g, "change", d), a.push([p, g]);
  }
  function d() {
    var p = o.is(Io), f = n.direction, g = a.reduce(function(m, $) {
      return bt(m, $[1].matches ? $[0] : {});
    }, {});
    Xc(n), v(g), n.destroy ? e.destroy(n.destroy === "completely") : p ? (l(!0), e.mount()) : f !== n.direction && e.refresh();
  }
  function h(p) {
    matchMedia(jc).matches && (p ? bt(n, i) : Xc(n, Un(i)));
  }
  function v(p, f, g) {
    bt(n, p), f && bt(Object.getPrototypeOf(n), p), (g || !o.is(ln)) && e.emit(Ce, n);
  }
  return {
    setup: s,
    destroy: l,
    reduce: h,
    set: v
  };
}
var tr = "Arrow", nr = tr + "Left", or = tr + "Right", $l = tr + "Up", bl = tr + "Down", Qc = "rtl", rr = "ttb", yr = {
  width: ["height"],
  left: ["top", "right"],
  right: ["bottom", "left"],
  x: ["y"],
  X: ["Y"],
  Y: ["X"],
  ArrowLeft: [$l, or],
  ArrowRight: [bl, nr]
};
function Jm(e, t, n) {
  function o(i, c, a) {
    a = a || n.direction;
    var s = a === Qc && !c ? 1 : a === rr ? 0 : -1;
    return yr[i] && yr[i][s] || i.replace(/width|left|right/i, function(l, u) {
      var d = yr[l.toLowerCase()][s] || l;
      return u > 0 ? d.charAt(0).toUpperCase() + d.slice(1) : d;
    });
  }
  function r(i) {
    return i * (n.direction === Qc ? 1 : -1);
  }
  return {
    resolve: o,
    orient: r
  };
}
var ot = "role", vn = "tabindex", Qm = "disabled", Be = "aria-", ro = Be + "controls", yl = Be + "current", ea = Be + "selected", Te = Be + "label", qi = Be + "labelledby", wl = Be + "hidden", Ki = Be + "orientation", Yn = Be + "roledescription", ta = Be + "live", na = Be + "busy", oa = Be + "atomic", Yi = [ot, vn, Qm, ro, yl, Te, qi, wl, Ki, Yn], Ye = oo + "__", Rt = "is-", wr = oo, ra = Ye + "track", e0 = Ye + "list", ir = Ye + "slide", Cl = ir + "--clone", t0 = ir + "__container", ji = Ye + "arrows", cr = Ye + "arrow", xl = cr + "--prev", El = cr + "--next", ar = Ye + "pagination", _l = ar + "__page", n0 = Ye + "progress", o0 = n0 + "__bar", r0 = Ye + "toggle", i0 = Ye + "spinner", c0 = Ye + "sr", a0 = Rt + "initialized", Wt = Rt + "active", Sl = Rt + "prev", Al = Rt + "next", Kr = Rt + "visible", Yr = Rt + "loading", Pl = Rt + "focus-in", Ol = Rt + "overflow", s0 = [Wt, Kr, Sl, Al, Yr, Pl, Ol], l0 = {
  slide: ir,
  clone: Cl,
  arrows: ji,
  arrow: cr,
  prev: xl,
  next: El,
  pagination: ar,
  page: _l,
  spinner: i0
};
function u0(e, t) {
  if (Xs(e.closest))
    return e.closest(t);
  for (var n = e; n && n.nodeType === 1 && !Vn(n, t); )
    n = n.parentElement;
  return n;
}
var d0 = 5, ia = 200, Tl = "touchstart mousedown", Cr = "touchmove mousemove", xr = "touchend touchcancel mouseup click";
function f0(e, t, n) {
  var o = fe(e), r = o.on, i = o.bind, c = e.root, a = n.i18n, s = {}, l = [], u = [], d = [], h, v, p;
  function f() {
    b(), y(), $();
  }
  function g() {
    r(pe, m), r(pe, f), r(Ce, $), i(document, Tl + " keydown", function(x) {
      p = x.type === "keydown";
    }, {
      capture: !0
    }), i(c, "focusin", function() {
      Je(c, Pl, !!p);
    });
  }
  function m(x) {
    var C = Yi.concat("style");
    lt(l), Qe(c, u), Qe(h, d), Ke([h, v], C), Ke(c, x ? C : ["style", Yn]);
  }
  function $() {
    Qe(c, u), Qe(h, d), u = _(wr), d = _(ra), qe(c, u), qe(h, d), ee(c, Te, n.label), ee(c, qi, n.labelledby);
  }
  function b() {
    h = w("." + ra), v = no(h, "." + e0), Nn(h && v, "A track/list element is missing."), wo(l, Js(v, "." + ir + ":not(." + Cl + ")")), Ft({
      arrows: ji,
      pagination: ar,
      prev: xl,
      next: El,
      bar: o0,
      toggle: r0
    }, function(x, C) {
      s[C] = w("." + x);
    }), zn(s, {
      root: c,
      track: h,
      list: v,
      slides: l
    });
  }
  function y() {
    var x = c.id || Ym(oo), C = n.role;
    c.id = x, h.id = h.id || x + "-track", v.id = v.id || x + "-list", !ke(c, ot) && c.tagName !== "SECTION" && C && ee(c, ot, C), ee(c, Yn, a.carousel), ee(v, ot, "presentation");
  }
  function w(x) {
    var C = tl(c, x);
    return C && u0(C, "." + wr) === c ? C : void 0;
  }
  function _(x) {
    return [x + "--" + n.type, x + "--" + n.direction, n.drag && x + "--draggable", n.isNavigation && x + "--nav", x === wr && Wt];
  }
  return zn(s, {
    setup: f,
    mount: g,
    destroy: m
  });
}
var yn = "slide", On = "loop", io = "fade";
function v0(e, t, n, o) {
  var r = fe(e), i = r.on, c = r.emit, a = r.bind, s = e.Components, l = e.root, u = e.options, d = u.isNavigation, h = u.updateOnMove, v = u.i18n, p = u.pagination, f = u.slideFocus, g = s.Direction.resolve, m = ke(o, "style"), $ = ke(o, Te), b = n > -1, y = no(o, "." + t0), w;
  function _() {
    b || (o.id = l.id + "-slide" + Fi(t + 1), ee(o, ot, p ? "tabpanel" : "group"), ee(o, Yn, v.slide), ee(o, Te, $ || zr(v.slideLabel, [t + 1, e.length]))), x();
  }
  function x() {
    a(o, "click", ae(c, Hi, B)), a(o, "keydown", ae(c, ml, B)), i([Pn, gl, Gt], S), i(Wi, T), h && i(ut, D);
  }
  function C() {
    w = !0, r.destroy(), Qe(o, s0), Ke(o, Yi), ee(o, "style", m), ee(o, Te, $ || "");
  }
  function T() {
    var V = e.splides.map(function(R) {
      var U = R.splide.Components.Slides.getAt(t);
      return U ? U.slide.id : "";
    }).join(" ");
    ee(o, Te, zr(v.slideX, (b ? n : t) + 1)), ee(o, ro, V), ee(o, ot, f ? "button" : ""), f && Ke(o, Yn);
  }
  function D() {
    w || S();
  }
  function S() {
    if (!w) {
      var V = e.index;
      A(), O(), Je(o, Sl, t === V - 1), Je(o, Al, t === V + 1);
    }
  }
  function A() {
    var V = M();
    V !== Zc(o, Wt) && (Je(o, Wt, V), ee(o, yl, d && V || ""), c(V ? rl : il, B));
  }
  function O() {
    var V = W(), R = !V && (!M() || b);
    if (e.state.is([An, Jn]) || ee(o, wl, R || ""), ee(Mi(o, u.focusableNodes || ""), vn, R ? -1 : ""), f && ee(o, vn, R ? -1 : 0), V !== Zc(o, Kr) && (Je(o, Kr, V), c(V ? cl : al, B)), !V && document.activeElement === o) {
      var U = s.Slides.getAt(e.index);
      U && Qs(U.slide);
    }
  }
  function I(V, R, U) {
    Me(U && y || o, V, R);
  }
  function M() {
    var V = e.index;
    return V === t || u.cloneStatus && V === n;
  }
  function W() {
    if (e.is(io))
      return M();
    var V = Oe(s.Elements.track), R = Oe(o), U = g("left", !0), te = g("right", !0);
    return Mo(V[U]) <= Kn(R[U]) && Mo(R[te]) <= Kn(V[te]);
  }
  function K(V, R) {
    var U = xe(V - t);
    return !b && (u.rewind || e.is(On)) && (U = At(U, e.length - U)), U <= R;
  }
  var B = {
    index: t,
    slideIndex: n,
    slide: o,
    container: y,
    isClone: b,
    mount: _,
    destroy: C,
    update: S,
    style: I,
    isWithin: K
  };
  return B;
}
function p0(e, t, n) {
  var o = fe(e), r = o.on, i = o.emit, c = o.bind, a = t.Elements, s = a.slides, l = a.list, u = [];
  function d() {
    h(), r(pe, v), r(pe, h);
  }
  function h() {
    s.forEach(function(S, A) {
      f(S, A, -1);
    });
  }
  function v() {
    w(function(S) {
      S.destroy();
    }), lt(u);
  }
  function p() {
    w(function(S) {
      S.update();
    });
  }
  function f(S, A, O) {
    var I = v0(e, A, O, S);
    I.mount(), u.push(I), u.sort(function(M, W) {
      return M.index - W.index;
    });
  }
  function g(S) {
    return S ? _(function(A) {
      return !A.isClone;
    }) : u;
  }
  function m(S) {
    var A = t.Controller, O = A.toIndex(S), I = A.hasFocus() ? 1 : n.perPage;
    return _(function(M) {
      return Co(M.index, O, O + I - 1);
    });
  }
  function $(S) {
    return _(S)[0];
  }
  function b(S, A) {
    Ie(S, function(O) {
      if (St(O) && (O = el(O)), Zs(O)) {
        var I = s[A];
        I ? Li(O, I) : to(l, O), qe(O, n.classes.slide), C(O, ae(i, bn));
      }
    }), i(pe);
  }
  function y(S) {
    Bt(_(S).map(function(A) {
      return A.slide;
    })), i(pe);
  }
  function w(S, A) {
    g(A).forEach(S);
  }
  function _(S) {
    return u.filter(Xs(S) ? S : function(A) {
      return St(S) ? Vn(A.slide, S) : Ii(eo(S), A.index);
    });
  }
  function x(S, A, O) {
    w(function(I) {
      I.style(S, A, O);
    });
  }
  function C(S, A) {
    var O = Mi(S, "img"), I = O.length;
    I ? O.forEach(function(M) {
      c(M, "load error", function() {
        --I || A();
      });
    }) : A();
  }
  function T(S) {
    return S ? s.length : u.length;
  }
  function D() {
    return u.length > n.perPage;
  }
  return {
    mount: d,
    destroy: v,
    update: p,
    register: f,
    get: g,
    getIn: m,
    getAt: $,
    add: b,
    remove: y,
    forEach: w,
    filter: _,
    style: x,
    getLength: T,
    isEnough: D
  };
}
function h0(e, t, n) {
  var o = fe(e), r = o.on, i = o.bind, c = o.emit, a = t.Slides, s = t.Direction.resolve, l = t.Elements, u = l.root, d = l.track, h = l.list, v = a.getAt, p = a.style, f, g, m;
  function $() {
    b(), i(window, "resize load", Xm(ae(c, bn))), r([Ce, pe], b), r(bn, y);
  }
  function b() {
    f = n.direction === rr, Me(u, "maxWidth", Nt(n.width)), Me(d, s("paddingLeft"), w(!1)), Me(d, s("paddingRight"), w(!0)), y(!0);
  }
  function y(B) {
    var V = Oe(u);
    (B || g.width !== V.width || g.height !== V.height) && (Me(d, "height", _()), p(s("marginRight"), Nt(n.gap)), p("width", C()), p("height", T(), !0), g = V, c(Jo), m !== (m = K()) && (Je(u, Ol, m), c(jm, m)));
  }
  function w(B) {
    var V = n.padding, R = s(B ? "right" : "left");
    return V && Nt(V[R] || (Wn(V) ? 0 : V)) || "0px";
  }
  function _() {
    var B = "";
    return f && (B = x(), Nn(B, "height or heightRatio is missing."), B = "calc(" + B + " - " + w(!1) + " - " + w(!0) + ")"), B;
  }
  function x() {
    return Nt(n.height || Oe(h).width * n.heightRatio);
  }
  function C() {
    return n.autoWidth ? null : Nt(n.fixedWidth) || (f ? "" : D());
  }
  function T() {
    return Nt(n.fixedHeight) || (f ? n.autoHeight ? null : D() : x());
  }
  function D() {
    var B = Nt(n.gap);
    return "calc((100%" + (B && " + " + B) + ")/" + (n.perPage || 1) + (B && " - " + B) + ")";
  }
  function S() {
    return Oe(h)[s("width")];
  }
  function A(B, V) {
    var R = v(B || 0);
    return R ? Oe(R.slide)[s("width")] + (V ? 0 : M()) : 0;
  }
  function O(B, V) {
    var R = v(B);
    if (R) {
      var U = Oe(R.slide)[s("right")], te = Oe(h)[s("left")];
      return xe(U - te) + (V ? 0 : M());
    }
    return 0;
  }
  function I(B) {
    return O(e.length - 1) - O(0) + A(0, B);
  }
  function M() {
    var B = v(0);
    return B && parseFloat(Me(B.slide, s("marginRight"))) || 0;
  }
  function W(B) {
    return parseFloat(Me(d, s("padding" + (B ? "Right" : "Left")))) || 0;
  }
  function K() {
    return e.is(io) || I(!0) > S();
  }
  return {
    mount: $,
    resize: y,
    listSize: S,
    slideSize: A,
    sliderSize: I,
    totalSize: O,
    getPadding: W,
    isOverflow: K
  };
}
var m0 = 2;
function g0(e, t, n) {
  var o = fe(e), r = o.on, i = t.Elements, c = t.Slides, a = t.Direction.resolve, s = [], l;
  function u() {
    r(pe, d), r([Ce, bn], v), (l = g()) && (p(l), t.Layout.resize(!0));
  }
  function d() {
    h(), u();
  }
  function h() {
    Bt(s), lt(s), o.destroy();
  }
  function v() {
    var m = g();
    l !== m && (l < m || !m) && o.emit(pe);
  }
  function p(m) {
    var $ = c.get().slice(), b = $.length;
    if (b) {
      for (; $.length < m; )
        wo($, $);
      wo($.slice(-m), $.slice(0, m)).forEach(function(y, w) {
        var _ = w < m, x = f(y.slide, w);
        _ ? Li(x, $[0].slide) : to(i.list, x), wo(s, x), c.register(x, w - m + (_ ? 0 : b), y.index);
      });
    }
  }
  function f(m, $) {
    var b = m.cloneNode(!0);
    return qe(b, n.classes.clone), b.id = e.root.id + "-clone" + Fi($ + 1), b;
  }
  function g() {
    var m = n.clones;
    if (!e.is(On))
      m = 0;
    else if (Qn(m)) {
      var $ = n[a("fixedWidth")] && t.Layout.slideSize(0), b = $ && Kn(Oe(i.track)[a("width")] / $);
      m = b || n[a("autoWidth")] && e.length || n.perPage * m0;
    }
    return m;
  }
  return {
    mount: u,
    destroy: h
  };
}
function $0(e, t, n) {
  var o = fe(e), r = o.on, i = o.emit, c = e.state.set, a = t.Layout, s = a.slideSize, l = a.getPadding, u = a.totalSize, d = a.listSize, h = a.sliderSize, v = t.Direction, p = v.resolve, f = v.orient, g = t.Elements, m = g.list, $ = g.track, b;
  function y() {
    b = t.Transition, r([Dt, Jo, Ce, pe], w);
  }
  function w() {
    t.Controller.isBusy() || (t.Scroll.cancel(), x(e.index), t.Slides.update());
  }
  function _(R, U, te, ue) {
    R !== U && B(R > te) && (S(), C(D(I(), R > te), !0)), c(An), i(ut, U, te, R), b.start(U, function() {
      c($n), i(Pn, U, te, R), ue && ue();
    });
  }
  function x(R) {
    C(O(R, !0));
  }
  function C(R, U) {
    if (!e.is(io)) {
      var te = U ? R : T(R);
      Me(m, "transform", "translate" + p("X") + "(" + te + "px)"), R !== te && i(gl);
    }
  }
  function T(R) {
    if (e.is(On)) {
      var U = A(R), te = U > t.Controller.getEnd(), ue = U < 0;
      (ue || te) && (R = D(R, te));
    }
    return R;
  }
  function D(R, U) {
    var te = R - K(U), ue = h();
    return R -= f(ue * (Kn(xe(te) / ue) || 1)) * (U ? 1 : -1), R;
  }
  function S() {
    C(I(), !0), b.cancel();
  }
  function A(R) {
    for (var U = t.Slides.get(), te = 0, ue = 1 / 0, re = 0; re < U.length; re++) {
      var de = U[re].index, N = xe(O(de, !0) - R);
      if (N <= ue)
        ue = N, te = de;
      else
        break;
    }
    return te;
  }
  function O(R, U) {
    var te = f(u(R - 1) - W(R));
    return U ? M(te) : te;
  }
  function I() {
    var R = p("left");
    return Oe(m)[R] - Oe($)[R] + f(l(!1));
  }
  function M(R) {
    return n.trimSpace && e.is(yn) && (R = nn(R, 0, f(h(!0) - d()))), R;
  }
  function W(R) {
    var U = n.focus;
    return U === "center" ? (d() - s(R, !0)) / 2 : +U * s(R) || 0;
  }
  function K(R) {
    return O(R ? t.Controller.getEnd() : 0, !!n.trimSpace);
  }
  function B(R) {
    var U = f(D(I(), R));
    return R ? U >= 0 : U <= m[p("scrollWidth")] - Oe($)[p("width")];
  }
  function V(R, U) {
    U = Qn(U) ? I() : U;
    var te = R !== !0 && f(U) < f(K(!1)), ue = R !== !1 && f(U) > f(K(!0));
    return te || ue;
  }
  return {
    mount: y,
    move: _,
    jump: x,
    translate: C,
    shift: D,
    cancel: S,
    toIndex: A,
    toPosition: O,
    getPosition: I,
    getLimit: K,
    exceededLimit: V,
    reposition: w
  };
}
function b0(e, t, n) {
  var o = fe(e), r = o.on, i = o.emit, c = t.Move, a = c.getPosition, s = c.getLimit, l = c.toPosition, u = t.Slides, d = u.isEnough, h = u.getLength, v = n.omitEnd, p = e.is(On), f = e.is(yn), g = ae(I, !1), m = ae(I, !0), $ = n.start || 0, b, y = $, w, _, x;
  function C() {
    T(), r([Ce, pe, ko], T), r(Jo, D);
  }
  function T() {
    w = h(!0), _ = n.perMove, x = n.perPage, b = B();
    var N = nn($, 0, v ? b : w - 1);
    N !== $ && ($ = N, c.reposition());
  }
  function D() {
    b !== B() && i(ko);
  }
  function S(N, L, X) {
    if (!de()) {
      var J = O(N), Z = K(J);
      Z > -1 && (L || Z !== $) && (te(Z), c.move(J, Z, y, X));
    }
  }
  function A(N, L, X, J) {
    t.Scroll.scroll(N, L, X, function() {
      var Z = K(c.toIndex(a()));
      te(v ? At(Z, b) : Z), J && J();
    });
  }
  function O(N) {
    var L = $;
    if (St(N)) {
      var X = N.match(/([+\-<>])(\d+)?/) || [], J = X[1], Z = X[2];
      J === "+" || J === "-" ? L = M($ + +("" + J + (+Z || 1)), $) : J === ">" ? L = Z ? V(+Z) : g(!0) : J === "<" && (L = m(!0));
    } else
      L = p ? N : nn(N, 0, b);
    return L;
  }
  function I(N, L) {
    var X = _ || (re() ? 1 : x), J = M($ + X * (N ? -1 : 1), $, !(_ || re()));
    return J === -1 && f && !nl(a(), s(!N), 1) ? N ? 0 : b : L ? J : K(J);
  }
  function M(N, L, X) {
    if (d() || re()) {
      var J = W(N);
      J !== N && (L = N, N = J, X = !1), N < 0 || N > b ? !_ && (Co(0, N, L, !0) || Co(b, L, N, !0)) ? N = V(R(N)) : p ? N = X ? N < 0 ? -(w % x || x) : w : N : n.rewind ? N = N < 0 ? b : 0 : N = -1 : X && N !== L && (N = V(R(L) + (N < L ? -1 : 1)));
    } else
      N = -1;
    return N;
  }
  function W(N) {
    if (f && n.trimSpace === "move" && N !== $)
      for (var L = a(); L === l(N, !0) && Co(N, 0, e.length - 1, !n.rewind); )
        N < $ ? --N : ++N;
    return N;
  }
  function K(N) {
    return p ? (N + w) % w || 0 : N;
  }
  function B() {
    for (var N = w - (re() || p && _ ? 1 : x); v && N-- > 0; )
      if (l(w - 1, !0) !== l(N, !0)) {
        N++;
        break;
      }
    return nn(N, 0, w - 1);
  }
  function V(N) {
    return nn(re() ? N : x * N, 0, b);
  }
  function R(N) {
    return re() ? At(N, b) : Mo((N >= b ? w - 1 : N) / x);
  }
  function U(N) {
    var L = c.toIndex(N);
    return f ? nn(L, 0, b) : L;
  }
  function te(N) {
    N !== $ && (y = $, $ = N);
  }
  function ue(N) {
    return N ? y : $;
  }
  function re() {
    return !Qn(n.focus) || n.isNavigation;
  }
  function de() {
    return e.state.is([An, Jn]) && !!n.waitForTransition;
  }
  return {
    mount: C,
    go: S,
    scroll: A,
    getNext: g,
    getPrev: m,
    getAdjacent: I,
    getEnd: B,
    setIndex: te,
    getIndex: ue,
    toIndex: V,
    toPage: R,
    toDest: U,
    hasFocus: re,
    isBusy: de
  };
}
var y0 = "http://www.w3.org/2000/svg", w0 = "m15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z", ho = 40;
function C0(e, t, n) {
  var o = fe(e), r = o.on, i = o.bind, c = o.emit, a = n.classes, s = n.i18n, l = t.Elements, u = t.Controller, d = l.arrows, h = l.track, v = d, p = l.prev, f = l.next, g, m, $ = {};
  function b() {
    w(), r(Ce, y);
  }
  function y() {
    _(), b();
  }
  function w() {
    var A = n.arrows;
    A && !(p && f) && T(), p && f && (zn($, {
      prev: p,
      next: f
    }), qn(v, A ? "" : "none"), qe(v, m = ji + "--" + n.direction), A && (x(), S(), ee([p, f], ro, h.id), c(dl, p, f)));
  }
  function _() {
    o.destroy(), Qe(v, m), g ? (Bt(d ? [p, f] : v), p = f = null) : Ke([p, f], Yi);
  }
  function x() {
    r([Dt, Pn, pe, Gt, ko], S), i(f, "click", ae(C, ">")), i(p, "click", ae(C, "<"));
  }
  function C(A) {
    u.go(A, !0);
  }
  function T() {
    v = d || fn("div", a.arrows), p = D(!0), f = D(!1), g = !0, to(v, [p, f]), !d && Li(v, h);
  }
  function D(A) {
    var O = '<button class="' + a.arrow + " " + (A ? a.prev : a.next) + '" type="button"><svg xmlns="' + y0 + '" viewBox="0 0 ' + ho + " " + ho + '" width="' + ho + '" height="' + ho + '" focusable="false"><path d="' + (n.arrowPath || w0) + '" />';
    return el(O);
  }
  function S() {
    if (p && f) {
      var A = e.index, O = u.getPrev(), I = u.getNext(), M = O > -1 && A < O ? s.last : s.prev, W = I > -1 && A > I ? s.first : s.next;
      p.disabled = O < 0, f.disabled = I < 0, ee(p, Te, M), ee(f, Te, W), c(fl, p, f, O, I);
    }
  }
  return {
    arrows: $,
    mount: b,
    destroy: _,
    update: S
  };
}
var x0 = ki + "-interval";
function E0(e, t, n) {
  var o = fe(e), r = o.on, i = o.bind, c = o.emit, a = er(n.interval, e.go.bind(e, ">"), x), s = a.isPaused, l = t.Elements, u = t.Elements, d = u.root, h = u.toggle, v = n.autoplay, p, f, g = v === "pause";
  function m() {
    v && ($(), h && ee(h, ro, l.track.id), g || b(), _());
  }
  function $() {
    n.pauseOnHover && i(d, "mouseenter mouseleave", function(T) {
      p = T.type === "mouseenter", w();
    }), n.pauseOnFocus && i(d, "focusin focusout", function(T) {
      f = T.type === "focusin", w();
    }), h && i(h, "click", function() {
      g ? b() : y(!0);
    }), r([ut, Qo, pe], a.rewind), r(ut, C);
  }
  function b() {
    s() && t.Slides.isEnough() && (a.start(!n.resetProgress), f = p = g = !1, _(), c(Vi));
  }
  function y(T) {
    T === void 0 && (T = !0), g = !!T, _(), s() || (a.pause(), c(Ui));
  }
  function w() {
    g || (p || f ? y(!1) : b());
  }
  function _() {
    h && (Je(h, Wt, !g), ee(h, Te, n.i18n[g ? "play" : "pause"]));
  }
  function x(T) {
    var D = l.bar;
    D && Me(D, "width", T * 100 + "%"), c(hl, T);
  }
  function C(T) {
    var D = t.Slides.getAt(T);
    a.set(D && +ke(D.slide, x0) || n.interval);
  }
  return {
    mount: m,
    destroy: a.cancel,
    play: b,
    pause: y,
    isPaused: s
  };
}
function _0(e, t, n) {
  var o = fe(e), r = o.on;
  function i() {
    n.cover && (r(zi, ae(a, !0)), r([Dt, Ce, pe], ae(c, !0)));
  }
  function c(s) {
    t.Slides.forEach(function(l) {
      var u = no(l.container || l.slide, "img");
      u && u.src && a(s, u, l);
    });
  }
  function a(s, l, u) {
    u.style("background", s ? 'center/cover no-repeat url("' + l.src + '")' : "", !0), qn(l, s ? "none" : "");
  }
  return {
    mount: i,
    destroy: ae(c, !1)
  };
}
var S0 = 10, A0 = 600, P0 = 0.6, O0 = 1.5, T0 = 800;
function D0(e, t, n) {
  var o = fe(e), r = o.on, i = o.emit, c = e.state.set, a = t.Move, s = a.getPosition, l = a.getLimit, u = a.exceededLimit, d = a.translate, h = e.is(yn), v, p, f = 1;
  function g() {
    r(ut, y), r([Ce, pe], w);
  }
  function m(x, C, T, D, S) {
    var A = s();
    if (y(), T && (!h || !u())) {
      var O = t.Layout.sliderSize(), I = Ur(x) * O * Mo(xe(x) / O) || 0;
      x = a.toPosition(t.Controller.toDest(x % O)) + I;
    }
    var M = nl(A, x, 1);
    f = 1, C = M ? 0 : C || Lo(xe(x - A) / O0, T0), p = D, v = er(C, $, ae(b, A, x, S), 1), c(Jn), i(Qo), v.start();
  }
  function $() {
    c($n), p && p(), i(Gt);
  }
  function b(x, C, T, D) {
    var S = s(), A = x + (C - x) * _(D), O = (A - S) * f;
    d(S + O), h && !T && u() && (f *= P0, xe(O) < S0 && m(l(u(!0)), A0, !1, p, !0));
  }
  function y() {
    v && v.cancel();
  }
  function w() {
    v && !v.isPaused() && (y(), $());
  }
  function _(x) {
    var C = n.easingFunc;
    return C ? C(x) : 1 - Math.pow(1 - x, 4);
  }
  return {
    mount: g,
    destroy: y,
    scroll: m,
    cancel: w
  };
}
var on = {
  passive: !1,
  capture: !0
};
function R0(e, t, n) {
  var o = fe(e), r = o.on, i = o.emit, c = o.bind, a = o.unbind, s = e.state, l = t.Move, u = t.Scroll, d = t.Controller, h = t.Elements.track, v = t.Media.reduce, p = t.Direction, f = p.resolve, g = p.orient, m = l.getPosition, $ = l.exceededLimit, b, y, w, _, x, C = !1, T, D, S;
  function A() {
    c(h, Cr, Wr, on), c(h, xr, Wr, on), c(h, Tl, I, on), c(h, "click", K, {
      capture: !0
    }), c(h, "dragstart", Xe), r([Dt, Ce], O);
  }
  function O() {
    var k = n.drag;
    ne(!k), _ = k === "free";
  }
  function I(k) {
    if (T = !1, !D) {
      var Q = Z(k);
      J(k.target) && (Q || !k.button) && (d.isBusy() ? Xe(k, !0) : (S = Q ? h : window, x = s.is([An, Jn]), w = null, c(S, Cr, M, on), c(S, xr, W, on), l.cancel(), u.cancel(), B(k)));
    }
  }
  function M(k) {
    if (s.is(yo) || (s.set(yo), i(sl)), k.cancelable)
      if (x) {
        l.translate(b + X(re(k)));
        var Q = de(k) > ia, ye = C !== (C = $());
        (Q || ye) && B(k), T = !0, i(ll), Xe(k);
      } else
        U(k) && (x = R(k), Xe(k));
  }
  function W(k) {
    s.is(yo) && (s.set($n), i(ul)), x && (V(k), Xe(k)), a(S, Cr, M), a(S, xr, W), x = !1;
  }
  function K(k) {
    !D && T && Xe(k, !0);
  }
  function B(k) {
    w = y, y = k, b = m();
  }
  function V(k) {
    var Q = te(k), ye = ue(Q), Ee = n.rewind && n.rewindByDrag;
    v(!1), _ ? d.scroll(ye, 0, n.snap) : e.is(io) ? d.go(g(Ur(Q)) < 0 ? Ee ? "<" : "-" : Ee ? ">" : "+") : e.is(yn) && C && Ee ? d.go($(!0) ? ">" : "<") : d.go(d.toDest(ye), !0), v(!0);
  }
  function R(k) {
    var Q = n.dragMinThreshold, ye = Wn(Q), Ee = ye && Q.mouse || 0, je = (ye ? Q.touch : +Q) || 10;
    return xe(re(k)) > (Z(k) ? je : Ee);
  }
  function U(k) {
    return xe(re(k)) > xe(re(k, !0));
  }
  function te(k) {
    if (e.is(On) || !C) {
      var Q = de(k);
      if (Q && Q < ia)
        return re(k) / Q;
    }
    return 0;
  }
  function ue(k) {
    return m() + Ur(k) * At(xe(k) * (n.flickPower || 600), _ ? 1 / 0 : t.Layout.listSize() * (n.flickMaxPages || 1));
  }
  function re(k, Q) {
    return L(k, Q) - L(N(k), Q);
  }
  function de(k) {
    return Vr(k) - Vr(N(k));
  }
  function N(k) {
    return y === k && w || y;
  }
  function L(k, Q) {
    return (Z(k) ? k.changedTouches[0] : k)["page" + f(Q ? "Y" : "X")];
  }
  function X(k) {
    return k / (C && e.is(yn) ? d0 : 1);
  }
  function J(k) {
    var Q = n.noDrag;
    return !Vn(k, "." + _l + ", ." + cr) && (!Q || !Vn(k, Q));
  }
  function Z(k) {
    return typeof TouchEvent < "u" && k instanceof TouchEvent;
  }
  function ie() {
    return x;
  }
  function ne(k) {
    D = k;
  }
  return {
    mount: A,
    disable: ne,
    isDragging: ie
  };
}
var N0 = {
  Spacebar: " ",
  Right: or,
  Left: nr,
  Up: $l,
  Down: bl
};
function Gi(e) {
  return e = St(e) ? e : e.key, N0[e] || e;
}
var ca = "keydown";
function I0(e, t, n) {
  var o = fe(e), r = o.on, i = o.bind, c = o.unbind, a = e.root, s = t.Direction.resolve, l, u;
  function d() {
    h(), r(Ce, v), r(Ce, h), r(ut, f);
  }
  function h() {
    var m = n.keyboard;
    m && (l = m === "global" ? window : a, i(l, ca, g));
  }
  function v() {
    c(l, ca);
  }
  function p(m) {
    u = m;
  }
  function f() {
    var m = u;
    u = !0, Gs(function() {
      u = m;
    });
  }
  function g(m) {
    if (!u) {
      var $ = Gi(m);
      $ === s(nr) ? e.go("<") : $ === s(or) && e.go(">");
    }
  }
  return {
    mount: d,
    destroy: v,
    disable: p
  };
}
var In = ki + "-lazy", xo = In + "-srcset", L0 = "[" + In + "], [" + xo + "]";
function M0(e, t, n) {
  var o = fe(e), r = o.on, i = o.off, c = o.bind, a = o.emit, s = n.lazyLoad === "sequential", l = [Pn, Gt], u = [];
  function d() {
    n.lazyLoad && (h(), r(pe, h));
  }
  function h() {
    lt(u), v(), s ? m() : (i(l), r(l, p), p());
  }
  function v() {
    t.Slides.forEach(function($) {
      Mi($.slide, L0).forEach(function(b) {
        var y = ke(b, In), w = ke(b, xo);
        if (y !== b.src || w !== b.srcset) {
          var _ = n.classes.spinner, x = b.parentElement, C = no(x, "." + _) || fn("span", _, x);
          u.push([b, $, C]), b.src || qn(b, "none");
        }
      });
    });
  }
  function p() {
    u = u.filter(function($) {
      var b = n.perPage * ((n.preloadPages || 1) + 1) - 1;
      return $[1].isWithin(e.index, b) ? f($) : !0;
    }), u.length || i(l);
  }
  function f($) {
    var b = $[0];
    qe($[1].slide, Yr), c(b, "load error", ae(g, $)), ee(b, "src", ke(b, In)), ee(b, "srcset", ke(b, xo)), Ke(b, In), Ke(b, xo);
  }
  function g($, b) {
    var y = $[0], w = $[1];
    Qe(w.slide, Yr), b.type !== "error" && (Bt($[2]), qn(y, ""), a(zi, y, w), a(bn)), s && m();
  }
  function m() {
    u.length && f(u.shift());
  }
  return {
    mount: d,
    destroy: ae(lt, u),
    check: p
  };
}
function k0(e, t, n) {
  var o = fe(e), r = o.on, i = o.emit, c = o.bind, a = t.Slides, s = t.Elements, l = t.Controller, u = l.hasFocus, d = l.getIndex, h = l.go, v = t.Direction.resolve, p = s.pagination, f = [], g, m;
  function $() {
    b(), r([Ce, pe, ko], $);
    var D = n.pagination;
    p && qn(p, D ? "" : "none"), D && (r([ut, Qo, Gt], T), y(), T(), i(vl, {
      list: g,
      items: f
    }, C(e.index)));
  }
  function b() {
    g && (Bt(p ? Tt(g.children) : g), Qe(g, m), lt(f), g = null), o.destroy();
  }
  function y() {
    var D = e.length, S = n.classes, A = n.i18n, O = n.perPage, I = u() ? l.getEnd() + 1 : Kn(D / O);
    g = p || fn("ul", S.pagination, s.track.parentElement), qe(g, m = ar + "--" + x()), ee(g, ot, "tablist"), ee(g, Te, A.select), ee(g, Ki, x() === rr ? "vertical" : "");
    for (var M = 0; M < I; M++) {
      var W = fn("li", null, g), K = fn("button", {
        class: S.page,
        type: "button"
      }, W), B = a.getIn(M).map(function(R) {
        return R.slide.id;
      }), V = !u() && O > 1 ? A.pageX : A.slideX;
      c(K, "click", ae(w, M)), n.paginationKeyboard && c(K, "keydown", ae(_, M)), ee(W, ot, "presentation"), ee(K, ot, "tab"), ee(K, ro, B.join(" ")), ee(K, Te, zr(V, M + 1)), ee(K, vn, -1), f.push({
        li: W,
        button: K,
        page: M
      });
    }
  }
  function w(D) {
    h(">" + D, !0);
  }
  function _(D, S) {
    var A = f.length, O = Gi(S), I = x(), M = -1;
    O === v(or, !1, I) ? M = ++D % A : O === v(nr, !1, I) ? M = (--D + A) % A : O === "Home" ? M = 0 : O === "End" && (M = A - 1);
    var W = f[M];
    W && (Qs(W.button), h(">" + M), Xe(S, !0));
  }
  function x() {
    return n.paginationDirection || n.direction;
  }
  function C(D) {
    return f[l.toPage(D)];
  }
  function T() {
    var D = C(d(!0)), S = C(d());
    if (D) {
      var A = D.button;
      Qe(A, Wt), Ke(A, ea), ee(A, vn, -1);
    }
    if (S) {
      var O = S.button;
      qe(O, Wt), ee(O, ea, !0), ee(O, vn, "");
    }
    i(pl, {
      list: g,
      items: f
    }, D, S);
  }
  return {
    items: f,
    mount: $,
    destroy: b,
    getAt: C,
    update: T
  };
}
var F0 = [" ", "Enter"];
function H0(e, t, n) {
  var o = n.isNavigation, r = n.slideFocus, i = [];
  function c() {
    e.splides.forEach(function(p) {
      p.isParent || (l(e, p.splide), l(p.splide, e));
    }), o && u();
  }
  function a() {
    i.forEach(function(p) {
      p.destroy();
    }), lt(i);
  }
  function s() {
    a(), c();
  }
  function l(p, f) {
    var g = fe(p);
    g.on(ut, function(m, $, b) {
      f.go(f.is(On) ? b : m);
    }), i.push(g);
  }
  function u() {
    var p = fe(e), f = p.on;
    f(Hi, h), f(ml, v), f([Dt, Ce], d), i.push(p), p.emit(Wi, e.splides);
  }
  function d() {
    ee(t.Elements.list, Ki, n.direction === rr ? "vertical" : "");
  }
  function h(p) {
    e.go(p.index);
  }
  function v(p, f) {
    Ii(F0, Gi(f)) && (h(p), Xe(f));
  }
  return {
    setup: ae(t.Media.set, {
      slideFocus: Qn(r) ? o : r
    }, !0),
    mount: c,
    destroy: a,
    remount: s
  };
}
function B0(e, t, n) {
  var o = fe(e), r = o.bind, i = 0;
  function c() {
    n.wheel && r(t.Elements.track, "wheel", a, on);
  }
  function a(l) {
    if (l.cancelable) {
      var u = l.deltaY, d = u < 0, h = Vr(l), v = n.wheelMinThreshold || 0, p = n.wheelSleep || 0;
      xe(u) > v && h - i > p && (e.go(d ? "<" : ">"), i = h), s(d) && Xe(l);
    }
  }
  function s(l) {
    return !n.releaseWheel || e.state.is(An) || t.Controller.getAdjacent(l) !== -1;
  }
  return {
    mount: c
  };
}
var W0 = 90;
function V0(e, t, n) {
  var o = fe(e), r = o.on, i = t.Elements.track, c = n.live && !n.isNavigation, a = fn("span", c0), s = er(W0, ae(u, !1));
  function l() {
    c && (h(!t.Autoplay.isPaused()), ee(i, oa, !0), a.textContent = "…", r(Vi, ae(h, !0)), r(Ui, ae(h, !1)), r([Pn, Gt], ae(u, !0)));
  }
  function u(v) {
    ee(i, na, v), v ? (to(i, a), s.start()) : (Bt(a), s.cancel());
  }
  function d() {
    Ke(i, [ta, oa, na]), Bt(a);
  }
  function h(v) {
    c && ee(i, ta, v ? "off" : "polite");
  }
  return {
    mount: l,
    disable: h,
    destroy: d
  };
}
var U0 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  Media: Zm,
  Direction: Jm,
  Elements: f0,
  Slides: p0,
  Layout: h0,
  Clones: g0,
  Move: $0,
  Controller: b0,
  Arrows: C0,
  Autoplay: E0,
  Cover: _0,
  Scroll: D0,
  Drag: R0,
  Keyboard: I0,
  LazyLoad: M0,
  Pagination: k0,
  Sync: H0,
  Wheel: B0,
  Live: V0
}), z0 = {
  prev: "Previous slide",
  next: "Next slide",
  first: "Go to first slide",
  last: "Go to last slide",
  slideX: "Go to slide %s",
  pageX: "Go to page %s",
  play: "Start autoplay",
  pause: "Pause autoplay",
  carousel: "carousel",
  slide: "slide",
  select: "Select a slide to show",
  slideLabel: "%s of %s"
}, q0 = {
  type: "slide",
  role: "region",
  speed: 400,
  perPage: 1,
  cloneStatus: !0,
  arrows: !0,
  pagination: !0,
  paginationKeyboard: !0,
  interval: 5e3,
  pauseOnHover: !0,
  pauseOnFocus: !0,
  resetProgress: !0,
  easing: "cubic-bezier(0.25, 1, 0.5, 1)",
  drag: !0,
  direction: "ltr",
  trimSpace: !0,
  focusableNodes: "a, button, textarea, input, select, iframe",
  live: !0,
  classes: l0,
  i18n: z0,
  reducedMotion: {
    speed: 0,
    rewindSpeed: 0,
    autoplay: "pause"
  }
};
function K0(e, t, n) {
  var o = t.Slides;
  function r() {
    fe(e).on([Dt, pe], i);
  }
  function i() {
    o.forEach(function(a) {
      a.style("transform", "translateX(-" + 100 * a.index + "%)");
    });
  }
  function c(a, s) {
    o.style("transition", "opacity " + n.speed + "ms " + n.easing), Gs(s);
  }
  return {
    mount: r,
    start: c,
    cancel: Wr
  };
}
function Y0(e, t, n) {
  var o = t.Move, r = t.Controller, i = t.Scroll, c = t.Elements.list, a = ae(Me, c, "transition"), s;
  function l() {
    fe(e).bind(c, "transitionend", function(v) {
      v.target === c && s && (d(), s());
    });
  }
  function u(v, p) {
    var f = o.toPosition(v, !0), g = o.getPosition(), m = h(v);
    xe(f - g) >= 1 && m >= 1 ? n.useScroll ? i.scroll(f, m, !1, p) : (a("transform " + m + "ms " + n.easing), o.translate(f, !0), s = p) : (o.jump(v), p());
  }
  function d() {
    a(""), i.cancel();
  }
  function h(v) {
    var p = n.rewindSpeed;
    if (e.is(yn) && p) {
      var f = r.getIndex(!0), g = r.getEnd();
      if (f === 0 && v >= g || f >= g && v === 0)
        return p;
    }
    return n.speed;
  }
  return {
    mount: l,
    start: u,
    cancel: d
  };
}
var j0 = /* @__PURE__ */ function() {
  function e(n, o) {
    this.event = fe(), this.Components = {}, this.state = Gm(ln), this.splides = [], this._o = {}, this._E = {};
    var r = St(n) ? tl(document, n) : n;
    Nn(r, r + " is invalid."), this.root = r, o = bt({
      label: ke(r, Te) || "",
      labelledby: ke(r, qi) || ""
    }, q0, e.defaults, o || {});
    try {
      bt(o, JSON.parse(ke(r, ki)));
    } catch {
      Nn(!1, "Invalid JSON");
    }
    this._o = Object.create(bt({}, o));
  }
  var t = e.prototype;
  return t.mount = function(o, r) {
    var i = this, c = this.state, a = this.Components;
    Nn(c.is([ln, Io]), "Already mounted!"), c.set(ln), this._C = a, this._T = r || this._T || (this.is(io) ? K0 : Y0), this._E = o || this._E;
    var s = zn({}, U0, this._E, {
      Transition: this._T
    });
    return Ft(s, function(l, u) {
      var d = l(i, a, i._o);
      a[u] = d, d.setup && d.setup();
    }), Ft(a, function(l) {
      l.mount && l.mount();
    }), this.emit(Dt), qe(this.root, a0), c.set($n), this.emit(qr), this;
  }, t.sync = function(o) {
    return this.splides.push({
      splide: o
    }), o.splides.push({
      splide: this,
      isParent: !0
    }), this.state.is($n) && (this._C.Sync.remount(), o.Components.Sync.remount()), this;
  }, t.go = function(o) {
    return this._C.Controller.go(o), this;
  }, t.on = function(o, r) {
    return this.event.on(o, r), this;
  }, t.off = function(o) {
    return this.event.off(o), this;
  }, t.emit = function(o) {
    var r;
    return (r = this.event).emit.apply(r, [o].concat(Tt(arguments, 1))), this;
  }, t.add = function(o, r) {
    return this._C.Slides.add(o, r), this;
  }, t.remove = function(o) {
    return this._C.Slides.remove(o), this;
  }, t.is = function(o) {
    return this._o.type === o;
  }, t.refresh = function() {
    return this.emit(pe), this;
  }, t.destroy = function(o) {
    o === void 0 && (o = !0);
    var r = this.event, i = this.state;
    return i.is(ln) ? fe(this).on(qr, this.destroy.bind(this, o)) : (Ft(this._C, function(c) {
      c.destroy && c.destroy(o);
    }, !0), r.emit(Bi), r.destroy(), o && lt(this.splides), i.set(Io)), this;
  }, zm(e, [{
    key: "options",
    get: function() {
      return this._o;
    },
    set: function(o) {
      this._C.Media.set(o, !0, !0);
    }
  }, {
    key: "length",
    get: function() {
      return this._C.Slides.getLength(!0);
    }
  }, {
    key: "index",
    get: function() {
      return this._C.Controller.getIndex();
    }
  }]), e;
}(), Xi = j0;
Xi.defaults = {};
Xi.STATES = Km;
var aa = [
  [Dt, "onMounted"],
  [qr, "onReady"],
  [ut, "onMove"],
  [Pn, "onMoved"],
  [Hi, "onClick"],
  [rl, "onActive"],
  [il, "onInactive"],
  [cl, "onVisible"],
  [al, "onHidden"],
  [pe, "onRefresh"],
  [Ce, "onUpdated"],
  [bn, "onResize"],
  [Jo, "onResized"],
  [sl, "onDrag"],
  [ll, "onDragging"],
  [ul, "onDragged"],
  [Qo, "onScroll"],
  [Gt, "onScrolled"],
  [Bi, "onDestroy"],
  [dl, "onArrowsMounted"],
  [fl, "onArrowsUpdated"],
  [vl, "onPaginationMounted"],
  [pl, "onPaginationUpdated"],
  [Wi, "onNavigationMounted"],
  [Vi, "onAutoplayPlay"],
  [hl, "onAutoplayPlaying"],
  [Ui, "onAutoplayPause"],
  [zi, "onLazyLoadLoaded"]
];
function Zi(...e) {
  return e.filter(Boolean).join(" ");
}
function Fo(e) {
  return e !== null && typeof e == "object";
}
function jr(e, t) {
  if (Array.isArray(e) && Array.isArray(t))
    return e.length === t.length && !e.some((n, o) => !jr(n, t[o]));
  if (Fo(e) && Fo(t)) {
    const n = Object.keys(e), o = Object.keys(t);
    return n.length === o.length && !n.some((r) => !Object.prototype.hasOwnProperty.call(t, r) || !jr(e[r], t[r]));
  }
  return e === t;
}
function G0(e, t) {
  return e.length === t.length && !e.some((n, o) => n !== t[o]);
}
function X0(e, t) {
  if (e) {
    const n = Object.keys(e);
    for (let o = 0; o < n.length; o++) {
      const r = n[o];
      if (r !== "__proto__" && t(e[r], r) === !1)
        break;
    }
  }
  return e;
}
function Gr(e, t) {
  const n = e;
  return X0(t, (o, r) => {
    Array.isArray(o) ? n[r] = o.slice() : Fo(o) ? n[r] = Gr(Fo(n[r]) ? n[r] : {}, o) : n[r] = o;
  }), n;
}
var Dl = ({ children: e, className: t, ...n }) => /* @__PURE__ */ q.createElement("div", {
  className: Zi("splide__track", t),
  ...n
}, /* @__PURE__ */ q.createElement("ul", {
  className: "splide__list"
}, e)), Z0 = class extends q.Component {
  constructor() {
    super(...arguments), this.splideRef = q.createRef(), this.slides = [];
  }
  componentDidMount() {
    const { options: e, extensions: t, transition: n } = this.props, { current: o } = this.splideRef;
    o && (this.splide = new Xi(o, e), this.bind(this.splide), this.splide.mount(t, n), this.options = Gr({}, e || {}), this.slides = this.getSlides());
  }
  componentWillUnmount() {
    this.splide && (this.splide.destroy(), this.splide = void 0), this.options = void 0, this.slides.length = 0;
  }
  componentDidUpdate() {
    if (!this.splide)
      return;
    const { options: e } = this.props;
    e && !jr(this.options, e) && (this.splide.options = e, this.options = Gr({}, e));
    const t = this.getSlides();
    G0(this.slides, t) || (this.splide.refresh(), this.slides = t);
  }
  sync(e) {
    var t;
    (t = this.splide) == null || t.sync(e);
  }
  go(e) {
    var t;
    (t = this.splide) == null || t.go(e);
  }
  getSlides() {
    var e;
    if (this.splide) {
      const t = (e = this.splide.Components.Elements) == null ? void 0 : e.list.children;
      return t && Array.prototype.slice.call(t) || [];
    }
    return [];
  }
  bind(e) {
    aa.forEach(([t, n]) => {
      const o = this.props[n];
      typeof o == "function" && e.on(t, (...r) => {
        o(e, ...r);
      });
    });
  }
  omit(e, t) {
    return t.forEach((n) => {
      Object.prototype.hasOwnProperty.call(e, n) && delete e[n];
    }), e;
  }
  render() {
    const { className: e, tag: t = "div", hasTrack: n = !0, children: o, ...r } = this.props;
    return /* @__PURE__ */ q.createElement(t, {
      className: Zi("splide", e),
      ref: this.splideRef,
      ...this.omit(r, ["options", ...aa.map((i) => i[1])])
    }, n ? /* @__PURE__ */ q.createElement(Dl, null, o) : o);
  }
}, J0 = ({ children: e, className: t, ...n }) => /* @__PURE__ */ q.createElement("li", {
  className: Zi("splide__slide", t),
  ...n
}, e);
/*!
 * Splide.js
 * Version  : 4.1.3
 * License  : MIT
 * Copyright: 2022 Naotoshi Fujita
 */
const Er = {
  default: "_default_14pth_4"
};
function Q0(e, t) {
  return e.map((n, o) => /* @__PURE__ */ P(J0, { className: t, children: n.children }, o));
}
function Eg({
  carouselItemClassname: e = "",
  carouselItems: t,
  className: n = "",
  preset: o = "default",
  onActive: r,
  options: i = {
    arrows: !0,
    breakpoints: {},
    classes: {},
    fixedWidth: "100px",
    gap: "16px",
    mediaQuery: "min",
    perMove: 1,
    perPage: 1,
    type: "loop",
    width: "1024px",
    arrowPath: eg
  },
  ...c
}) {
  const a = {
    default: Er.default,
    noStyle: Er.noStyle
  };
  return /* @__PURE__ */ se(
    Z0,
    {
      hasTrack: !1,
      onActive: r,
      options: i,
      className: oe(Er.carousel, a[o], n),
      ...c,
      children: [
        /* @__PURE__ */ P(Dl, { children: Q0(t, e) }),
        /* @__PURE__ */ P("div", { className: "splide__arrows" })
      ]
    }
  );
}
const eg = "M8.97393 5.17228L24 20L8.97754 34.8277C8.24259 35.5338 7.21366 37.3697 8.97754 39.0643C10.7414 40.7589 12.6523 39.7704 13.3872 39.0643L15.5921 36.946L31.0261 22.118C32.79 20.4233 31.761 18.5875 31.0261 17.8814L24.4115 11.5265L13.3872 0.935695C11.6234 -0.758939 9.71009 0.229598 8.97393 0.935695C7.21005 2.63033 8.23898 4.46618 8.97393 5.17228Z", tg = "_assessment_1njq9_5", ng = "_dialogOverlay_1njq9_5", og = "_dialogContent_1njq9_11", rg = "_dialogTitle_1njq9_30", ig = "_dialogDescription_1njq9_34", cg = "_dialogCloseWrapper_1njq9_38", ag = "_dialogClose_1njq9_38", ht = {
  assessment: tg,
  dialogOverlay: ng,
  dialogContent: og,
  dialogTitle: rg,
  dialogDescription: ig,
  dialogCloseWrapper: cg,
  dialogClose: ag
};
function _g({
  isOpen: e,
  trigger: t,
  title: {
    asChild: n,
    dialogTitle: o,
    className: r,
    ...i
  },
  description: {
    asChild: c,
    dialogDescription: a,
    className: s,
    ...l
  },
  close: { dialogCTA: u, className: d, attributes: h },
  overlay: {
    asChild: v,
    className: p,
    ...f
  } = {},
  content: {
    asChild: g,
    className: m,
    ...$
  } = {},
  preset: b = "default",
  onOpenChange: y
}) {
  const w = !t && { open: e, onOpenChange: y }, _ = {
    default: ht.default,
    assessment: ht.assessment
  };
  return /* @__PURE__ */ se(Ia, { ...w, children: [
    t && /* @__PURE__ */ P(La, { asChild: !0, children: t }),
    /* @__PURE__ */ P(Ma, { children: /* @__PURE__ */ se("div", { className: _[b], children: [
      /* @__PURE__ */ P(
        ka,
        {
          asChild: v,
          className: oe(ht.dialogOverlay, p),
          ...f
        }
      ),
      /* @__PURE__ */ se(
        Fa,
        {
          onOpenAutoFocus: (x) => {
            x.preventDefault();
          },
          asChild: g,
          className: oe(ht.dialogContent, m),
          ...$,
          children: [
            /* @__PURE__ */ P(
              Ha,
              {
                asChild: n,
                className: oe(ht.dialogTitle, r),
                ...i,
                children: o
              }
            ),
            /* @__PURE__ */ P(
              id,
              {
                asChild: c,
                className: oe(ht.dialogDescription, s),
                ...l,
                children: a
              }
            ),
            /* @__PURE__ */ P(Ba, { asChild: !0, children: /* @__PURE__ */ P("div", { className: ht.dialogCloseWrapper, children: /* @__PURE__ */ P(
              "button",
              {
                className: oe(ht.dialogClose, d),
                ...h,
                children: u
              }
            ) }) })
          ]
        }
      )
    ] }) })
  ] });
}
export {
  gg as Accordion,
  $g as Banner,
  dg as Button,
  bg as Card,
  Eg as Carousel,
  tp as Checkbox,
  wg as CheckboxGroup,
  Di as DateField,
  Wa as Flyout,
  up as Heading,
  vg as Input,
  _g as Modal,
  hg as Popover
};
